webpackJsonp([0],Array(28).concat([
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, ".color_primary{color:#0057a5!important}.browsehappy{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}html{position:relative;min-height:100%}body{padding:0;margin-bottom:50px;font-size:14px;word-wrap:break-word}h2{color:#0057a5;font-size:1.5em;margin-bottom:30px;text-transform:uppercase}h2 .fa{font-size:.7em}h3{font-size:1.125em;color:#0057a5}.form-control{background-color:transparent;border:none;border-radius:0;box-shadow:none;color:rgba(0,0,0,.8);padding-left:10px;border-bottom:1px solid rgba(0,0,0,.4)}.form-control:focus{box-shadow:none;border-bottom:1px solid #0057a5}.form-control[readonly]{background-color:transparent}.has-error .form-control{box-shadow:none}.has-success *{color:inherit!important}.ng-cloak,[ng-cloak],[ng\\:cloak]{display:none!important}[data-ng-click],[ng-click],[ui-sref],[x-ng-click],a{cursor:pointer;color:#444}[data-ng-click]:active,[data-ng-click]:focus,[data-ng-click]:hover,[ng-click]:active,[ng-click]:focus,[ng-click]:hover,[ui-sref]:active,[ui-sref]:focus,[ui-sref]:hover,[x-ng-click]:active,[x-ng-click]:focus,[x-ng-click]:hover,a:active,a:focus,a:hover{text-decoration:none}[data-ng-click] .disabled,[ng-click] .disabled,[ui-sref] .disabled,[x-ng-click] .disabled,a .disabled{color:#eee}fieldset{margin-top:10px}fieldset legend{border-bottom:0;color:#0057a5;font-size:1em;margin-bottom:10px}dl{margin-bottom:0}dl dt{width:25%!important;line-height:1.6}dl.compact>dt,dl dt{text-align:left!important}dl.compact>dt{width:10%!important;line-height:1.4}table{border-spacing:0 3px;border-collapse:separate}table thead>tr>th{border-bottom:0!important;color:#e20a41;font-weight:400}table tbody{color:#444}table tbody tr td{padding:10px 8px;vertical-align:middle!important;word-break:break-all}table tbody tr td.actions,table tbody tr th.actions{background-color:#fff!important;border:0;width:1%;white-space:nowrap}table tbody .active>td{background-color:#0057a5!important;color:#fff}table.compact tbody>tr>td{padding-top:2px;padding-bottom:2px;vertical-align:middle}.table-striped>tbody tr:nth-child(odd)>td,.table-striped>tbody tr:nth-child(odd)>th{background-color:rgba(0,0,0,.1)}.table-striped>tbody tr:nth-child(2n)>td,.table-striped>tbody tr:nth-child(2n)>th{background-color:rgba(0,0,0,.2)}.container-fluid{padding:10px 80px}.navbar{margin-bottom:0;border:0;border-radius:0}.footer{background-color:#333;display:flex;justify-content:space-between}.footer .versioninfo{color:#969696;padding:15px}.footer .poweredby{color:#969696;font-size:14px;padding-right:10px}.footer .navbar-nav>li{float:left}.footer .navbar-nav>li>a{color:#eee;background-color:#333}.footer .navbar-nav>li>a:active,.footer .navbar-nav>li>a:focus,.footer .navbar-nav>li>a:hover{color:#aaa;background-color:#333}.navbar-subheader{text-align:center;border-top:none;background-color:rgba(0,0,0,.1)}.navbar-subheader .navbar-brand{height:61px;margin-left:0!important;padding:0}.navbar-subheader .navbar-nav{display:inline-block;float:none;margin-top:5px;vertical-align:top}.navbar-subheader .navbar-nav>li>a{color:rgba(0,0,0,.8);padding:15px 0}@media (min-width:1200px){.navbar-subheader .navbar-nav>li>a{font-size:1.5em}}@media (max-width:1199px){.navbar-subheader .navbar-nav>li>a{font-size:1.2em}}.navbar-subheader .navbar-nav>.open>a:active,.navbar-subheader .navbar-nav>.open>a:focus,.navbar-subheader .navbar-nav>.open>a:hover,.navbar-subheader .navbar-nav>li>a:active,.navbar-subheader .navbar-nav>li>a:focus,.navbar-subheader .navbar-nav>li>a:hover{color:rgba(0,0,0,.4);background-color:transparent}.navbar-subheader .navbar-nav>.open>a{color:rgba(0,0,0,.8);background-color:transparent}.navbar-subheader .navbar-nav>.active>a,.navbar-subheader .navbar-nav>.active>a:active,.navbar-subheader .navbar-nav>.active>a:focus,.navbar-subheader .navbar-nav>.active>a:hover{color:#0057a5;background-color:transparent}.navbar-subheader .navbar-collapse{text-align:center}.navbar-subheader .dropdown-menu{margin-top:20px!important;border:0;border-top:2px solid #e20a41;background-color:#efefef}.navbar-subheader .dropdown-menu>li>a:hover{background-color:transparent;color:#0057a5}@media (min-width:1200px){.navbar-subheader .center{margin-right:40px}}@media (max-width:1199px){.navbar-subheader .center>li{margin:auto 10px}}@media (min-width:1200px){.navbar-subheader .center>li{margin:auto 30px}}#banner{width:100%}#login{background-color:hsla(0,0%,100%,.7);position:absolute;top:0;right:0;height:100%;padding:0 130px 0 105px;max-width:469px}@media (max-width:1200px){#login{padding:0 50px 0 35px}}@media (max-width:992px){#login{position:relative}}#login h2{margin-bottom:40px;text-align:center}@media (max-width:1200px){#login h2{margin-bottom:5px}}#login .form-group{margin-bottom:20px}@media (max-width:1200px){#login .form-group{margin-bottom:5px}}#login input[type=checkbox]{display:none}#login input[type=checkbox]+label:before{font-family:FontAwesome;display:inline-block;width:19px;height:19px;content:\"\\F096\";color:#0057a5}#login input[type=checkbox]:checked+label:before{content:\"\\F046\"}#login .checkbox label{font-size:.875em;padding-left:0}.logout .fa-power-off{font-size:1.5em}#patientlist{height:260px;overflow:auto;margin-top:10px;clear:both}.tile{margin-bottom:20px;height:280px}.tile .scrollable-table-wrapper{height:245px;overflow-y:auto}.tile .scrollable-table-wrapper>table{margin-bottom:0}.tile .tab-content,.tile .tile-header{background-color:transparent}.tile .tab-content h4,.tile .tile-header h4{color:#666;font-size:1.125em;font-weight:700;line-height:2;margin:0}.tile .tab-content h5,.tile .tile-header h5{color:#666;font-size:1em;font-weight:700;line-height:2;margin:0}.tile .tile-body{background-color:rgba(0,0,0,.1);padding:10px;-webkit-box-shadow:5px 5px 2px 0 #a4a49a;-moz-box-shadow:5px 5px 2px 0 #a4a49a;box-shadow:5px 5px 2px 0 #a4a49a}.tile .tile-body .placeholder{margin-top:80px}.tile .tile-body td,.tile .tile-body th{border:none!important}.placeholder{color:#888;font-style:italic;text-align:center}.fa,.glyphicon{color:#0057a5;vertical-align:middle}tr.active .fa{color:#fff}tr.active td.actions .fa{color:#0057a5}tr.active td.actions .fa-circle-thinner:before{border:2px solid #0057a5}.fa-circle-thinner:before{width:1.8em;height:1.8em;text-align:center;border-radius:100%;border:2px solid #0057a5;display:flex;justify-content:center;align-items:center}tr.active .fa-circle-thinner:before{border:2px solid #fff}.btn{border-radius:0;border:0;padding:5px 12px}.btn:active{outline:none!important;background-color:rgba(0,0,0,.4)}.btn-primary{background-color:#0057a5;color:#fff}.btn-primary:active,.btn-primary:focus,.btn-primary:hover{background-color:#0072d8;color:#fff;outline:none}.btn-danger,.btn-emil{color:#fff}.btn-emil{background-color:#aaa}.btn-discard{background-color:rgba(0,0,0,.4);color:#fff}.btn-validate{background-color:#ccc;color:#666}.news h3{color:#888;margin-top:0;font-size:1.125em}.news>div{border-bottom:1px solid #bbb;padding-top:20px;padding-bottom:20px}.news div:last-child{border-bottom:0}.news .date{color:rgba(0,0,0,.4);font-size:1em}.news .content.accent{background-color:#eee;padding:20px}.news .content{padding:auto 20px}.news .content p{font-size:1em;margin-top:20px;text-align:justify;white-space:pre-wrap}.news .content .more{color:rgba(0,0,0,.4);font-size:.875em}#formview strong{color:#0057a5}#formview .control-label{background-color:#eee;width:100%;padding:2px}#formview fieldset{position:relative;padding:10px}#formview fieldset legend:hover{cursor:pointer}#formview fieldset legend i{width:15px}#formview fieldset label{padding-right:40px}#formview .popover-content{font-size:.9em}#formview .target-lesion-title>label{background:#a5d4ff}#formview .target-lesion-child{padding-left:25px}#patientSearch{white-space:nowrap}#patientSearch input{display:inline;width:177.6px}#patientDetails{margin-top:50px}.box{font:10px sans-serif}.box circle,.box line,.box rect{fill:#0057a5;stroke:#000;stroke-width:1px}.box .center{stroke-dasharray:3,3}.box .outlier{fill:none;stroke:#000}.axis{font:12px sans-serif}.axis .x path,.axis line,.axis path{fill:none;stroke:#000;shape-rendering:crispEdges}@media (min-width:992px){#home .stats{padding-left:50px}}#home .recent-patients{margin-bottom:20px}@media (min-width:992px){#home .recent-patients{padding-right:50px}}.has-error .transparent,.transparent{border:0;background-color:transparent}.modal-dialog.datepicker{width:350px}#medication td,#targetlesions td{vertical-align:top!important}#medication td ul,#targetlesions td ul{padding-left:0;margin-left:15px}.nav-tabs{border-bottom:0!important}.nav-tabs>li{margin-right:10px}.nav-tabs>li>a{background-color:rgba(0,0,0,.2);border-radius:0;-webkit-border-radius:0;-moz-border-radius:0}.nav-tabs>li>a:active,.nav-tabs>li>a:focus,.nav-tabs>li>a:hover{background-color:#e5e5e5}.nav-tabs>li.active>a,.nav-tabs>li.active>a:active,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{border-top:2px solid #e20a41;background-color:#e5e5e5}.tab-content{padding:10px;border-right:1px solid #ddd;border-left:1px solid #ddd;border-bottom:1px solid #ddd;background-color:#e5e5e5}.messages table{display:block;max-height:250px;overflow-y:auto}.messages table tr.read{color:#aaa}#impressum{white-space:pre-line}.ta-editor.form-control.editor-height,.ta-scroll-window.form-control.editor-height{height:300px;min-height:300px;overflow:auto;font-family:inherit;font-size:100%}.form-control.editor-height>.ta-bind{min-height:300px;padding:6px 12px}.form-control.editor-height>.ta-bind:focus{outline:none}.busy-loading-transparent .cg-busy-default-sign{background-color:transparent;border:0}.busy-loading .cg-busy-default-text{display:none}.busy-loading .cg-busy-default-sign{top:50%}#user-popover .dl-horizontal dt{width:auto!important}#user-popover .dl-horizontal dd{margin-left:10px}@media (min-width:768px){.modal-dialog{width:800px}}.modal-dialog .modal-body{max-height:70vh;overflow:auto}.has-error .help-block{color:#a94442!important}.popover{max-width:none}.padding-left-last-form-label>div>label:last-child{padding-left:10em}", ""]);

// exports


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, ".fade-in.ng-hide-remove{transition:opacity 1s linear;opacity:0}.fade-in.ng-hide-remove-active{opacity:1}", ""]);

// exports


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var User = function () {
  function User(username, roles, uuid, center, centerHull) {
    _classCallCheck(this, User);

    this._username = username;
    this._roles = roles || [];
    this._uuid = uuid;
    this._center = center || [];
    this._centerHull = centerHull || [];
    this._messages = 0;
  }

  _createClass(User, [{
    key: "isAdmin",
    value: function isAdmin() {
      return this._roles.indexOf("ROLE_ADMIN") > -1;
    }
  }, {
    key: "isCustodian",
    value: function isCustodian() {
      return this._roles.indexOf("ROLE_CUSTODIAN") > -1;
    }
  }, {
    key: "isMonitor",
    value: function isMonitor() {
      return this._roles.indexOf("ROLE_MONITOR") > -1;
    }
  }, {
    key: "isOfficer",
    value: function isOfficer() {
      return this._roles.indexOf("ROLE_OFFICER") > -1;
    }
  }, {
    key: "isAssistent",
    value: function isAssistent() {
      return this._roles.indexOf("ROLE_ASSISTENT") > -1;
    }
  }, {
    key: "hasPermission",


    /**
     * This function checks whether the user is permitted
     * to do certain things by comparing a 5 bit permission
     * string, e.g. 10010 where the first bit
     * represents the admin role, the second bit the monitor, third bit
     * the study officer, fourth bit the assistent role and the last bit
     * the custodian role. So 10010 means
     * this function can be used by admins and assistents.
     * @param perms the permission string
     */
    value: function hasPermission(perms) {
      var allowed = false;

      if (perms[0] === "1") {
        if (this.isAdmin()) {
          allowed = true;
        }
      }
      if (perms[1] === "1") {
        if (this.isMonitor()) {
          allowed = true;
        }
      }
      if (perms[2] === "1") {
        if (this.isOfficer()) {
          allowed = true;
        }
      }
      if (perms[3] === "1") {
        if (this.isAssistent()) {
          allowed = true;
        }
      }
      if (perms[4] === "1") {
        if (this.isCustodian()) {
          allowed = true;
        }
      }

      return allowed;
    }
  }, {
    key: "username",
    get: function get() {
      return this._username;
    },
    set: function set(username) {
      this._username = username;
    }
  }, {
    key: "uuid",
    get: function get() {
      return this._uuid;
    },
    set: function set(uuid) {
      this._uuid = uuid;
    }
  }, {
    key: "messages",
    get: function get() {
      return this._messages;
    },
    set: function set(count) {
      this._messages = count;
    }
  }, {
    key: "roles",
    get: function get() {
      return this._roles;
    }
  }, {
    key: "center",
    get: function get() {
      return this._center;
    }
  }, {
    key: "centerHull",
    get: function get() {
      return this._centerHull;
    }
  }], [{
    key: "build",


    // builds a user object from the server's principal object
    value: function build(data) {
      var roles = data.coreUser.authorities.map(function (item) {
        return item.authority;
      });

      return new User(data.coreUser.username, roles, data.uuid, data.center, data.centerHull);
    }
  }]);

  return User;
}();

exports.default = User;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint -W079 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(187);

__webpack_require__(193);

__webpack_require__(194);

__webpack_require__(201);

__webpack_require__(202);

__webpack_require__(203);

__webpack_require__(204);

__webpack_require__(205);

__webpack_require__(206);

__webpack_require__(207);

__webpack_require__(208);

var _angular = __webpack_require__(7);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(210);

var _jquery2 = _interopRequireDefault(_jquery);

var _angularjs = __webpack_require__(30);

var _angularjs2 = _interopRequireDefault(_angularjs);

__webpack_require__(233);

__webpack_require__(235);

__webpack_require__(237);

var _angularFileSaver = __webpack_require__(242);

var _angularFileSaver2 = _interopRequireDefault(_angularFileSaver);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(38);

var _angularUiNotification = __webpack_require__(243);

var _angularUiNotification2 = _interopRequireDefault(_angularUiNotification);

var _angularHttpAuthInterceptor = __webpack_require__(245);

var _angularHttpAuthInterceptor2 = _interopRequireDefault(_angularHttpAuthInterceptor);

var _textangular = __webpack_require__(247);

var _textangular2 = _interopRequireDefault(_textangular);

__webpack_require__(249);

var _angularBusy = __webpack_require__(250);

var _angularBusy2 = _interopRequireDefault(_angularBusy);

__webpack_require__(252);

__webpack_require__(253);

var _appConfig = __webpack_require__(255);

var _crudservice = __webpack_require__(256);

var _crudservice2 = _interopRequireDefault(_crudservice);

var _user = __webpack_require__(185);

var _user2 = _interopRequireDefault(_user);

var _authservice = __webpack_require__(257);

var _authservice2 = _interopRequireDefault(_authservice);

__webpack_require__(258);

__webpack_require__(286);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.$ = window.jQuery = _jquery2.default;

//import '../statistics/statistics.module';

__webpack_require__(332);

exports.default = _angular2.default.module('emilApp', ['emilSettings', 'emilPatients',
//'emilStatistics',
_angularFileSaver2.default, _angularjs2.default, 'ui.bootstrap', _angularUiNotification2.default, _angularHttpAuthInterceptor2.default, 'ui.bootstrap.datetimepicker', _textangular2.default, 'ui.validate', 'ui.dateTimeInput', 'ngAnimate', _angularBusy2.default]).config(['$stateProvider', '$httpProvider', '$urlRouterProvider', '$compileProvider', 'NotificationProvider', '$provide', '$qProvider', function ($stateProvider, $httpProvider, $urlRouterProvider, $compileProvider, NotificationProvider, $provide, $qProvider) {

  $stateProvider.state('main', {
    abstract: true,
    url: '/',
    template: '<ui-view/>',
    data: {
      proxy: 'main.home'
    }
  }).state('main.home', {
    url: '',
    template: __webpack_require__(345),
    data: {
      displayName: 'Start'
    }
  }).state('main.contact', {
    url: 'kontakt',
    component: 'contact',
    params: {
      'permission': '11111'
    },
    data: {
      displayName: 'Kontakt'
    }
  }).state('main.impressum', {
    url: 'impressum',
    template: '<h2>Impressum</h2><p ng-bind-html="impressum" id="impressum"></p>',
    controller: ['$scope', 'settings', function ($scope, settings) {
      $scope.impressum = settings.impressum;
    }],
    resolve: {
      settings: ['CRUDService', 'config', function (CRUDService, config) {
        return CRUDService.getAll(config.urls.settings);
      }]
    },
    data: {
      displayName: 'Impressum'
    }
  }).state('main.downloads', {
    url: 'downloads',
    template: __webpack_require__(346),
    data: {
      displayName: 'Downloads'
    }
  }).state('main.messages', {
    url: 'nachrichten',
    template: '<messages></messages>',
    params: {
      permission: '11111'
    },
    data: {
      displayName: 'Nachrichten'
    }
  }).state('main.messages.details', {
    url: '/:uuid',
    component: 'messageDetails',
    resolve: {
      'message': ['$stateParams', function ($stateParams) {
        return $stateParams.message;
      }]
    },
    bindings: {
      message: 'message'
    },
    params: {
      permission: '11111',
      message: undefined
    },
    data: {
      displayName: 'Details'
    }
  });

  $urlRouterProvider.otherwise('/');

  $httpProvider.interceptors.push('defaultInterceptor');

  $httpProvider.defaults.withCredentials = true;

  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|blob):/);

  $qProvider.errorOnUnhandledRejections(false);

  NotificationProvider.setOptions({
    positionX: 'center'
  });

  // configure textangular wysiwyg editor
  $provide.decorator('taOptions', ['$delegate', function (taOptions) {
    // $delegate is the taOptions we are decorating
    taOptions.toolbar = [['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'], ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'], ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'], ['insertLink']];
    taOptions.forceTextAngularSanitize = false;

    return taOptions;
  }]);
  $provide.decorator('taTranslations', ['$delegate', function ($delegate) {
    $delegate.heading.tooltip = 'Überschrift ';
    $delegate.pre.tooltip = 'Vorformatierter Text';
    $delegate.quote.tooltip = 'Zitat';
    $delegate.justifyLeft.tooltip = 'Linksbündig';
    $delegate.justifyCenter.tooltip = 'Zentriert';
    $delegate.justifyRight.tooltip = 'Rechtsbündig';
    $delegate.bold.tooltip = 'Fett';
    $delegate.italic.tooltip = 'Kursiv';
    $delegate.underline.tooltip = 'Unterstrichen';
    $delegate.strikeThrough.tooltip = 'Durchgestrichen';
    $delegate.ul.tooltip = 'Ungeordnete Liste';
    $delegate.ol.tooltip = 'Geordnete Liste';
    $delegate.indent.tooltip = 'Einzug erhöhen';
    $delegate.outdent.tooltip = 'Einzug verringern';
    $delegate.clear.tooltip = 'Formatierung entfernen';
    $delegate.undo.tooltip = 'Rückgängig';
    $delegate.redo.tooltip = 'Wiederholen';
    $delegate.insertLink.tooltip = 'Link einfügen';
    $delegate.insertLink.dialogPrompt = "Geben sie die Link-Adresse an:";
    return $delegate;
  }]);
}]).value('cgBusyDefaults', {
  message: 'Wird geladen.',
  backdrop: true,
  wrapperClass: 'busy-loading'
}).run(['$rootScope', '$location', '$transitions', '$trace', '$state', '$http', 'AuthService', 'Notification', '$templateCache', 'config', 'CRUDService', function ($rootScope, $location, $transitions, $trace, $state, $http, AuthService, Notification, $templateCache, config, CRUDService) {
  // disable ui-router tracing and error logging
  $trace.disable();
  $state.defaultErrorHandler(function () {});

  var reload = true;

  $transitions.onBefore({}, function (trans) {
    // restore user object after page refresh
    if (reload) {
      return $http.get('/api/users/current', { ignoreAuthModule: true }).then(function (response) {

        $rootScope.user = _user2.default.build(response.data);

        CRUDService.getAll(config.urls.messages + '/search/count').then(function (data) {
          $rootScope.user.messages = data;
        });

        // check given state permission
        var params = trans.params();
        if (params.hasOwnProperty('permission')) {
          if (!$rootScope.user || !$rootScope.user.hasPermission(params.permission)) {
            Notification.error('Sie sind nicht berechtigt die angeforderte Seite zu öffnen.');
            if ($rootScope.user) {
              return false;
            }
            trans.router.stateService.transitionTo('main.home');
            return true;
          }
        }
      }, function () {
        // session expired or something unexpected happened.. better get out of here
        if ($rootScope.user) {
          AuthService.logout();
        } else {
          trans.router.stateService.target('main.home', undefined, { location: true });
        }
      });
    } else {
      // check given state permission
      var params = trans.params();
      if (params.hasOwnProperty('permission')) {
        if (!$rootScope.user || !$rootScope.user.hasPermission(params.permission)) {
          Notification.error('Sie sind nicht berechtigt die angeforderte Seite zu öffnen.');
          if (!$rootScope.user) {
            trans.router.stateService.transitionTo('main.home');
            return true;
          }
          return false;
        }
      }
    }
  });

  $rootScope.$on('event:auth-loginRequired', function () {
    $rootScope.user = false;
    $state.go('main.home');
    Notification.error('Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.');
  });

  // overwrite the default datetimepicker template
  // the template is copied from views/datepicker.html but has to be directly put to the template cache
  $templateCache.put('templates/datetimepicker.html', '<div class="datetimepicker"><table class="table table-condensed {{ data.currentView }}-view"> <thead> <tr> <th class="left" data-ng-click="changeView(data.currentView, data.leftDate, $event)" data-ng-show="data.leftDate.selectable"><i class="glyphicon glyphicon-arrow-left"><span class="sr-only">{{ screenReader.previous }}</span></i> </th> <th class="switch" colspan="5" data-ng-show="data.previousViewDate.selectable" data-ng-click="changeView(data.previousView, data.previousViewDate, $event)">{{ data.previousViewDate.display }}</th> <th class="right" data-ng-click="changeView(data.currentView, data.rightDate, $event)" data-ng-show="data.rightDate.selectable"><i class="glyphicon glyphicon-arrow-right"><span class="sr-only">{{ screenReader.next }}</span></i> </th> </tr> <tr> <th class="dow" data-ng-repeat="day in data.dayNames">{{ day }}</th> </tr> </thead> <tbody> <tr data-ng-if="data.currentView !== \'day\'"> <td colspan="7"> <span class="{{ data.currentView }}" data-ng-repeat="dateObject in data.dates" data-ng-class="{current: dateObject.current, active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}" data-ng-click="changeView(data.nextView, dateObject, $event)">{{ dateObject.display }}</span></td> </tr> <tr data-ng-if="data.currentView === \'day\'" data-ng-repeat="week in data.weeks"> <td data-ng-repeat="dateObject in week.dates" data-ng-click="changeView(data.nextView, dateObject, $event)" class="day" data-ng-class="{current: dateObject.current, active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}">{{ dateObject.display }}</td> </tr> </tbody> </table></div> ');

  // set moment.js default locale
  _moment2.default.locale('de');

  // move static config object to root scope
  $rootScope.config = config;

  var pjson = __webpack_require__(347); //
  $rootScope.config.version = pjson.version;
}]).filter('orderObjectBy', function () {
  return function (items, field, reverse) {
    var filtered = [];
    _angular2.default.forEach(items, function (item) {
      filtered.push(item);
    });
    filtered.sort(function (a, b) {
      return a[field] > b[field] ? 1 : -1;
    });
    if (reverse) filtered.reverse();
    return filtered;
  };
}).constant('config', _appConfig.config)
/// Module loading
.component('emilButtonAdd', __webpack_require__(348)).component('emilButtonDelete', __webpack_require__(349)).component('emilButtonEdit', __webpack_require__(350)).component('emilDatepicker', __webpack_require__(351)).component('emilEditor', __webpack_require__(352)).component('emilHeader', __webpack_require__(353)).component('emilFooter', __webpack_require__(355)).component('login', __webpack_require__(357)).component('logout', __webpack_require__(359)).component('contact', __webpack_require__(360)).component('messages', __webpack_require__(362)).component('messageDetails', __webpack_require__(364)).component('news', __webpack_require__(365)).component('sessionTimeout', __webpack_require__(367)).directive('confirm', __webpack_require__(368)).directive('editorMaxlength', __webpack_require__(369)).directive('infiniteScroll', __webpack_require__(370)).directive('passwordValidator', __webpack_require__(371)).directive('breadcrumbs', __webpack_require__(372)).factory('defaultInterceptor', __webpack_require__(374)).service('User', [_user2.default]).service('AuthService', _authservice2.default).service('CRUDService', _crudservice2.default);

/***/ }),
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(28);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(true) {
	module.hot.accept(28, function() {
		var newContent = __webpack_require__(28);

		if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(29);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(true) {
	module.hot.accept(29, function() {
		var newContent = __webpack_require__(29);

		if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/images/swisspower-logo.small.png";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/images/gfl-logo.small.png";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/images/banner.png";

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html> <html ng-app=emilApp> <head> <meta charset=utf-8> <title>SwissPOWER</title> <meta name=description content=\"\"> <meta name=viewport content=\"width=device-width\"> <link rel=stylesheet href=https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css type=text/css /> <style>.ng-cloak,[ng-cloak],[ng\\:cloak]{display:none!important}</style> </head> <body class=ng-cloak ng-cloak> <!--[if lte IE 8]>\n      <p class=\"browsehappy\">You are using an <strong>outdated</strong> browser. Please <a href=\"http://browsehappy.com/\">upgrade your browser</a> to improve your experience.</p>\n    <![endif]--> <emil-header></emil-header> <breadcrumbs displayname-property=data.displayName abstract-proxy-property=data.proxy></breadcrumbs> <div class=container-fluid> <ui-view></ui-view> </div> <emil-footer></emil-footer> </body> </html> ";

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 66,
	"./af.js": 66,
	"./ar": 67,
	"./ar-dz": 68,
	"./ar-dz.js": 68,
	"./ar-kw": 69,
	"./ar-kw.js": 69,
	"./ar-ly": 70,
	"./ar-ly.js": 70,
	"./ar-ma": 71,
	"./ar-ma.js": 71,
	"./ar-sa": 72,
	"./ar-sa.js": 72,
	"./ar-tn": 73,
	"./ar-tn.js": 73,
	"./ar.js": 67,
	"./az": 74,
	"./az.js": 74,
	"./be": 75,
	"./be.js": 75,
	"./bg": 76,
	"./bg.js": 76,
	"./bm": 77,
	"./bm.js": 77,
	"./bn": 78,
	"./bn.js": 78,
	"./bo": 79,
	"./bo.js": 79,
	"./br": 80,
	"./br.js": 80,
	"./bs": 81,
	"./bs.js": 81,
	"./ca": 82,
	"./ca.js": 82,
	"./cs": 83,
	"./cs.js": 83,
	"./cv": 84,
	"./cv.js": 84,
	"./cy": 85,
	"./cy.js": 85,
	"./da": 86,
	"./da.js": 86,
	"./de": 38,
	"./de-at": 87,
	"./de-at.js": 87,
	"./de-ch": 88,
	"./de-ch.js": 88,
	"./de.js": 38,
	"./dv": 89,
	"./dv.js": 89,
	"./el": 90,
	"./el.js": 90,
	"./en-au": 91,
	"./en-au.js": 91,
	"./en-ca": 92,
	"./en-ca.js": 92,
	"./en-gb": 93,
	"./en-gb.js": 93,
	"./en-ie": 94,
	"./en-ie.js": 94,
	"./en-nz": 95,
	"./en-nz.js": 95,
	"./eo": 96,
	"./eo.js": 96,
	"./es": 97,
	"./es-do": 98,
	"./es-do.js": 98,
	"./es-us": 99,
	"./es-us.js": 99,
	"./es.js": 97,
	"./et": 100,
	"./et.js": 100,
	"./eu": 101,
	"./eu.js": 101,
	"./fa": 102,
	"./fa.js": 102,
	"./fi": 103,
	"./fi.js": 103,
	"./fo": 104,
	"./fo.js": 104,
	"./fr": 105,
	"./fr-ca": 106,
	"./fr-ca.js": 106,
	"./fr-ch": 107,
	"./fr-ch.js": 107,
	"./fr.js": 105,
	"./fy": 108,
	"./fy.js": 108,
	"./gd": 109,
	"./gd.js": 109,
	"./gl": 110,
	"./gl.js": 110,
	"./gom-latn": 111,
	"./gom-latn.js": 111,
	"./gu": 112,
	"./gu.js": 112,
	"./he": 113,
	"./he.js": 113,
	"./hi": 114,
	"./hi.js": 114,
	"./hr": 115,
	"./hr.js": 115,
	"./hu": 116,
	"./hu.js": 116,
	"./hy-am": 117,
	"./hy-am.js": 117,
	"./id": 118,
	"./id.js": 118,
	"./is": 119,
	"./is.js": 119,
	"./it": 120,
	"./it.js": 120,
	"./ja": 121,
	"./ja.js": 121,
	"./jv": 122,
	"./jv.js": 122,
	"./ka": 123,
	"./ka.js": 123,
	"./kk": 124,
	"./kk.js": 124,
	"./km": 125,
	"./km.js": 125,
	"./kn": 126,
	"./kn.js": 126,
	"./ko": 127,
	"./ko.js": 127,
	"./ky": 128,
	"./ky.js": 128,
	"./lb": 129,
	"./lb.js": 129,
	"./lo": 130,
	"./lo.js": 130,
	"./lt": 131,
	"./lt.js": 131,
	"./lv": 132,
	"./lv.js": 132,
	"./me": 133,
	"./me.js": 133,
	"./mi": 134,
	"./mi.js": 134,
	"./mk": 135,
	"./mk.js": 135,
	"./ml": 136,
	"./ml.js": 136,
	"./mr": 137,
	"./mr.js": 137,
	"./ms": 138,
	"./ms-my": 139,
	"./ms-my.js": 139,
	"./ms.js": 138,
	"./mt": 140,
	"./mt.js": 140,
	"./my": 141,
	"./my.js": 141,
	"./nb": 142,
	"./nb.js": 142,
	"./ne": 143,
	"./ne.js": 143,
	"./nl": 144,
	"./nl-be": 145,
	"./nl-be.js": 145,
	"./nl.js": 144,
	"./nn": 146,
	"./nn.js": 146,
	"./pa-in": 147,
	"./pa-in.js": 147,
	"./pl": 148,
	"./pl.js": 148,
	"./pt": 149,
	"./pt-br": 150,
	"./pt-br.js": 150,
	"./pt.js": 149,
	"./ro": 151,
	"./ro.js": 151,
	"./ru": 152,
	"./ru.js": 152,
	"./sd": 153,
	"./sd.js": 153,
	"./se": 154,
	"./se.js": 154,
	"./si": 155,
	"./si.js": 155,
	"./sk": 156,
	"./sk.js": 156,
	"./sl": 157,
	"./sl.js": 157,
	"./sq": 158,
	"./sq.js": 158,
	"./sr": 159,
	"./sr-cyrl": 160,
	"./sr-cyrl.js": 160,
	"./sr.js": 159,
	"./ss": 161,
	"./ss.js": 161,
	"./sv": 162,
	"./sv.js": 162,
	"./sw": 163,
	"./sw.js": 163,
	"./ta": 164,
	"./ta.js": 164,
	"./te": 165,
	"./te.js": 165,
	"./tet": 166,
	"./tet.js": 166,
	"./th": 167,
	"./th.js": 167,
	"./tl-ph": 168,
	"./tl-ph.js": 168,
	"./tlh": 169,
	"./tlh.js": 169,
	"./tr": 170,
	"./tr.js": 170,
	"./tzl": 171,
	"./tzl.js": 171,
	"./tzm": 172,
	"./tzm-latn": 173,
	"./tzm-latn.js": 173,
	"./tzm.js": 172,
	"./uk": 174,
	"./uk.js": 174,
	"./ur": 175,
	"./ur.js": 175,
	"./uz": 176,
	"./uz-latn": 177,
	"./uz-latn.js": 177,
	"./uz.js": 176,
	"./vi": 178,
	"./vi.js": 178,
	"./x-pseudo": 179,
	"./x-pseudo.js": 179,
	"./yo": 180,
	"./yo.js": 180,
	"./zh-cn": 181,
	"./zh-cn.js": 181,
	"./zh-hk": 182,
	"./zh-hk.js": 182,
	"./zh-tw": 183,
	"./zh-tw.js": 183
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;

/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var opsCodes = {
  "8-836.0**": "Angioplastie",
  "8-83b.ba": "Ein medikamentenfreisetzender Ballon an anderen Gefäßen",
  "8-83b.bb": "Zwei medikamentenfreisetzende Ballons an anderen Gefäßen",
  "8-83b.bc": "Drei medikamentenfreisetzende Ballons an anderen Gefäßen",
  "8-83b.bd": "Vier oder mehr medikamentenfreisetzende Ballons an anderen Gefäßen",
  "8-836.1**": "Scoring- oder Cutting-Ballon",
  "8-836.2**": "Laser-Angioplastie",
  "8-836.3**": "Atherektomie",
  "8-836.w**": "Atherektomie unter peripherem Embolieschutz ",
  "8-840.0**": "Ein Stent",
  "8-840.1**": "Zwei Stents",
  "8-840.2**": "Drei Stents",
  "8-840.3**": "Vier Stents",
  "8-840.4**": "Fünf Stents",
  "8-840.5**": "Sechs oder mehr Stents",
  "8-841.0**": "Ein Stent",
  "8-841.1**": "Zwei Stents",
  "8-841.2**": "Drei Stents",
  "8-841.3**": "Vier Stents",
  "8-841.4**": "Fünf Stents",
  "8-841.5**": "Sechs oder mehr Stents",
  "8-842.0**": "Ein Stent",
  "8-842.1**": "Zwei Stents",
  "8-842.2**": "Drei Stents",
  "8-842.3**": "Vier Stents",
  "8-842.4**": "Fünf Stents",
  "8-842.5**": "Sechs oder mehr Stents",
  "8-843.0**": "Ein Stent",
  "8-843.1**": "Zwei Stents",
  "8-843.2**": "Drei Stents",
  "8-843.3**": "Vier Stents",
  "8-843.4**": "Fünf Stents",
  "8-843.5**": "Sechs oder mehr Stents",
  "8-848.0**": "Ein Stent",
  "8-848.1**": "Zwei Stents",
  "8-848.2**": "Drei Stents",
  "8-848.3**": "Vier Stents",
  "8-848.4**": "Fünf Stents",
  "8-848.5**": "Sechs oder mehr Stents",
  "8-83b.f1": "100 mm bis unter 150 mm",
  "8-83b.f2": "150 mm bis unter 200 mm",
  "8-83b.f3": "200 mm bis unter 250 mm",
  "8-83b.f4": "250 mm oder mehr",
  "8-836.7**": "Selektive Thrombolyse",
  "8-83b.j": "Verwendung eines ultraschallgestützten Thrombolysesystems",
  "8-836.8**": "Thrombektomie",
  "8-836.p**": "Rotationsthrombektomie",
  "8-83b.4": "Verwendung eines hydrodynamischen Thrombektomiesystems",
  "8-83c.70": "1 Gefäß",
  "8-83c.71": "2 Gefäße",
  "8-83c.72": "3 oder mehr Gefäße",
  "8-83b.9": "Einsatz eines Embolieprotektionssystems",
  "8-83b.a": "Verwendung von Rekanalisationssystemen",
  "8-83b.a0": "System zur Mikro-Dissektion",
  "8-83b.a1": "Spezielles Nadelsystem zur subintimalen Rekanalisation",
  "8-83b.a2": "Mechanisches Radiofrequenz-System",
  "8-83b.ax": "Sonstige",
  "8-83b.c": "Verwendung eines Gefäßverschlusssystems",
  "8-83b.c2": "Nahtsystem",
  "8-83b.c3": "Clipsystem",
  "8-83b.c4": "Polymerdichtung mit äußerer Sperrscheibe",
  "8-83b.c5": "Resorbierbare Plugs ohne Anker",
  "8-83b.c6": "Resorbierbare Plugs mit Anker",
  "8-83b.03": "Paclitaxel-freisetzende Stents ohne Polymer",
  "8-83b.05": "Paclitaxel-freisetzende Stents mit biologisch abbaubarer Polymerbeschichtung",
  "8-83b.06": "Paclitaxel-freisetzende Stents mit sonstigem Polymer",
  "8-83b.07": "Sirolimus-freisetzende Stents ohne Polymer",
  "8-83b.08": "Sirolimus-freisetzende Stents mit Polymer",
  "8-83b.09": "Tacrolimus-freisetzende Stents",
  "8-83b.0b": "Everolimus-freisetzende Stents mit biologisch abbaubarer Polymerbeschichtung",
  "8-83b.0c": "Everolimus-freisetzende Stents mit sonstigem Polymer"
},
    opsRegionen = {
  'Aorta': { '8-836.0**': '04', 'default': '4' },
  'Andere Gefäße thorakal': { '8-836.0**': '08', 'default': '8' },
  'Andere Gefäße abdominal und pelvin': { '8-836.0**': '0q', '8-836.1**': 'h', '8-836.2**': 'h', '8-836.3**': 'h', '8-836.w**': 'h', '8-836.7**': 'h', '8-836.8**': 'h', '8-836.p**': 'h', 'default': 'q' },
  'Gefäße viszeral': { '8-836.0**': '0a', 'default': 'a' },
  'Gefäße Oberschenkel – femoral': { '8-836.0**': '0s', '8-836.1**': 'k', '8-836.2**': 'k', '8-836.3**': 'k', '8-836.w**': 'k', '8-836.7**': 'k', '8-836.8**': 'k', '8-836.p**': 'k', 'default': 's' },
  'Gefäße Oberschenkel - popliteal': { '8-836.0**': '0s', '8-836.1**': 'k', '8-836.2**': 'k', '8-836.3**': 'k', '8-836.w**': 'k', '8-836.7**': 'k', '8-836.8**': 'k', '8-836.p**': 'k', 'default': 's' },
  'Gefäße Unterschenkel': { '8-836.0**': '0c', 'default': 'c' },
  'Künstliche Gefäße': { '8-836.0**': '0e', 'default': 'e' },
  'Sonstige': { '8-836.0**': '0x', 'default': 'x' }
};

var config = exports.config = {
  'urls': {
    'news': '/api/news?projection=default',
    'center': '/api/center?projection=default',
    'networks': '/api/networks',
    'protocol': '/api/logging',
    'patients': '/api/patients',
    'users': '/api/users',
    'targetlesions': '/api/targetlesions',
    //'statistics': '/api/statistics',
    'messages': '/api/messages',
    'settings': '/api/settings/search/global',
    'contact': '/api/contact'
  },
  'labels': {
    "ARTERIAL": "arteriell",
    "FOLLOWUP": "Follow-Up",
    "INTERVENTION": "Intervention",
    "ANAMNESIS": "Ersterfassung",
    "POSTINTERVATIONELLENACHKONTROLLE": "Postinterventionelle Nachkontrolle",
    "TAKING": "Einnahme",
    "NO_TAKING": "Keine Einnahme",
    "UNKNOWN": "Unbekannt",
    "aspirin": "Aspirin",
    "antipsychotica": "Antipsychotica",
    "antihypertensiva": "Antihypertensiva",
    "antidepressiva": "Antidepressiva",
    "antiandrogene": "Antiandrogene",
    "antihistaminika": "Antihistaminika",
    "pde_5_i": "PDE-5-I",
    "plavix": "Plavix",
    "oak": "OAK",
    "andere": "Andere Medikation",
    "ACCEPTED": "Angenommen",
    "DECLINED": "Abgelehnt",
    "OPEN": "Offen"
  },
  'icdCodes': {
    "I70.8": "I70.8 Atherosklerose sonstiger Arterien"
  },
  'opsCodes': opsCodes,
  'opsRegionen': opsRegionen,
  'opsWizardSchema': {
    "title": "OPS-Wizard",
    "type": "object",
    "properties": {
      "angioplastie": {
        "type": "string",
        "title": "Angioplastie",
        "enum": ["8-836.0**", "8-83b.ba", "8-83b.bb", "8-83b.bc", "8-83b.bd"],
        "x-schema-form": {
          "type": "radios",
          "titleMap": [{ "value": "8-836.0**", "name": opsCodes["8-836.0**"] }, { "value": "8-83b.ba", "name": opsCodes["8-83b.ba"] }, { "value": "8-83b.bb", "name": opsCodes["8-83b.bb"] }, { "value": "8-83b.bc", "name": opsCodes["8-83b.bc"] }, { "value": "8-83b.bd", "name": opsCodes["8-83b.bd"] }]
        }
      },
      "scoring_ballon": {
        "title": "Scoring- oder Cutting-Ballon",
        "type": "string",
        "enum": ["8-836.1**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [{ "value": "8-836.1**", "name": opsCodes["8-836.1**"] }]
        }
      },
      "laser_angio": {
        "title": "Laser-Angioplastie",
        "type": "string",
        "enum": ["8-836.2**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [{ "value": "8-836.2**", "name": opsCodes["8-836.2**"] }]
        }
      },
      "atherektomie": {
        "title": "Atherektomie",
        "type": "string",
        "enum": ["8-836.3**", "8-836.w**"],
        "x-schema-form": {
          "type": "radios",
          "titleMap": [{ "value": "8-836.3**", "name": opsCodes["8-836.3**"] }, { "value": "8-836.w**", "name": opsCodes["8-836.w**"] }]
        }
      },
      "nicht_medfrei_stents": {
        "type": "string",
        "title": "Implantation von nicht medikamentenfreisetzenden Stents",
        "enum": ["8-840.0**", "8-840.1**", "8-840.2**", "8-840.3**", "8-840.4**", "8-840.5**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [{ "value": "8-840.0**", "name": opsCodes["8-840.0**"] }, { "value": "8-840.1**", "name": opsCodes["8-840.1**"] }, { "value": "8-840.2**", "name": opsCodes["8-840.2**"] }, { "value": "8-840.3**", "name": opsCodes["8-840.3**"] }, { "value": "8-840.4**", "name": opsCodes["8-840.4**"] }, { "value": "8-840.5**", "name": opsCodes["8-840.5**"] }]
        }
      },
      "medfrei_stents": {
        "type": "string",
        "title": "Implantation von medikamentenfreisetzenden Stents",
        "enum": ["8-841.0**", "8-841.1**", "8-841.2**", "8-841.3**", "8-841.4**", "8-841.5**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [{ "value": "8-841.0**", "name": opsCodes["8-841.0**"] }, { "value": "8-841.1**", "name": opsCodes["8-841.1**"] }, { "value": "8-841.2**", "name": opsCodes["8-841.2**"] }, { "value": "8-841.3**", "name": opsCodes["8-841.3**"] }, { "value": "8-841.4**", "name": opsCodes["8-841.4**"] }, { "value": "8-841.5**", "name": opsCodes["8-841.5**"] }]
        }
      },
      "medfrei_art": {
        "title": "Art des freigesetzten Medikaments",
        "type": "string",
        "enum": ["8-83b.03", "8-83b.05", "8-83b.06", "8-83b.07", "8-83b.08", "8-83b.09", "8-83b.0b", "8-83b.0c"],
        "x-schema-form": {
          "type": "radios",
          "titleMap": [{ "value": "8-83b.03", "name": opsCodes["8-83b.03"] }, { "value": "8-83b.05", "name": opsCodes["8-83b.05"] }, { "value": "8-83b.06", "name": opsCodes["8-83b.06"] }, { "value": "8-83b.07", "name": opsCodes["8-83b.07"] }, { "value": "8-83b.08", "name": opsCodes["8-83b.08"] }, { "value": "8-83b.09", "name": opsCodes["8-83b.09"] }, { "value": "8-83b.0b", "name": opsCodes["8-83b.0b"] }, { "value": "8-83b.0c", "name": opsCodes["8-83b.0c"] }]
        }
      },
      "nicht_medfrei_stents_graft": {
        "type": "string",
        "title": "Implantation von nicht medikamentenfreisetzenden gecoverten Stents (Stent-Graft)",
        "enum": ["8-842.0**", "8-842.1**", "8-842.2**", "8-842.3**", "8-842.4**", "8-842.5**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [{ "value": "8-842.0**", "name": opsCodes["8-842.0**"] }, { "value": "8-842.1**", "name": opsCodes["8-842.1**"] }, { "value": "8-842.2**", "name": opsCodes["8-842.2**"] }, { "value": "8-842.3**", "name": opsCodes["8-842.3**"] }, { "value": "8-842.4**", "name": opsCodes["8-842.4**"] }, { "value": "8-842.5**", "name": opsCodes["8-842.5**"] }]
        }
      },
      "biores_stents": {
        "type": "string",
        "title": "Implantation von bioresorbierbaren Stents",
        "enum": ["8-843.0**", "8-843.1**", "8-843.2**", "8-843.3**", "8-843.4**", "8-843.5**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [{ "value": "8-843.0**", "name": opsCodes["8-843.0**"] }, { "value": "8-843.1**", "name": opsCodes["8-843.1**"] }, { "value": "8-843.2**", "name": opsCodes["8-843.2**"] }, { "value": "8-843.3**", "name": opsCodes["8-843.3**"] }, { "value": "8-843.4**", "name": opsCodes["8-843.4**"] }, { "value": "8-843.5**", "name": opsCodes["8-843.5**"] }]
        }
      },
      "medfrei_stents_graft": {
        "type": "string",
        "title": "Implantation von medikamentenfreisetzenden gecoverten Stents (Stent-Graft)",
        "enum": ["8-848.0**", "8-848.1**", "8-848.2**", "8-848.3**", "8-848.4**", "8-848.5**"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [{ "value": "8-848.0**", "name": opsCodes["8-848.0**"] }, { "value": "8-848.1**", "name": opsCodes["8-848.1**"] }, { "value": "8-848.2**", "name": opsCodes["8-848.2**"] }, { "value": "8-848.3**", "name": opsCodes["8-848.3**"] }, { "value": "8-848.4**", "name": opsCodes["8-848.4**"] }, { "value": "8-848.5**", "name": opsCodes["8-848.5**"] }]
        }
      },
      "laenge_periphere_stents": {
        "type": "string",
        "title": "Länge der peripheren Stents",
        "enum": ["8-83b.f1", "8-83b.f2", "8-83b.f3", "8-83b.f4"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [{ "value": "8-83b.f1", "name": opsCodes["8-83b.f1"] }, { "value": "8-83b.f2", "name": opsCodes["8-83b.f2"] }, { "value": "8-83b.f3", "name": opsCodes["8-83b.f3"] }, { "value": "8-83b.f4", "name": opsCodes["8-83b.f4"] }]
        }
      },
      "thrombolyse": {
        "type": "string",
        "title": "Thrombolyse",
        "enum": ["8-836.7**", "8-83b.j"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [{ "value": "8-836.7**", "name": opsCodes["8-836.7**"] }, { "value": "8-83b.j", "name": opsCodes["8-83b.j"] }]
        }
      },
      "thrombektomie": {
        "type": "string",
        "title": "Thrombektomie",
        "enum": ["8-836.8**", "8-836.p**", "8-83b.4"],
        "x-schema-form": {
          "type": "radios",
          "titleMap": [{ "value": "8-836.8**", "name": opsCodes["8-836.8**"] }, { "value": "8-836.p**", "name": opsCodes["8-836.p**"] }, { "value": "8-83b.4", "name": opsCodes["8-83b.4"] }]
        }
      },
      "spasmolyse": {
        "type": "string",
        "title": "Intraarterielle Spasmolyse",
        "enum": ["8-83c.70", "8-83c.71", "8-83c.72"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [{ "value": "8-83c.70", "name": opsCodes["8-83c.70"] }, { "value": "8-83c.71", "name": opsCodes["8-83c.71"] }, { "value": "8-83c.72", "name": opsCodes["8-83c.72"] }]
        }
      },
      "embolie_protekt": {
        "type": "string",
        "title": "Einsatz eines Embolieprotektionssystems",
        "enum": ["8-83b.9"],
        "x-schema-form": {
          "type": "radios-inline",
          "titleMap": [{ "value": "8-83b.9", "name": opsCodes["8-83b.9"] }],
          "condition": "model.atherektomie !== '8-836.w**'"
        }
      },
      "rekanalisationssystem": {
        "type": "string",
        "title": "Rekanalisationssysteme",
        "enum": ["8-83b.a", "8-83b.a0", "8-83b.a1", "8-83b.a2", "8-83b.ax"],
        "x-schema-form": {
          "type": "radios",
          "titleMap": [{ "value": "8-83b.a", "name": opsCodes["8-83b.a"] }, { "value": "8-83b.a0", "name": opsCodes["8-83b.a0"] }, { "value": "8-83b.a1", "name": opsCodes["8-83b.a1"] }, { "value": "8-83b.a2", "name": opsCodes["8-83b.a2"] }, { "value": "8-83b.ax", "name": opsCodes["8-83b.ax"] }]
        }
      },
      "verschlusssystem": {
        "type": "string",
        "title": "Gefäßverschlusssysteme",
        "enum": ["8-83b.c", "8-83b.c2", "8-83b.c3", "8-83b.c4", "8-83b.c5", "8-83b.c6"],
        "x-schema-form": {
          "type": "radios",
          "titleMap": [{ "value": "8-83b.c", "name": opsCodes["8-83b.c"] }, { "value": "8-83b.c2", "name": opsCodes["8-83b.c2"] }, { "value": "8-83b.c3", "name": opsCodes["8-83b.c3"] }, { "value": "8-83b.c4", "name": opsCodes["8-83b.c4"] }, { "value": "8-83b.c5", "name": opsCodes["8-83b.c5"] }, { "value": "8-83b.c6", "name": opsCodes["8-83b.c6"] }]
        }
      }
    }
  }
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CrudService = function () {
  function CrudService($http, $q) {
    _classCallCheck(this, CrudService);

    this.$http = $http;
    this.$q = $q;
  }

  _createClass(CrudService, [{
    key: 'getAll',
    value: function getAll(uri, page, sort) {
      var deferred = this.$q.defer();

      this.$http.get(uri, { params: { page: page, sort: sort } }).then(function (response) {
        if (response.status === 200) {
          deferred.resolve(response.data);
        } else {
          deferred.reject();
        }
      }, function () {
        deferred.reject();
      });

      return deferred.promise;
    }
  }, {
    key: 'remove',
    value: function remove(uri) {
      return this.$http.delete(uri);
    }
  }, {
    key: 'save',
    value: function save(item, uri) {
      if (item._links) {
        // update item
        return this.$http.put(item._links.self.href, item);
      } else {
        // save new item
        return this.$http.post(uri, item);
      }
    }
  }]);

  return CrudService;
}();

CrudService.$inject = ['$http', '$q'];
exports.default = CrudService;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _user = __webpack_require__(185);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthService = function () {
  function AuthService($http, $q, $rootScope) {
    _classCallCheck(this, AuthService);

    this.$http = $http;
    this.$q = $q;
    this.$rootScope = $rootScope;
  }

  _createClass(AuthService, [{
    key: 'isLoggedIn',
    value: function isLoggedIn() {
      if (this.$rootScope.user) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'login',
    value: function login(id, password, remember) {
      var deferred = this.$q.defer();
      var data = {
        'username': id,
        'password': password,
        'remember-me': remember
      };

      var self = this;
      this.$http.post('/login', jQuery.param(data), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        ignoreAuthModule: true
      }).then(function (data) {
        var that = self;
        if (data.status === 200) {
          self.$http.get('/api/users/current').then(function (response) {
            that.$rootScope.user = _user2.default.build(response.data);
            that.$rootScope.user.remember = remember;
            deferred.resolve(response);
          });
        } else {
          that.$rootScope.user = false;
          deferred.reject(data);
        }
      }, function (data) {
        self.$rootScope.user = false;
        deferred.reject(data);
      });

      return deferred.promise;
    }
  }, {
    key: 'logout',
    value: function logout() {
      var deferred = this.$q.defer();

      var self = this;
      this.$http.post('/logout', { ignoreAuthModule: true }).then(function () {
        self.$rootScope.user = false;
        deferred.resolve();
      }, function () {
        self.$rootScope.user = false;
        deferred.reject();
      });

      // return promise object
      return deferred.promise;
    }
  }]);

  return AuthService;
}();

AuthService.$inject = ['$http', '$q', '$rootScope'];
exports.default = AuthService;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(30);

var _angularjs2 = _interopRequireDefault(_angularjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('emilSettings', [_angularjs2.default]).config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('main.settings', {
    abstract: true,
    url: 'verwaltung',
    template: '<h2>Verwaltung</h2><ui-view/>',
    data: {
      displayName: 'Verwaltung'
    }
  }).state('main.settings.profile', {
    url: '/profil',
    component: 'settingsProfile',
    params: {
      permission: '11111'
    },
    data: {
      displayName: 'Profil'
    }
  }).state('main.settings.news', {
    url: '/neuigkeiten',
    component: 'settingsNews',
    params: {
      permission: '10000'
    },
    data: {
      displayName: 'Neuigkeiten'
    }
  }).state('main.settings.news-add', {
    url: '/neuigkeiten',
    component: 'formNews',
    params: {
      item: undefined,
      permission: '10000'
    },
    data: {
      displayName: 'Neuigkeit hinzufügen'
    }
  }).state('main.settings.user', {
    url: '/nutzer',
    component: 'settingsUsers',
    params: {
      permission: '10000'
    },
    data: {
      displayName: 'Nutzer'
    }
  }).state('main.settings.user-add', {
    url: '/nutzer',
    controller: 'UserCtrl',
    template: __webpack_require__(259),
    params: {
      permission: '10000'
    },
    data: {
      displayName: 'Nutzer hinzufügen'
    }
  }).state('main.settings.user-edit', {
    url: '/nutzer',
    controller: 'UserCtrl',
    template: __webpack_require__(260),
    params: {
      item: undefined,
      permission: '10000'
    },
    data: {
      displayName: 'Nutzer bearbeiten'
    }
  }).state('main.settings.center', {
    url: '/zentren',
    component: 'settingsCenter',
    params: {
      permission: '10000'
    },
    data: {
      displayName: 'Zentren'
    }
  }).state('main.settings.center-add', {
    url: '/zentren',
    component: 'formCenter',
    params: {
      item: undefined,
      permission: '10000'
    },
    data: {
      displayName: 'Zentren hinzufügen'
    }
  }).state('main.settings.protocol', {
    url: '/protokoll',
    component: 'protocol',
    params: {
      permission: '10000'
    },
    data: {
      displayName: 'Protokoll'
    }
  }).state('main.settings.network', {
    url: '/verbunde',
    component: 'settingsNetwork',
    params: {
      permission: '10000'
    },
    data: {
      displayName: 'Zentrumsverbund'
    }
  }).state('main.settings.network-add', {
    url: '/verbunde/neu',
    component: 'formNetwork',
    params: {
      item: undefined,
      permission: '10000'
    },
    data: {
      displayName: 'Zentrumsverbund erstellen'
    }
  }).state('main.settings.options', {
    url: '/optionen',
    displayName: 'Optionen',
    component: 'settings',
    params: {
      permission: '10000'
    },
    data: {
      displayName: 'Optionen'
    }
  }).state('main.settings.deletionrequests', {
    url: '/loeschantraege',
    component: 'deletionRequests',
    params: {
      permission: '11111'
    },
    data: {
      displayName: 'Löschanträge'
    }
  }).state('main.settings.export', {
    url: '/export',
    component: 'settingsExport',
    params: {
      permission: '01101'
    },
    data: {
      displayName: 'Export'
    }
  });
}]).component('deletionRequests', __webpack_require__(261)).component('formCenter', __webpack_require__(263)).component('formNetwork', __webpack_require__(265)).component('formNews', __webpack_require__(267)).component('protocol', __webpack_require__(269)).component('settings', __webpack_require__(271)).component('settingsCenter', __webpack_require__(273)).component('settingsNetwork', __webpack_require__(275)).component('settingsNews', __webpack_require__(277)).component('settingsProfile', __webpack_require__(279)).component('settingsUsers', __webpack_require__(281)).component('settingsExport', __webpack_require__(283)).controller('UserCtrl', __webpack_require__(285));

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = "<h3>neuen Nutzer hinzufügen</h3> <form class=form name=form novalidate> <div class=form-group ng-class=\"{ 'has-error' : form.username.$invalid && form.$submitted}\"> <label>Nutzername</label> <input type=text class=form-control ng-model=model.username name=username required=required minlength=5 maxlength=255> <p ng-show=\"form.username.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.username.$error.minlength && form.$submitted\" class=help-block>Unterschrittene Mindestlänge von 5 Zeichen.</p> </div> <div class=row> <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : form.password.$invalid && form.$submitted}\"> <label>Passwort</label> <p class=help-block>Mindestlänge: 8 Zeichen. Muss sowohl Buchstaben, als auch Zahlen enthalten.</p> <input type=password class=form-control ng-model=model.password id=password name=password ng-required=changePw minlength=8 maxlength=255 password-validator> <p ng-show=\"form.password.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.password.$error.minlength && form.$submitted\" class=help-block>Unterschrittene Mindestlänge von 8 Zeichen.</p> <p ng-show=\"form.password.$error.passwordVerify && form.$submitted\" class=help-block>Schwaches Passwort. Das angegebene Passwort muss mindestens aus acht Zeichen bestehen und sowohl Buchstaben, als auch Zahlen enthalten.</p> </div> <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : form.password2.$invalid && form.$submitted}\"> <label>Passwort wiederholen</label> <p class=help-block>&nbsp;</p> <input type=password class=form-control ng-model=password2 ui-validate=\" '$value==model.password' \" ui-validate-watch=\" 'model.password' \" name=password2 ng-required=changePw minlength=8 maxlength=255> <p ng-show=\"form.password2.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.password2.$error.minlength && form.$submitted\" class=help-block>Unterschrittene Mindestlänge von 8 Zeichen.</p> <p ng-show=\"form.password2.$error.validator && form.$submitted\" class=help-block>Die angegebenen Passwörter stimmen nicht überein.</p> </div> </div> <div class=form-group ng-class=\"{ 'has-error' : form.role.$invalid && form.$submitted}\"> <label>Rolle</label> <select class=form-control name=role ng-model=model.roles[0] ng-options=\"role.id as role.label for role in roles\" required=required> </select> <p ng-show=\"form.role.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> <div class=row> <div class=\"form-group col-sm-2\" ng-class=\"{ 'has-error' : form.title.$invalid && form.$submitted}\"> <label>Titel</label> <input type=text class=form-control ng-model=model.title name=title maxlength=255> <p ng-show=\"form.title.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=\"form-group col-sm-5\" ng-class=\"{ 'has-error' : form.prename.$invalid && form.$submitted}\"> <label>Vorname</label> <input type=text class=form-control ng-model=model.prename name=prename maxlength=255> <p ng-show=\"form.prename.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=\"form-group col-sm-5\" ng-class=\"{ 'has-error' : form.name.$invalid && form.$submitted}\"> <label>Nachname</label> <input type=text class=form-control ng-model=model.name name=name maxlength=255> <p ng-show=\"form.name.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> </div> <div class=row> <div class=\"form-group col-sm-2\" ng-class=\"{ 'has-error' : form.address.$invalid && form.$submitted}\"> <label>Anrede</label> <input type=text class=form-control ng-model=model.address name=address maxlength=255> <p ng-show=\"form.address.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=\"form-group col-sm-5\" ng-class=\"{ 'has-error' : form.gender.$invalid && form.$submitted}\"> <label>Geschlecht</label> <select class=form-control name=gender ng-model=model.gender ng-options=\"k as v for (k,v) in gender\"> </select> </div> <div class=\"form-group col-sm-5\" ng-class=\"{ 'has-error' : form.mail.$invalid && form.$submitted}\"> <label>E-Mail-Adresse</label> <input type=text class=form-control ng-model=model.mail name=mail maxlength=255> <p ng-show=\"form.mail.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> </div> <div class=form-group ng-class=\"{ 'has-error' : form.center.$invalid && form.$submitted}\"> <label>Zentren</label> <select multiple=multiple class=form-control ng-model=model.center ng-options=\"item.uuid as item.name for item in center\" size=10 name=center required=required infinite-scroll=getNextPageCenter()> </select> <small>* Mehrfachauswahl durch Halten der Strg-Taste möglich.</small> <p ng-show=\"form.center.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> <button class=\"btn btn-primary\" ng-click=\"add(form, true)\">Speichern</button> <button class=\"btn btn-discard\" ui-sref=main.settings.user>Verwerfen</button> </form> ";

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = "<h3>Nutzer bearbeiten</h3> <form class=form name=form novalidate> <div class=form-group> <label>Nutzername</label> <input type=text class=form-control ng-model=model.username disabled=disabled> </div> <div class=form-group ng-class=\"{ 'has-error' : form.role.$invalid && form.$submitted}\"> <label>Rolle</label> <select class=form-control name=role ng-model=model.roles[0] ng-options=\"role.id as role.label for role in roles\" required=required> </select> <p ng-show=\"form.role.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> <div class=row> <div class=\"form-group col-sm-2\" ng-class=\"{ 'has-error' : form.title.$invalid && form.$submitted}\"> <label>Titel</label> <input type=text class=form-control ng-model=model.title name=title maxlength=255> <p ng-show=\"form.title.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=\"form-group col-sm-5\" ng-class=\"{ 'has-error' : form.prename.$invalid && form.$submitted}\"> <label>Vorname</label> <input type=text class=form-control ng-model=model.prename name=prename maxlength=255> <p ng-show=\"form.prename.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=\"form-group col-sm-5\" ng-class=\"{ 'has-error' : form.name.$invalid && form.$submitted}\"> <label>Nachname</label> <input type=text class=form-control ng-model=model.name name=name maxlength=255> <p ng-show=\"form.name.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> </div> <div class=row> <div class=\"form-group col-sm-2\" ng-class=\"{ 'has-error' : form.address.$invalid && form.$submitted}\"> <label>Anrede</label> <input type=text class=form-control ng-model=model.address name=address maxlength=255> <p ng-show=\"form.address.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=\"form-group col-sm-5\" ng-class=\"{ 'has-error' : form.gender.$invalid && form.$submitted}\"> <label>Geschlecht</label> <select class=form-control name=gender ng-model=model.gender ng-options=\"k as v for (k,v) in gender\"> </select> </div> <div class=\"form-group col-sm-5\" ng-class=\"{ 'has-error' : form.mail.$invalid && form.$submitted}\"> <label>E-Mail-Adresse</label> <input type=text class=form-control ng-model=model.mail name=mail maxlength=255> <p ng-show=\"form.mail.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> </div> <div class=form-group ng-class=\"{ 'has-error' : form.center.$invalid && form.$submitted}\"> <label>Zentren</label> <select multiple=multiple class=form-control ng-model=model.center ng-options=\"item.uuid as item.name for item in center\" name=center size=10 infinite-scroll=getNextPageCenter()> </select> <small>* Mehrfachauswahl durch Halten der Strg-Taste möglich.</small> <p ng-show=\"form.center.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> <button class=\"btn btn-primary\" ng-click=edit(form)>Speichern</button> <button class=\"btn btn-discard\" ui-sref=main.settings.user>Verwerfen</button> </form> <h3>Passwort ändern</h3> <form class=form name=formpw novalidate> <div class=form-group ng-class=\"{ 'has-error' : formpw.password.$invalid && formpw.$submitted}\"> <label>neues Passwort</label> <input type=password class=form-control ng-model=passwords.new name=password ng-required=changePw minlength=8 maxlength=255 password-validator> <p ng-show=\"formpw.password.$error.required && formpw.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"formpw.password.$error.minlength && formpw.$submitted\" class=help-block>Unterschrittene Mindestlänge von 8 Zeichen.</p> <p ng-show=\"formpw.password.$error.passwordVerify && formpw.$submitted\" class=help-block>Schwaches Passwort. Das angegebene Passwort muss mindestens aus acht Zeichen bestehen und sowohl Buchstaben, als auch Zahlen enthalten.</p> </div> <div class=form-group ng-class=\"{ 'has-error' : formpw.password2.$invalid && formpw.$submitted}\"> <label>neues Passwort wiederholen</label> <input type=password class=form-control ng-model=passwords.new2 name=password2 ui-validate=\" '$value==passwords.new' \" ui-validate-watch=\" 'passwords.new' \" ng-required=changePw minlength=8 maxlength=255> <p ng-show=\"formpw.password2.$error.required && formpw.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"formpw.password2.$error.minlength && formpw.$submitted\" class=help-block>Unterschrittene Mindestlänge von 8 Zeichen.</p> <p ng-show=\"formpw.password2.$error.validator && formpw.$submitted\" class=help-block>Die angegebenen Passwörter stimmen nicht überein.</p> </div> <button class=\"btn btn-primary\" ng-click=changePw(formpw)>Speichern</button> <button class=\"btn btn-discard\" ui-sref=main.settings.user>Verwerfen</button> </form> ";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DeletionRequestsCtrl = function DeletionRequestsCtrl($http, Notification) {
  var ctrl = this;

  ctrl.requests = [];

  ctrl.$onInit = function () {
    ctrl.reloadRequests();
  };

  ctrl.reloadRequests = function () {
    $http.get('/api/deletionrequests').then(function (data) {
      ctrl.requests = data.data;
    });
  };

  ctrl.acceptRequest = function (item) {
    item.state = "ACCEPTED";
    $http.post('/api/deletionrequests/' + item.uuid, "ACCEPTED").then(function () {
      ctrl.reloadRequests();
      Notification.success("Der Löschvorgang wurde erfolgreich abgeschlossen.");
    }, function () {
      ctrl.reloadRequests();
      Notification.error("Der Löschvorgang konnte nicht abgeschlossen werden.");
    });
  };

  ctrl.declineRequest = function (item) {
    item.state = "DECLINED";
    $http.post('/api/deletionrequests/' + item.uuid, "DECLINED").then(function () {
      ctrl.$reloadRequests();
      Notification.success("Der Löschantrag wurde erfolgreich abgelehnt.");
    }, function () {
      ctrl.reloadRequests();
      Notification.error("Der Löschantrag konnte nicht abgelehnt werden.");
    });
  };

  ctrl.removeRequest = function (item) {
    $http.delete('/api/deletionrequests/' + item.uuid).then(function () {
      ctrl.reloadRequests();
      Notification.success("Der Löschantrag wurde erfolgreich entfernt.");
    }, function () {
      ctrl.reloadRequests();
      Notification.error("Der Löschantrag konnte nicht entfernt werden.");
    });
  };
};

DeletionRequestsCtrl.$inject = ['$http', 'Notification'];

module.exports = {
  template: __webpack_require__(262),
  controller: DeletionRequestsCtrl
};

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = "<div class=tile cg-busy=$ctrl.request> <h3>Löschanträge</h3> <p class=placeholder ng-if=\"$ctrl.requests.length === 0\">Keine Löschanträge vorhanden.</p> <table ng-if=\"$ctrl.requests.length > 0\" class=\"table table-striped table-hover\" style=margin-bottom:80px> <thead> <tr> <th>Datum</th> <th>Entität</th> <th ng-if=$root.user.isCustodian()>Initiator</th> <th>Bemerkung</th> <th>Status</th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.requests | orderBy:'createdAt':true\"> <td>{{item.createdAt|date:\"dd.MM.yyyy\"}}</td> <td ng-if=\"!item.entity && item.state !== 'OPEN'\"><em>gelöscht</em></td> <td ng-if=item.entity> <span ng-if=item.entity.pid>Patient {{item.entity.pid}}</span> <span ng-if=item.entity.schema>Formular {{$root.config.labels[item.entity.schema.action]}} vom {{item.entity.createdAt|date:\"dd.MM.yyyy\"}}</span> <span ng-if=item.entity.actions>Behandlung vom {{item.entity.createdAt|date:\"dd.MM.yyyy\"}}</span> </td> <td ng-if=$root.user.isCustodian()>{{item.initiator.coreUser.username}}</td> <td>{{item.comment}}</td> <td>{{$root.config.labels[item.state]}}</td> <td> <span ng-if=\"item.state === 'OPEN'\"> <a ng-if=$root.user.isCustodian() confirm=\"Soll der Löschvorgang wirklich durchgeführt werden?\" action=$ctrl.acceptRequest(item)> <span title=\"Löschvorgang durchführen\"> <i class=\"fa fa-check fa-circle-thinner\"></i> </span> </a> <a ng-if=$root.user.isCustodian() confirm=\"Soll der Löschantrag wirklich abgelehnt werden?\" action=$ctrl.declineRequest(item)> <span title=\"Löschantrag ablehnen\"> <i class=\"fa fa-remove fa-circle-thinner\"></i> </span> </a> </span> <a ng-if=\"$root.user.isCustodian() && item.state !== 'OPEN'\" confirm=\"Soll der Löschantrag wirklich entfernt werden?\" action=$ctrl.removeRequest(item)> <span title=\"Löschantrag entfernen\"> <i class=\"fa fa-trash fa-circle-thinner\"></i> </span> </a> </td> </tr> </tbody> </table> </div> ";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CenterFormCtrl = function CenterFormCtrl(CRUDService, Notification, config, $stateParams, $state) {
  var ctrl = this,
      initModel = {
    name: "",
    city: "",
    centerNetwork: [],
    scope: 'QS'
  },
      currentPageNetworks = 0,
      totalPagesNetworks,
      uris = {};

  ctrl.$onInit = function () {

    if ($stateParams.item) {
      ctrl.model = $stateParams.item;
      /*ctrl.model = {
        name: $stateParams.item.name,
        city: $stateParams.item.city,
        scope: $stateParams.item.scope,
        uuid: $stateParams.item.uuid,
        _links: $stateParams.item._links,
        centerNetwork: $stateParams.item.centerNetwork.map(function (network) {
          return network.uuid;
        })
      };*/
      ctrl.model.centerNetwork = $stateParams.item.centerNetwork.map(function (network) {
        return network.uuid;
      });
    } else {
      ctrl.model = initModel;
    }

    CRUDService.getAll(config.urls.networks).then(function (data) {
      totalPagesNetworks = data.page.totalPages;
      ctrl.networks = data._embedded.networks.map(function (item) {
        uris[item.uuid] = item._links.self.href;
        item.uri = item._links.self.href;
        return item;
      });
    });
  };

  ctrl.add = function (form) {
    if (form.$valid) {

      for (var uuid in ctrl.model.centerNetwork) {
        ctrl.model.centerNetwork[uuid] = uris[ctrl.model.centerNetwork[uuid]];
      }

      CRUDService.save(ctrl.model, config.urls.center).then(function () {
        ctrl.model = initModel;
        $state.go('main.settings.center');
      }, function () {
        Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
      });
    }
  };

  ctrl.getNextPageNetworks = function () {
    if (currentPageNetworks + 1 < totalPagesNetworks) {
      currentPageNetworks++;
      CRUDService.getAll(config.urls.networks, currentPageNetworks).then(function (data) {
        ctrl.networks = ctrl.networks.concat(data._embedded.networks.map(function (item) {
          uris[item.uuid] = item._links.self.href;
          item.uri = item._links.self.href;
          return item;
        }));
      });
    }
  };
};

CenterFormCtrl.$inject = ['CRUDService', 'Notification', 'config', '$stateParams', '$state'];

module.exports = {
  template: __webpack_require__(264),
  controller: CenterFormCtrl
};

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = "<h3>Zentrum {{$ctrl.model.uuid ? 'bearbeiten' : 'hinzufügen'}}</h3> <form class=form name=form novalidate> <div class=form-group ng-class=\"{ 'has-error' : form.department.$invalid && form.$submitted}\"> <label>Abteilung</label> <input type=text name=department class=form-control ng-model=$ctrl.model.department required=required maxlength=255> <p ng-show=\"form.department.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.department.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=form-group ng-class=\"{ 'has-error' : form.name.$invalid && form.$submitted}\"> <label>Klinik/Organisationseinheit</label> <input type=text name=name class=form-control ng-model=$ctrl.model.name required=required maxlength=255> <p ng-show=\"form.name.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.name.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=form-group ng-class=\"{ 'has-error' : form.street.$invalid && form.$submitted}\"> <label>Straße, Hausnr.</label> <input type=text name=street class=form-control ng-model=$ctrl.model.street maxlength=255> <p ng-show=\"form.street.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=row> <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : form.zip.$invalid && form.$submitted}\"> <label>Postleitzahl</label> <input type=text name=zip class=form-control ng-model=$ctrl.model.zip maxlength=255> <p ng-show=\"form.zip.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : form.city.$invalid && form.$submitted}\"> <label>Stadt</label> <input type=text name=city class=form-control ng-model=$ctrl.model.city maxlength=255> <p ng-show=\"form.city.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> </div> <div class=row> <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : form.phone.$invalid && form.$submitted}\"> <label>Telefon</label> <input type=text name=phone class=form-control ng-model=$ctrl.model.phone maxlength=255> <p ng-show=\"form.phone.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : form.fax.$invalid && form.$submitted}\"> <label>Fax</label> <input type=text name=fax class=form-control ng-model=$ctrl.model.fax maxlength=255> <p ng-show=\"form.fax.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> </div> <div class=form-group ng-class=\"{ 'has-error' : form.scope.$invalid && form.$submitted}\"> <label>Umfang</label> <div class=radio> <label> <input type=radio name=scope value=QS ng-model=$ctrl.model.scope> QS </label> </div> <div class=radio> <label> <input type=radio name=scope value=SCIENCE ng-model=$ctrl.model.scope> Science </label> </div> </div> <div class=form-group ng-class=\"{ 'has-error' : form.centerNetwork.$invalid && form.$submitted}\"> <label>Zentrumsverbunde</label> <select multiple=multiple class=form-control ng-model=$ctrl.model.centerNetwork ng-options=\"item.uuid as item.name for item in $ctrl.networks\" size=10 infinite-scroll=$ctrl.getNextPageNetworks()> </select> <small>* Mehrfachauswahl durch Halten der Strg-Taste möglich.</small> </div> <button class=\"btn btn-primary\" ng-click=$ctrl.add(form)>Speichern</button> <button class=\"btn btn-discard\" ui-sref=main.settings.center>Verwerfen</button> </form> ";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var NetworkFormCtrl = function NetworkFormCtrl(CRUDService, Notification, config, $stateParams, $state) {
  var ctrl = this,
      initModel = {
    name: ""
  };

  ctrl.$onInit = function () {
    ctrl.model = $stateParams.item || initModel;
  };

  ctrl.add = function (form) {
    if (form.$valid) {
      CRUDService.save(ctrl.model, config.urls.networks, 'name,asc').then(function () {
        ctrl.model = initModel;
        $state.go('main.settings.network');
      }, function () {
        Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
      });
    }
  };
};

NetworkFormCtrl.$inject = ['CRUDService', 'Notification', 'config', '$stateParams', '$state'];

module.exports = {
  template: __webpack_require__(266),
  controller: NetworkFormCtrl
};

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports = "<h3>Zentrumsverbund {{$ctrl.model.uuid ? 'bearbeiten' : 'hinzufügen'}}</h3> <form class=form name=form novalidate> <div class=form-group ng-class=\"{ 'has-error' : form.name.$invalid && form.$submitted}\"> <label>Name</label> <input type=text name=name class=form-control ng-model=$ctrl.model.name required=required maxlength=255> <p ng-show=\"form.name.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> <button class=\"btn btn-primary\" ng-click=$ctrl.add(form)>Speichern</button> <button class=\"btn btn-discard\" ui-sref=main.settings.network>Verwerfen</button> </form> ";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var NewsFormCtrl = function NewsFormCtrl(CRUDService, Notification, config, $stateParams, $rootScope, $http, $state) {
  var ctrl = this;

  var initModel = {
    title: "",
    content: "",
    publishDate: null,
    author: null
  };
  ctrl.model = $stateParams.item || initModel;

  ctrl.save = function (form) {
    if (form.$valid) {
      // get user uri
      $http.get(config.urls.users + "/search/findByUuid?uuid=" + $rootScope.user.uuid).then(function (response) {
        ctrl.model.author = response.data._links.self.href;
        if (!ctrl.model._links) {
          ctrl.model.publishDate = new Date();
        }

        CRUDService.save(ctrl.model, config.urls.news).then(function () {
          ctrl.model = initModel;
          $state.go('main.settings.news');
        }, function () {
          Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
        });
      });
    }
  };
};

NewsFormCtrl.$inject = ['CRUDService', 'Notification', 'config', '$stateParams', '$rootScope', '$http', '$state'];

module.exports = {
  template: __webpack_require__(268),
  controller: NewsFormCtrl
};

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = "<h3>News-Beitrag {{$ctrl.model.uuid ? 'bearbeiten' : 'hinzufügen'}}</h3> <form class=form name=form novalidate> <div class=form-group ng-class=\"{ 'has-error' : form.title.$invalid && form.$submitted}\"> <label>Überschrift</label> <input type=text name=title class=form-control ng-model=$ctrl.model.title required=required maxlength=255> <p ng-show=\"form.title.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> <div class=form-group ng-class=\"{ 'has-error' : (form.content.$invalid && form.$submitted) || form.content.$error.maxlength}\"> <label>Inhalt</label> <emil-editor field-name=\"'content'\" required=true maxlength=2000 form-field=$ctrl.model.content></emil-editor> <p ng-show=\"form.content.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=form.content.$error.maxlength class=help-block>Überschrittene Maximallänge von 2000 Zeichen.</p> </div> <button class=\"btn btn-primary\" ng-click=$ctrl.save(form)>Speichern</button> <button class=\"btn btn-discard\" ui-sref=main.settings.news>Verwerfen</button> </form> ";

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ProtocolCtrl = function ProtocolCtrl($rootScope, $scope, $state, $stateParams, CRUDService, config) {
  var ctrl = this;

  var url = config.urls.protocol + "/search/findByLoggerName?logger=net.gesundheitsforen.emil.model.EntityProtocolListener";
  ctrl.i = 0;

  var currentPage = 0;
  var totalPages;

  function getAll() {
    CRUDService.getAll(url, undefined, 'timestmp,desc').then(function (data) {
      ctrl.protocol = data._embedded.logging;
      totalPages = data.page.totalPages;
    });
  }

  getAll();

  ctrl.getNextPage = function () {
    if (currentPage + 1 < totalPages) {
      currentPage++;
      CRUDService.getAll(url, currentPage, 'timestmp,desc').then(function (data) {
        ctrl.protocol = ctrl.protocol.concat(data._embedded.logging);
      });
    }
  };

  $scope.$watch(function () {
    return ctrl.i;
  }, function (val) {
    if (val === 7) {
      url = config.urls.protocol;
      getAll();
    }
  });
};

ProtocolCtrl.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'CRUDService', 'config'];

module.exports = {
  template: __webpack_require__(270),
  controller: ProtocolCtrl
};

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = "<h3 ng-click=\"$ctrl.i = $ctrl.i + 1\" class=color_primary style=cursor:auto>Nutzungsprotokoll</h3> <table class=\"table table-striped\" infinite-scroll=$ctrl.getNextPage() infinite-scroll-container=\"'document'\"> <thead> <tr> <th>Datum</th> <th>Meldung</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.protocol\"> <td>{{item.timestmp|date:\"dd.MM.yyyy HH:mm\"}}</td> <td>{{item.levelString}} - {{item.formattedMessage}}</td> </tr> </tbody> </table> ";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SettingsCtrl = function SettingsCtrl(CRUDService, config, Notification) {
  var ctrl = this;

  ctrl.$onInit = function () {
    CRUDService.getAll(config.urls.settings).then(function (data) {
      ctrl.settings = data;
    });
  };

  ctrl.save = function (form) {
    if (form.$valid) {
      CRUDService.save(ctrl.settings).then(function () {
        Notification.success('Die Einstellungen wurden erfolgreich gespeichert.');
      }, function () {
        Notification.error('Beim Speichern der Einstellungen ist ein Fehler aufgetreten.');
      });
    }
  };

  ctrl.addSubject = function () {
    if (ctrl.newSubject) {
      ctrl.settings.mailSubjects.push(ctrl.newSubject);
      ctrl.newSubject = "";
    }
  };
};

SettingsCtrl.$inject = ['CRUDService', 'config', 'Notification'];

module.exports = {
  template: __webpack_require__(272),
  controller: SettingsCtrl
};

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports = "<h3>Einstellungen</h3> <form name=form> <fieldset> <legend>Ausbleibende Behandlungen</legend> <p class=help-block>Definiert ab wie vielen vergangenen Tagen seit Behandlungbeginn ein Behandlungsschritt als überfällig gilt.</p> <div class=row> <div class=\"form-group col-sm-4\" ng-class=\"{ 'has-error' : form.durationAnamnesis.$invalid && form.$submitted}\"> <label>Anamnese</label> <input type=number class=form-control name=durationAnamnesis ng-model=$ctrl.settings.durationAnamnesis required=required> <p ng-show=\"form.durationAnamnesis.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> <div class=\"form-group col-sm-4\" ng-class=\"{ 'has-error' : form.durationIntervention.$invalid && form.$submitted}\"> <label>Intervention</label> <input type=number class=form-control name=durationIntervention ng-model=$ctrl.settings.durationIntervention required=required> <p ng-show=\"form.durationIntervention.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> <div class=\"form-group col-sm-4\" ng-class=\"{ 'has-error' : form.durationPostInterventionFollowup.$invalid && form.$submitted}\"> <label>Postinterventionelle Nachkontrolle</label> <input type=number class=form-control name=durationPostInterventionFollowup ng-model=$ctrl.settings.durationPostInterventionFollowup required=required> <p ng-show=\"form.durationPostInterventionFollowup.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> </div> <p></p> <p class=help-block>Definiert ab wie vielen vergangenen Tagen seit der letzten Intervention, ein Behandlungsschritt als überfällig gilt.</p> <div class=row> <div class=\"form-group col-sm-4\" ng-class=\"{ 'has-error' : form.durationFirstFollowup.$invalid && form.$submitted}\"> <label>Erstes Follow-Up</label> <input type=number class=form-control name=durationFirstFollowup ng-model=$ctrl.settings.durationFirstFollowup required=required> <p ng-show=\"form.durationFirstFollowup.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> <div class=\"form-group col-sm-4\" ng-class=\"{ 'has-error' : form.durationSecondFollowup.$invalid && form.$submitted}\"> <label>Weiteres Follow-Up</label> <input type=number class=form-control name=durationSecondFollowup ng-model=$ctrl.settings.durationSecondFollowup required=required> <p ng-show=\"form.durationSecondFollowup.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> </div> </fieldset> <fieldset> <legend>Impressum</legend> <div class=form-group ng-class=\"{ 'has-error' : (form.impressum.$invalid && form.$submitted) || form.impressum.$error.maxlength}\"> <label>Inhalt</label> <emil-editor field-name=\"'impressum'\" required=true maxlength=10000 form-field=$ctrl.settings.impressum></emil-editor> <p ng-show=\"form.impressum.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=form.impressum.$error.maxlength class=help-block>Überschrittene Maximallänge von 10000 Zeichen.</p> </div> </fieldset> <fieldset> <legend>Kontaktformular</legend> <div class=form-group ng-class=\"{ 'has-error' : form.mailRecipient.$invalid && form.$submitted}\"> <label>Empfänger</label> <input type=text class=form-control name=mailRecipient ng-model=$ctrl.settings.mailRecipient required=required> <p ng-show=\"form.mailRecipient.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> <div class=form-group ng-class=\"{ 'has-error' : form.mailSubjects.$invalid && form.$submitted}\"> <label>Betreffzeilen</label> <ul> <li ng-repeat=\"s in $ctrl.settings.mailSubjects\"> {{s}} <span class=\"fa fa-lg fa-trash-o\" title=Entfernen ng-click=\"$ctrl.settings.mailSubjects.splice($index, 1)\"></span> </li> </ul> <div class=input-group> <input type=text class=form-control ng-model=$ctrl.newSubject placeholder=\"Betreffzeile hinzufügen\"> <span class=\"input-group-addon transparent\" ng-click=$ctrl.addSubject()> <i class=\"fa fa-plus fa-circle-thinner\"></i> </span> </div> </div> </fieldset> <button class=\"btn btn-primary\" ng-click=$ctrl.save(form)>Speichern</button> </form> ";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CenterSettingsCtrl = function CenterSettingsCtrl(CRUDService, config) {
  var ctrl = this;

  var currentPage = 0;
  var totalPages;

  ctrl.$onInit = function () {
    CRUDService.getAll(config.urls.center, undefined, 'name,asc').then(function (data) {
      ctrl.center = data._embedded.center;
      totalPages = data.page.totalPages;
    });
  };

  ctrl.remove = function (item) {
    CRUDService.remove(item._links.self.href).then(function () {
      ctrl.$onInit();
    });
  };

  ctrl.getNextPage = function () {
    if (currentPage + 1 < totalPages) {
      currentPage++;
      CRUDService.getAll(config.urls.center, currentPage, 'name,asc').then(function (data) {
        ctrl.center = ctrl.center.concat(data._embedded.center);
      });
    }
  };
};

CenterSettingsCtrl.$inject = ['CRUDService', 'config'];

module.exports = {
  template: __webpack_require__(274),
  controller: CenterSettingsCtrl
};

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports = "<h3>Zentren</h3> <div class=btn-group role=group> <a ui-sref=main.settings.center-add> <button type=button class=\"btn btn-emil\"> Zentrum hinzufügen <i class=\"fa fa-plus-circle\"></i> </button> </a> </div> <br/><br/> <table class=\"table table-striped\" infinite-scroll=$ctrl.getNextPage() infinite-scroll-container=\"'document'\"> <thead> <tr> <th>Name</th> <th>Ort</th> <th>Telefon</th> <th>Zentrumsverbunde</th> <th>Umfang</th> <th class=actions></th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.center\"> <td>{{item.department}}{{item.department ? ', ' : ''}}{{item.name}}</td> <td>{{item.zip}} {{item.city}}</td> <td>{{item.phone}}</td> <td> <span ng-repeat=\"network in item.centerNetwork\"> {{network.name}}{{$last ? '' : ', '}} </span> </td> <td>{{item.scope}}</td> <td class=actions> <emil-button-edit ui-sref=\"main.settings.center-add({item: item})\" title=\"Zentrum bearbeiten\"></emil-button-edit> <emil-button-delete confirm=\"Wollen sie das Zentrum '{{item.name}}' wirklich löschen?\" action=$ctrl.remove(item) title=\"Zentrum löschen\"></emil-button-delete> </td> </tr> </tbody> </table> ";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var NetworkSettingsCtrl = function NetworkSettingsCtrl(CRUDService, config) {
  var ctrl = this;

  var currentPage = 0;
  var totalPages;

  ctrl.$onInit = function () {
    CRUDService.getAll(config.urls.networks, undefined, 'name,asc').then(function (data) {
      ctrl.networks = data._embedded.networks;
      totalPages = data.page.totalPages;
    });
  };

  ctrl.remove = function (item) {
    CRUDService.remove(item._links.self.href).then(function () {
      ctrl.$onInit();
    });
  };

  ctrl.getNextPage = function () {
    if (currentPage + 1 < totalPages) {
      currentPage++;
      CRUDService.getAll(config.urls.networks, currentPage).then(function (data) {
        ctrl.networks = ctrl.networks.concat(data._embedded.networks);
      });
    }
  };
};

NetworkSettingsCtrl.$inject = ['CRUDService', 'config'];

module.exports = {
  template: __webpack_require__(276),
  controller: NetworkSettingsCtrl
};

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = "<h3>Zentrumsverbunde</h3> <div class=btn-group role=group> <a ui-sref=main.settings.network-add> <button type=button class=\"btn btn-emil\"> Zentrumsverbund hinzufügen <i class=\"fa fa-plus-circle\"></i> </button> </a> </div> <br/><br/> <table class=\"table table-striped\" infinite-scroll=$ctrl.getNextPage() infinite-scroll-container=\"'document'\"> <thead> <tr> <th>Name</th> <th class=actions></th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.networks\"> <td>{{item.name}}</td> <td class=actions> <emil-button-edit ui-sref=\"main.settings.network-add({item: item})\" title=\"Zentrumsverbund bearbeiten\"></emil-button-edit> <emil-button-delete confirm=\"Wollen sie den Zentrumsverbund '{{item.name}}' wirklich löschen?\" action=$ctrl.remove(item) title=\"Zentrumsverbund löschen\"></emil-button-delete> </td> </tr> </tbody> </table> ";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var NewsSettingsCtrl = function NewsSettingsCtrl(CRUDService, config) {
  var ctrl = this;

  var currentPage = 0;
  var totalPages;

  ctrl.$onInit = function () {
    CRUDService.getAll(config.urls.news).then(function (data) {
      ctrl.news = data._embedded.news;
      totalPages = data.page.totalPages;
    });
  };

  ctrl.remove = function (item) {
    CRUDService.remove(item._links.self.href).then(function () {
      ctrl.$onInit();
    });
  };

  ctrl.getNextPage = function () {
    if (currentPage + 1 < totalPages) {
      currentPage++;
      CRUDService.getAll(config.urls.news, currentPage).then(function (data) {
        ctrl.news = ctrl.news.concat(data._embedded.news);
      });
    }
  };
};

NewsSettingsCtrl.$inject = ['CRUDService', 'config'];

module.exports = {
  template: __webpack_require__(278),
  controller: NewsSettingsCtrl
};

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports = "<h3>Neuigkeiten</h3> <div class=btn-group role=group> <a ui-sref=main.settings.news-add> <button type=button class=\"btn btn-emil\"> Neuigkeit hinzufügen <i class=\"fa fa-plus-circle\"></i> </button> </a> </div> <br/><br/> <table class=\"table table-striped\" infinite-scroll=$ctrl.getNextPage() infinite-scroll-container=\"'document'\"> <thead> <tr> <th>Titel</th> <th>Autor</th> <th>Datum</th> <th class=actions></th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.news\"> <td>{{item.title}}</td> <td width=175>{{item.author.username}}</td> <td width=175>{{item.publishDate|date:\"dd.MM.yyyy HH:mm\"}}Uhr</td> <td class=actions> <emil-button-edit ui-sref=\"main.settings.news-add({item: item})\" title=\"Beitrag bearbeiten\"></emil-button-edit> <emil-button-delete confirm=\"Wollen sie den Eintrag '{{item.title}}' wirklich löschen?\" action=$ctrl.remove(item) title=\"Beitrag löschen\"></emil-button-delete> </td> </tr> </tbody> </table> ";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ProfileCtrl = function ProfileCtrl($rootScope, $scope, CRUDService, Notification, config) {
  var ctrl = this;

  ctrl.changePw = function (form) {
    if (form.$valid) {
      CRUDService.save({
        "username": $rootScope.user.uuid,
        "password": ctrl.passwords.new,
        "current": true
      }, config.urls.users + '/changePw').then(function () {
        ctrl.passwords = {};
        form.$submitted = false;
        Notification.success("Ihr Passwort wurde erfolgreich geändert.");
      }, function () {
        Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
      });
    }
  };

  ctrl.getRoles = function () {
    var ret = "";
    console.log($rootScope.user.roles);
    console.log($scope.roles);
    for (var urole in $rootScope.user.roles) {
      for (var role in $scope.roles) {
        if ($rootScope.user.roles[urole] === $scope.roles[role].id) {
          if (ret.length > 1) {
            ret += ", ";
          }
          ret += $scope.roles[role].label;
        }
      }
    }
    return ret;
  };

  $scope.roles = [{ id: 'ROLE_ASSISTENT', label: 'Assistent' }, { id: 'ROLE_OFFICER', label: 'Studienbeauftragter' }, { id: 'ROLE_MONITOR', label: 'Monitor' }, { id: 'ROLE_ADMIN', label: 'Administrator' }, { id: 'ROLE_CUSTODIAN', label: 'Datentreuhänder' }];

  $scope.userRoles = ctrl.getRoles();
};

ProfileCtrl.$inject = ['$rootScope', '$scope', 'CRUDService', 'Notification', 'config'];

module.exports = {
  template: __webpack_require__(280),
  controller: ProfileCtrl
};

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports = "<h3>Profil</h3> <fieldset> <legend>Benutzer</legend> <div class=form-group> <label>Nutzername</label> <input type=text class=form-control disabled=disabled value={{$root.user.username}}> </div> <div class=form-group> <label>Berechtigungsstufe</label> <input type=text class=form-control disabled=disabled value={{userRoles}}> </div> </fieldset> <fieldset> <legend>Passwort ändern</legend> <form class=form name=formpw novalidate> <div class=form-group ng-class=\"{ 'has-error' : formpw.password.$invalid && formpw.$submitted}\"> <label>Neues Passwort</label> <p class=help-block>Mindestlänge: 8 Zeichen. Muss sowohl Buchstaben, als auch Zahlen enthalten.</p> <input type=password class=form-control ng-model=$ctrl.passwords.new name=password required=required minlength=8 maxlength=255 password-validator> <p ng-show=\"formpw.password.$error.minlength && formpw.$submitted\" class=help-block>Unterschrittene Mindestlänge von 8 Zeichen.</p> <p ng-show=\"formpw.password.$error.required && formpw.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"formpw.password.$error.passwordVerify && formpw.$submitted\" class=help-block>Schwaches Passwort. Das angegebene Passwort muss mindestens aus acht Zeichen bestehen und sowohl Buchstaben, als auch Zahlen enthalten.</p> </div> <div class=form-group ng-class=\"{ 'has-error' : formpw.password2.$invalid && formpw.$submitted}\"> <label>Neues Passwort wiederholen</label> <input type=password class=form-control ng-model=$ctrl.passwords.new2 ui-validate=\" '$value==$ctrl.passwords.new' \" ui-validate-watch=\" '$ctrl.passwords.new' \" name=password2 required=required minlength=8 maxlength=255> <p ng-show=\"formpw.password2.$error.minlength && formpw.$submitted\" class=help-block>Unterschrittene Mindestlänge von 8 Zeichen.</p> <p ng-show=\"formpw.password2.$error.required && formpw.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"formpw.password2.$error.validator && formpw.$submitted\" class=help-block>Die angegebenen Passwörter stimmen nicht überein.</p> </div> <button class=\"btn btn-primary\" ng-click=$ctrl.changePw(formpw)>Speichern</button> </form> </fieldset> ";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var UserSettingsCtrl = function UserSettingsCtrl(CRUDService, config) {
  var ctrl = this;

  var currentPage = 0;
  var totalPages;

  ctrl.$onInit = function () {
    CRUDService.getAll(config.urls.users + '?projection=default').then(function (data) {
      ctrl.users = data._embedded.users;
      totalPages = data.page.totalPages;
    });
  };

  ctrl.remove = function (item) {
    CRUDService.remove(item._links.self.href).then(function () {
      ctrl.$onInit();
    });
  };

  ctrl.getNextPage = function () {
    if (currentPage + 1 < totalPages) {
      currentPage++;
      CRUDService.getAll(config.urls.users + '?projection=default', currentPage).then(function (data) {
        ctrl.users = ctrl.users.concat(data._embedded.users);
      });
    }
  };
};

UserSettingsCtrl.$inject = ['CRUDService', 'config'];

module.exports = {
  template: __webpack_require__(282),
  controller: UserSettingsCtrl
};

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports = "<h3>Benutzer</h3> <div class=btn-group role=group> <a ui-sref=main.settings.user-add> <button type=button class=\"btn btn-emil\"> Benutzer hinzufügen <i class=\"fa fa-plus-circle\"></i> </button> </a> </div> <br/><br/> <table class=\"table table-striped\" infinite-scroll=$ctrl.getNextPage() infinite-scroll-container=\"'document'\"> <thead> <tr> <th>Benutzername</th> <th>Name</th> <th>E-Mail-Adresse</th> <th>Rolle</th> <th>Zentren</th> <th class=actions></th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.users\"> <td>{{item.coreUser.username}}</td> <td>{{item.prename}} {{item.name}}</td> <td>{{item.mail}}</td> <td> <span ng-repeat=\"authority in item.authorities\"> {{authority.label}}{{$last ? '' : ', '}} </span> </td> <td> <span ng-repeat=\"center in item.center\"> {{center.name}} ({{center.city}}){{$last ? '' : ', '}} </span> </td> <td class=actions> <emil-button-edit ui-sref=\"main.settings.user-edit({item: item})\" title=\"Benutzer bearbeiten\"></emil-button-edit> <emil-button-delete confirm=\"Wollen sie den Benutzer '{{item.coreUser.username}}' wirklich löschen?\" action=$ctrl.remove(item) title=\"Benutzer löschen\"></emil-button-delete> </td> </tr> </tbody> </table> ";

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExportSettingsCtrl = function ExportSettingsCtrl(CRUDService, $q, $http) {
  var ctrl = this;
  this.$q = $q;
  this.$http = $http;

  ctrl.downloadBtnDisabled = false;

  ctrl.$onInit = function () {};

  ctrl.doExport = function (type) {
    ctrl.downloadBtnDisabled = true;
    var deferred = this.$q.defer();

    this.$http.get("/api/export", { params: { type: type }, responseType: 'arraybuffer' }).then(function (response) {
      if (response.status === 200) {
        var date = (0, _moment2.default)().format('YYYYMMDD_HHmm');
        ctrl.download(response.data, "MDAT_Export_" + date + ".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        deferred.resolve();
        ctrl.downloadBtnDisabled = false;
      } else {
        deferred.reject();
        ctrl.downloadBtnDisabled = false;
      }
    }, function () {
      deferred.reject();
      ctrl.downloadBtnDisabled = false;
    });
    return deferred.promise;
  };

  ctrl.download = function (data, filename, mime) {
    var blob = new Blob([data], { type: mime || 'application/octet-stream' });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // IE workaround for "HTML7007: One or more blob URLs were 
      // revoked by closing the blob for which they were created. 
      // These URLs will no longer resolve as the data backing 
      // the URL has been freed."
      window.navigator.msSaveBlob(blob, filename);
    } else {
      var blobURL = window.URL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename);

      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking 
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }

      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }
  };
};

ExportSettingsCtrl.$inject = ['CRUDService', '$q', '$http'];

module.exports = {
  template: __webpack_require__(284),
  controller: ExportSettingsCtrl
};

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = "<h3>Export</h3> <div class=btn-group role=group ng-if=\"$root.user.isMonitor() || $root.user.isCustodian()\"> <a ui-sref=main.settings.export-mdat> <button type=button ng-disabled=$ctrl.downloadBtnDisabled ng-click=\"$ctrl.doExport('ALL')\" class=\"btn btn-emil\"> MDAT Export aller Studienzentren <i class=\"fa fa-download\"></i> </button> </a> </div> <div class=btn-group role=group ng-if=$root.user.isOfficer()> <a ui-sref=main.settings.export-mdat> <button type=button ng-disabled=$ctrl.downloadBtnDisabled ng-disabled=checked ng-click=\"$ctrl.doExport('OWN_CENTER')\" class=\"btn btn-emil\"> MDAT Export des eigenen Studienzentrums <i class=\"fa fa-download\"></i> </button> </a> </div> <br/><br/> <p> <b>Hinweis:</b> Patienten, für die noch <u>keine</u> Behandlungsdaten erfasst wurden, sind <u>nicht im Export</u> enthalten. </p> ";

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var UserCtrl = function UserCtrl($scope, $rootScope, $state, $stateParams, CRUDService, config, Notification) {

  var currentPage = {
    user: 0,
    center: 0
  },
      totalPages = {
    user: 1,
    center: 1
  },
      initModel = {
    username: "",
    password: "",
    roles: ["ROLE_ASSISTENT"],
    center: []
  };
  $scope.password2 = "";
  $scope.model = initModel;

  $scope.passwords = {
    new: "",
    new2: ""
  };

  if ($stateParams.item) {
    $scope.model = $stateParams.item;
    $scope.model.username = $stateParams.item.coreUser.username;
    $scope.model.roles = $stateParams.item.authorities.map(function (item) {
      return item.authority;
    });
    $scope.model.center = $stateParams.item.center.map(function (item) {
      return item.uuid;
    });
  }

  $scope.gender = {
    "MALE": 'männlich',
    "FEMALE": 'weiblich'
  };

  $scope.roles = [{ id: 'ROLE_ASSISTENT', label: 'Assistent' }, { id: 'ROLE_OFFICER', label: 'Studienbeauftragter' }, { id: 'ROLE_MONITOR', label: 'Monitor' }, { id: 'ROLE_ADMIN', label: 'Administrator' }, { id: 'ROLE_CUSTODIAN', label: 'Datentreuhänder' }];

  function getAll() {
    CRUDService.getAll(config.urls.users + '?projection=default').then(function (data) {
      $scope.users = data._embedded.users;
      totalPages.user = data.page.totalPages;
    });
    CRUDService.getAll(config.urls.center).then(function (data) {
      $scope.center = data._embedded.center;
      totalPages.center = data.page.totalPages;
    });
  }
  getAll();

  $scope.remove = function (item) {
    CRUDService.remove(item._links.self.href).then(function () {
      getAll();
    });
  };

  $scope.edit = function (form) {
    $scope.add(form, false);
  };

  $scope.add = function (form, createUser) {
    if (form.$valid) {
      delete $scope.model._links;
      CRUDService.save($scope.model, config.urls.users + '/register').then(function () {
        $scope.model = initModel;
        $state.go('main.settings.user');
        if (createUser && createUser === true) {
          Notification.success("Nutzer erfolgreich angelegt.");
        } else {
          Notification.success("Änderungen am Nutzer erfolgreich gespeichert.");
        }
      }, function () {
        Notification.error("Nutzer konnte nicht angelegt werden.");
      });
    }
  };

  $scope.changePw = function (form) {
    if (form.$valid) {
      CRUDService.save({
        "username": $scope.model.uuid,
        "password": $scope.passwords.new
      }, config.urls.users + '/changePw').then(function () {
        $state.go('main.settings.user');
      }, function () {
        Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
      });
    }
  };

  $scope.getNextPage = function () {
    if (currentPage.user + 1 < totalPages.user) {
      currentPage.user++;
      CRUDService.getAll(config.urls.users + '?projection=default', currentPage.user).then(function (data) {
        $scope.users = $scope.users.concat(data._embedded.users);
      });
    }
  };

  $scope.getNextPageCenter = function () {
    if (currentPage.center + 1 < totalPages.center) {
      currentPage.center++;
      CRUDService.getAll(config.urls.center, currentPage.center).then(function (data) {
        $scope.center = $scope.center.concat(data._embedded.center);
      });
    }
  };
};

UserCtrl.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'CRUDService', 'config', 'Notification'];

module.exports = UserCtrl;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(30);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularSchemaForm = __webpack_require__(287);

var _angularSchemaForm2 = _interopRequireDefault(_angularSchemaForm);

__webpack_require__(291);

var _patientsservice = __webpack_require__(292);

var _patientsservice2 = _interopRequireDefault(_patientsservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('emilPatients', [_angularjs2.default, _angularSchemaForm2.default.name]).config(['$stateProvider', 'schemaFormDecoratorsProvider', 'schemaFormProvider', 'sfPathProvider', 'sfBuilderProvider', function ($stateProvider, schemaFormDecoratorsProvider, schemaFormProvider, sfPathProvider, sfBuilderProvider) {
  $stateProvider.state('main.patients', {
    abstract: true,
    url: 'patienten',
    template: '<ui-view/>',
    data: {
      proxy: 'main.patients.list'
    }
  }).state('main.patients.list', {
    url: '/uebersicht',
    component: 'patientList',
    params: {
      permission: '11111'
    },
    data: {
      displayName: 'Patientenübersicht'
    }
  }).state('main.patients.add', {
    url: '/neu',
    component: 'formPatient',
    params: {
      permission: '00110'
    },
    data: {
      displayName: 'Patient anlegen'
    }
  }).state('main.patients.edit', {
    url: '/bearbeiten/:pid',
    component: 'formPatient',
    params: {
      patient: undefined,
      permission: '00111'
    },
    data: {
      displayName: 'Patient bearbeiten'
    }
  }).state('main.patients.list.details', {
    url: '/:pid',
    component: 'patientDetails',
    params: {
      patient: undefined,
      permission: '11110'
    },
    resolve: {
      patient: ['PatientsService', '$stateParams', function (PatientsService, $stateParams) {
        return $stateParams.patient || PatientsService.findByPid($stateParams.pid);
      }]
    },
    data: {
      displayName: 'Details Patient'
    }
  }).state('main.patients.list.details.treatsteps', {
    component: 'treatmentSteps',
    resolve: {
      'patient': ['$stateParams', function ($stateParams) {
        return $stateParams.patient;
      }],
      'treatment': ['$stateParams', function ($stateParams) {
        return $stateParams.treatment;
      }]
    },
    bindings: {
      patient: 'patient',
      treatment: 'treatment'
    },
    params: {
      treatment: undefined,
      treatId: undefined,
      permission: '11110'
    },
    data: {
      displayName: ''
    }
  }).state('main.patients.list.details.treatform', {
    component: 'formTreatmentStep',
    resolve: {
      'patient': ['$stateParams', function ($stateParams) {
        return $stateParams.patient;
      }],
      'treatment': ['$stateParams', function ($stateParams) {
        return $stateParams.treatment;
      }]
    },
    bindings: {
      patient: 'patient',
      treatment: 'treatment'
    },
    params: {
      treatment: undefined,
      permission: '10110'
    },
    data: {
      displayName: ''
    }
  }).state('main.patients.formview', {
    url: '/:pid/behandlung/:treatId/:actionId',
    component: 'formTreatment',
    params: {
      permission: '11110'
    },
    data: {
      displayName: 'Behandlung'
    }
  }).state('main.patients.formview.changes', {
    component: 'treatmentStepsChangelog',
    resolve: {
      'change': ['$stateParams', function ($stateParams) {
        return $stateParams.change;
      }]
    },
    bindings: {
      change: 'change'
    },
    params: {
      change: undefined,
      permission: '10110'
    }
  });

  var calculator = function calculator(name, schema, options) {
    if (schema['x-calc']) {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'calculator';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  var datepicker = function datepicker(name, schema, options) {
    // add custom datepicker to schema-form
    if (schema.type === 'string' && schema.format === 'date') {
      if (schema['x-today']) {
        schema['default'] = new Date();
      }

      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'datepicker';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  var opsWizard = function opsWizard(name, schema, options) {
    // add custom datepicker to schema-form
    if (schema.type === 'string' && schema.format === 'ops') {

      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'ops';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(datepicker);
  schemaFormProvider.defaults.string.unshift(opsWizard);
  schemaFormProvider.defaults.string.unshift(calculator);
  schemaFormProvider.defaults.number.unshift(calculator);

  schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'datepicker', __webpack_require__(293));

  schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'ops', __webpack_require__(294));

  schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'calculator', __webpack_require__(295));

  schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'select-center', __webpack_require__(296));

  schemaFormDecoratorsProvider.defineAddOn('bootstrapDecorator', 'fieldset', 'fieldset.html', [sfBuilderProvider.builders.transclusion, sfBuilderProvider.builders.sfField, sfBuilderProvider.builders.condition]);

  schemaFormDecoratorsProvider.defineAddOn('bootstrapDecorator', 'radios-inline', 'radios-inline.html', [sfBuilderProvider.builders.sfField, sfBuilderProvider.builders.condition, sfBuilderProvider.builders.ngModel, sfBuilderProvider.builders.ngModelOptions]);
}]).run(['$templateCache', function ($templateCache) {
  $templateCache.put('fieldset.html', __webpack_require__(297));
  $templateCache.put('radios-inline.html', __webpack_require__(298));
}]).component('formPatient', __webpack_require__(299)).component('formTreatment', __webpack_require__(301)).component('formTreatmentStep', __webpack_require__(303)).component('masterData', __webpack_require__(305)).component('medications', __webpack_require__(307)).component('opsWizard', __webpack_require__(309)).component('overdueTreatments', __webpack_require__(311)).component('patientDetails', __webpack_require__(313)).component('patientList', __webpack_require__(315)).component('recentPatients', __webpack_require__(317)).component('targetLesionsTile', __webpack_require__(319)).component('targetLesions', __webpack_require__(321)).component('treatments', __webpack_require__(323)).component('treatmentSteps', __webpack_require__(325)).component('treatmentStepsChangelog', __webpack_require__(327)).component('treatmentStepsHistory', __webpack_require__(329)).directive('calculate', __webpack_require__(331)).service('PatientsService', _patientsservice2.default);

/***/ }),
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PatientsService = function () {
  function PatientsService($http, $q, $rootScope) {
    _classCallCheck(this, PatientsService);

    this.$http = $http;
    this.$q = $q;
    this.$rootScope = $rootScope;
  }

  _createClass(PatientsService, [{
    key: 'save',
    value: function save(data) {
      return this.$http.post('/api/patients/register', data);
    }
  }, {
    key: 'getPatientData',
    value: function getPatientData(pids, sortKey, page, searchKey, pageSize) {
      return this.$http.post('/api/patients/getPatientData', { sort: sortKey, pids: pids, page: page, search: searchKey, pageSize: pageSize });
    }
  }, {
    key: 'getAll',
    value: function getAll(sortKey, page, searchKey) {
      var defer = this.$q.defer();
      var currentPage = page || 0;

      var self = this;
      this.$http.get('/api/patients/search/findAllowedPatients', { params: { sort: 'lastModifiedAt,desc' } }).then(function (data) {
        var patients = data.data;

        if (self.$rootScope.user.hasPermission("00111")) {
          var pids = data.data.map(function (patient) {
            return patient.pid;
          });
          self.getPatientData(pids, sortKey, currentPage, searchKey).then(function (data) {
            defer.resolve({ patients: PatientsService.matchRecords(patients, data.data.pageList), totalPages: data.data.pageCount });
          }, function () {
            defer.reject();
          });
        } else {
          defer.resolve({ patients: patients });
        }
      }, function () {
        defer.reject();
      });

      return defer.promise;
    }
  }, {
    key: 'updateIdat',
    value: function updateIdat(data) {
      return this.$http.post('/api/patients/' + data.pid + '/idat', data);
    }
  }, {
    key: 'updateMdat',
    value: function updateMdat(data) {
      return this.$http.post('/api/patients/' + data.pid + '/mdat', data);
    }
  }, {
    key: 'remove',
    value: function remove(item) {
      return this.$http.delete('/api/patients/' + item.pid);
    }
  }, {
    key: 'findByPid',
    value: function findByPid(pid) {
      var defer = this.$q.defer();

      var self = this;
      this.$http.get('/api/patients/search/findAllowedPatientsByPid/' + pid).then(function (data) {
        var patients = data.data;

        if (patients.length !== 1) {
          defer.reject();
        } else {
          if (self.$rootScope.user.hasPermission("00111")) {
            var pids = data.data.map(function (patient) {
              return patient.pid;
            });
            self.getPatientData(pids).then(function (data) {
              var matchedPatients = PatientsService.matchRecords(patients, data.data.pageList);
              defer.resolve(matchedPatients[0]);
            }, function () {
              defer.reject();
            });
          } else {
            defer.resolve(patients[0]);
          }
        }
      }, function () {
        defer.reject();
      });

      return defer.promise;
    }
  }, {
    key: 'addTargetLesion',
    value: function addTargetLesion(pid, targetLesion) {
      return this.$http.post('/api/patients/' + pid + '/targetLesions', targetLesion);
    }
  }, {
    key: 'deleteTargetLesion',
    value: function deleteTargetLesion(pid, uuid) {
      return this.$http.delete('/api/patients/' + pid + '/targetLesions/' + uuid);
    }
  }, {
    key: 'addTreatment',
    value: function addTreatment(pid) {
      return this.$http.post('/api/patients/' + pid + '/treatments', {});
    }
  }, {
    key: 'updateTreatment',
    value: function updateTreatment(treatment) {
      return this.$http.put('/api/treatments/' + treatment.uuid, treatment);
    }
  }, {
    key: 'requestTreatmentForm',
    value: function requestTreatmentForm(uuid, model) {
      return this.$http.post('/api/treatments/' + uuid + '/actions', model);
    }
  }, {
    key: 'getTreatmentForm',
    value: function getTreatmentForm(treatmentUuid, actionUuid) {
      return this.$http.get('/api/treatments/' + treatmentUuid + '/actions/' + actionUuid);
    }
  }, {
    key: 'saveTreatmentForm',
    value: function saveTreatmentForm(treatment, action, model, customModel) {
      return this.$http.put('/api/treatments/' + treatment.uuid + '/actions/' + action.uuid, {
        data: JSON.stringify(model),
        customData: JSON.stringify(customModel)
      });
    }
  }, {
    key: 'getTreatmentReport',
    value: function getTreatmentReport(uuid) {
      return this.$http.get('/api/treatments/' + uuid + '/report', { responseType: 'arraybuffer' });
    }
  }, {
    key: 'getInterventionProtocol',
    value: function getInterventionProtocol(uuid, actionUuid) {
      return this.$http.get('/api/treatments/' + uuid + '/actions/' + actionUuid + '/report', { responseType: 'arraybuffer' });
    }
  }, {
    key: 'findRecent',
    value: function findRecent() {
      var defer = this.$q.defer();

      var self = this;
      this.$http.get('/api/patients/search/findAllowedRecentPatients').then(function (data) {
        var patients = data.data;

        if (self.$rootScope.user.hasPermission("00110")) {
          var pids = data.data.map(function (patient) {
            return patient.pid;
          });
          self.getPatientData(pids).then(function (data) {
            defer.resolve(PatientsService.matchRecords(patients, data.data.pageList));
          }, function () {
            defer.reject();
          });
        } else {
          defer.resolve(patients);
        }
      }, function () {
        defer.reject();
      });

      return defer.promise;
    }
  }, {
    key: 'findTreatmentActionsByTargetLesion',
    value: function findTreatmentActionsByTargetLesion(pid, i) {
      return this.$http.get('/api/patients/' + pid + '/findTreatmentActionsByTargetLesion/' + i);
    }
  }, {
    key: 'addTreatmentDeletionRequest',
    value: function addTreatmentDeletionRequest(params) {
      return this.$http.put('/api/treatments/' + params.uuid + '/deletionrequest', params);
    }
  }, {
    key: 'addTreatmentActionDeletionRequest',
    value: function addTreatmentActionDeletionRequest(params) {
      return this.$http.put('/api/treatments/' + params.treatUuid + '/actions/' + params.actionUuid + '/deletionrequest', params);
    }
  }, {
    key: 'addPatientDeletionRequest',
    value: function addPatientDeletionRequest(params) {
      return this.$http.put('/api/patients/' + params.pid + '/deletionrequest', params);
    }
  }, {
    key: 'removeTreatmentAction',
    value: function removeTreatmentAction(treatmentUuid, actionUuid) {
      return this.$http.delete('/api/treatments/' + treatmentUuid + '/actions/' + actionUuid);
    }
  }], [{
    key: 'matchRecords',
    value: function matchRecords(mdat, idat) {
      var patients = [];

      idat.forEach(function (record) {
        mdat.forEach(function (patient) {
          if (patient.pid === record.ids[0].idString) {
            patient.vorname = record.fields.vorname;
            patient.nachname = record.fields.nachname;
            patient.geburtsname = record.fields.geburtsname;
            patient.ort = record.fields.ort;
            patient.plz = record.fields.plz;
            patient.birthdate = new Date(record.fields.geburtsjahr + "/" + record.fields.geburtsmonat + "/" + record.fields.geburtstag);

            patients.push(patient);
          }
        });
      });
      return patients;
    }
  }]);

  return PatientsService;
}();

PatientsService.$inject = ['$http', '$q', '$rootScope'];
exports.default = PatientsService;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ae0c2c0be67e52c1ac4c2aeb1dfa9241.html";

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fd668fa02f23121ff7b7a991a7c739df.html";

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ea246a09036be20ff751b903d58c9077.html";

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "abcab09dc96c8d1135b9ba92f21b1639.html";

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = "<fieldset ng-disabled=form.readonly class=\"schema-form-fieldset {{form.htmlClass}}\" ng-init=\"hide = true\"> <legend ng-class=\"{'sr-only': !showTitle() }\" ng-click=\"hide = !hide\"> <i class=fa ng-class=\"{'fa-caret-right': hide, 'fa-caret-down': !hide}\"></i> {{ form.title }} </legend> <div class=help-block ng-show=form.description ng-bind-html=form.description></div> <div class=fade-in ng-show=!hide sf-field-transclude></div> </fieldset> ";

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group schema-form-radios-inline {{form.htmlClass}}\" ng-class=\"{'has-error': form.disableErrorState !== true &&  hasError(), 'has-success': form.disableSuccessState !== true && hasSuccess()}\"> <label class=\"control-label {{form.labelHtmlClass}}\" ng-show=showTitle() sf-field-model schema-validate=form>{{form.title}} <a ng-if=form.schema.help> <i class=\"fa fa-question\" uib-popover-html=form.schema.help popover-title=Hilfe popover-trigger=\"'outsideClick'\" popover-placement=right> </i> </a> </label> <div> <label class=radio-inline ng-repeat=\"item in form.titleMap\"> <input type=radio class={{form.fieldHtmlClass}} sf-changed=form ng-disabled=form.readonly sf-field-model ng-value=item.value name=\"{{form.key.join('.')}}\"> <span ng-bind-html=item.name></span> </label> </div> <div class=help-block sf-message=form.description></div> </div> ";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PatientFormCtrl = function PatientFormCtrl($rootScope, $state, $q, $stateParams, PatientsService, Notification) {
  var ctrl = this,
      initModel = {
    gender: "MALE",
    center: $rootScope.user.center[0] ? $rootScope.user.center[0].uuid : '',
    diagnosisICD: Object.keys($rootScope.config.icdCodes)[0],
    plz: "00000",
    ort: "-",
    lostToFollowUp: false
  };

  ctrl.gender = {
    "MALE": 'männlich',
    "FEMALE": 'weiblich'
  };

  ctrl.model = initModel;

  ctrl.$onInit = function () {
    PatientsService.getAll().then(function (data) {
      ctrl.patients = data.patients;
    });

    if ($stateParams.patient) {
      ctrl.model = $stateParams.patient;
      ctrl.model.geburtstag = $stateParams.patient.birthdate.getDate();
      ctrl.model.geburtsmonat = $stateParams.patient.birthdate.getMonth() + 1;
      ctrl.model.geburtsjahr = $stateParams.patient.birthdate.getFullYear();
      ctrl.model.center = $stateParams.patient.center.uuid;
      //ctrl.model.agreementDate = new Date($stateParams.patient.agreementDate);
    }
  };

  ctrl.add = function (form) {
    if (form.$valid) {
      ctrl.model.geburtsname = ctrl.model.geburtsname || ctrl.model.nachname;
      PatientsService.save(ctrl.model).then(function () {
        ctrl.model = initModel;
        $state.go('main.patients.list');
        Notification.success('Ein neuer Patient wurde angelegt.');
      }, function () {
        Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
      });
    }
  };

  ctrl.updateBirthdate = function () {
    if (ctrl.model.birthdate) {
      ctrl.model.geburtstag = ctrl.model.birthdate.getDate();
      ctrl.model.geburtsmonat = ctrl.model.birthdate.getMonth() + 1;
      ctrl.model.geburtsjahr = ctrl.model.birthdate.getFullYear();
    }
  };

  ctrl.update = function (form) {
    if (form.$valid) {
      $q.all([PatientsService.updateIdat(ctrl.model), PatientsService.updateMdat(ctrl.model)]).then(function () {
        Notification.success('Änderungen erfolgreich gespeichert.');
      }, function () {
        Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
      });
    }
  };

  ctrl.$doCheck = function () {
    // compare form data to existing patients
    if ($rootScope.user.hasPermission("00111")) {
      ctrl.similarPatient = ctrl.testForSimilarPatientData(ctrl.patients, ctrl.model);
    }
  };

  ctrl.testForSimilarPatientData = function (data, comparable) {
    if (ctrl.model.uuid) {
      // no create, just update
      return false;
    }
    if (data) {
      for (var patient in data) {
        if (data.hasOwnProperty(patient)) {
          if (data[patient].vorname === comparable.vorname && data[patient].nachname === comparable.nachname && data[patient].birthdate.getFullYear() === comparable.geburtsjahr && data[patient].birthdate.getMonth() + 1 === comparable.geburtsmonat && data[patient].birthdate.getDate() === comparable.geburtstag) {
            return data[patient].pid;
          }
        }
      }
    }
    return false;
  };
};

PatientFormCtrl.$inject = ['$rootScope', '$state', '$q', '$stateParams', 'PatientsService', 'Notification'];

module.exports = {
  template: __webpack_require__(300),
  controller: PatientFormCtrl
};

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = "<h3>Patient {{$ctrl.model.uuid ? 'bearbeiten' : 'hinzufügen'}}</h3> <form class=form name=form novalidate> <div class=row> <fieldset class=col-md-6> <legend>Persönliche Daten</legend> <div class=row> <div class=\"form-group col-sm-4\" ng-class=\"{ 'has-error' : form.prename.$invalid && form.$submitted}\"> <label>Vorname *</label> <input type=text class=form-control name=prename ng-model=$ctrl.model.vorname required=required ng-pattern=\"/^[A-Za-zäÄöÖüÜß\\.\\-\\'\\s]*[A-Za-zäÄöÖüÜß]+[A-Za-zäÄöÖüÜß\\.\\-\\'\\s]*$/\"> <p ng-show=\"form.prename.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.prename.$error.pattern && form.$submitted\" class=help-block>Unzulässige Zeichen vorhanden.</p> </div> <div class=\"form-group col-sm-4\" ng-class=\"{ 'has-error' : form.surname.$invalid && form.$submitted}\"> <label>Nachname *</label> <input type=text class=form-control name=surname ng-model=$ctrl.model.nachname required=required ng-pattern=\"/^[A-Za-zäÄöÖüÜß\\.\\-\\'\\s]*[A-Za-zäÄöÖüÜß]+[A-Za-zäÄöÖüÜß\\.\\-\\'\\s]*$/\"> <p ng-show=\"form.surname.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.surname.$error.pattern && form.$submitted\" class=help-block>Unzulässige Zeichen vorhanden.</p> </div> <div class=\"form-group col-sm-4\" ng-class=\"{ 'has-error' : form.birthname.$invalid && form.$submitted}\"> <label>Geburtsname</label> <input type=text class=form-control name=birthname ng-model=$ctrl.model.geburtsname ng-pattern=\"/^[A-Za-zäÄöÖüÜß\\.\\-\\'\\s]*[A-Za-zäÄöÖüÜß]+[A-Za-zäÄöÖüÜß\\.\\-\\'\\s]*$/\"> <p ng-show=\"form.birthname.$error.pattern && form.$submitted\" class=help-block>Unzulässige Zeichen vorhanden.</p> </div> </div> <div class=row> <div class=\"form-group col-sm-4\" ng-class=\"{ 'has-error' : form.birthdate.$invalid && form.$submitted}\"> <label>Geburtsdatum *</label> <emil-datepicker form-field=$ctrl.model.birthdate required=true field-name=\"'birthdate'\" on-change=$ctrl.updateBirthdate()></emil-datepicker> <p ng-show=\"form.birthdate.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.birthdate.$error.date && form.$submitted\" class=help-block>Datumsformat (yyyy-mm-dd) nicht korrekt.</p> </div> <div class=\"form-group col-sm-4\" ng-class=\"{ 'has-error' : form.gender.$invalid && form.$submitted}\"> <label>Geschlecht *</label> <select class=form-control name=gender ng-model=$ctrl.model.gender ng-options=\"k as v for (k,v) in $ctrl.gender\"> </select> <p ng-show=\"form.gender.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> </div> <div class=row> <div class=\"form-group col-sm-4\" ng-class=\"{ 'has-error' : form.insurance.$invalid && form.$submitted}\"> <label>Krankenversicherung</label> <label class=radio-inline><input type=radio name=insurance ng-model=$ctrl.model.insurance value=GKV> gesetzlich/allgemein</label> <label class=radio-inline><input type=radio name=insurance ng-model=$ctrl.model.insurance value=PKV> privat/zusatzversichert</label> <p ng-show=\"form.insurance.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> </div> </fieldset> <fieldset class=col-md-6> <legend>Anschrift</legend> <div class=row> <div class=\"form-group col-sm-4\" ng-class=\"{ 'has-error' : form.zip.$invalid && form.$submitted}\"> <label>Postleitzahl *</label> <input type=text class=form-control name=zip ng-model=$ctrl.model.plz required=required ng-pattern=/^[0-9]+$/ > <p ng-show=\"form.zip.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.zip.$error.pattern && form.$submitted\" class=help-block>Unzulässige Zeichen vorhanden.</p> </div> <div class=\"form-group col-sm-8\" ng-class=\"{ 'has-error' : form.city.$invalid && form.$submitted}\"> <label>Ort *</label> <input type=text class=form-control name=city ng-model=$ctrl.model.ort required=required ng-pattern=/^[^\\d]+$/ > <p ng-show=\"form.city.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.city.$error.pattern && form.$submitted\" class=help-block>Unzulässige Zeichen vorhanden.</p> </div> </div> </fieldset> </div> <fieldset> <legend>Aufnahmedaten</legend> <div class=row> <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : form.diagnosisICD.$invalid && form.$submitted}\"> <label>ICD-Code der Einschlussdiagnose *</label> <select ng-options=\"k as v for (k,v) in $root.config.icdCodes\" class=form-control name=diagnosisICD ng-model=$ctrl.model.diagnosisICD required=required></select> <p ng-show=\"form.diagnosisICD.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : form.center.$invalid && form.$submitted}\"> <label>Zentrum *</label> <select class=form-control name=center ng-model=$ctrl.model.center ng-options=\"item.uuid as item.name for item in $root.user.center\" required=required> </select> <p ng-show=\"form.center.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> </div> <div class=row> <div class=\"form-group col-sm-4 col-md-2\" ng-class=\"{ 'has-error' : form.lostToFollowUp.$invalid && form.$submitted}\"> <label>Studienabbruch *</label> <p><input type=checkbox ng-model=$ctrl.model.lostToFollowUp></p> </div> </div> <div class=row> <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : form.diagnosis.$invalid && form.$submitted}\"> <label>Kommentar</label> <input type=text class=form-control name=diagnosis ng-model=$ctrl.model.diagnosis maxlength=255> <p ng-show=\"form.diagnosis.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> </div> </fieldset> <div class=\"alert alert-warning\" role=alert ng-if=$ctrl.similarPatient> <i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i> Es existiert bereits ein Patient mit ähnlichen Stammdaten (<a ui-sref=\"main.patients.list.details({pid: $ctrl.similarPatient})\">PID {{$ctrl.similarPatient}}</a>). Sind sie sicher, dass sie einen neuen Patienten anlegen möchten? </div> <button class=\"btn btn-primary\" ng-click=\"$ctrl.model.uuid ? $ctrl.update(form) : $ctrl.add(form)\">Speichern</button> <button class=\"btn btn-discard\" ui-sref=main.patients.list>Verwerfen</button> <p><strong>* Plichtfeld</strong></p> </form> ";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TreatmentFormCtrl = function TreatmentFormCtrl($rootScope, $state, $stateParams, $q, PatientsService, Notification, CRUDService, config, $timeout, $compile, $scope) {
  var ctrl = this,
      crossCheckMedicationDiabetesInfoPupulated = 0,
      actionId = $stateParams.actionId,
      treatId = $stateParams.treatId;

  ctrl.pid = $stateParams.pid;
  ctrl.schema = $stateParams.schema || {};
  ctrl.patient = $stateParams.patient;
  ctrl.treatment = $stateParams.treatment;
  ctrl.action = $stateParams.action;
  ctrl.change = $stateParams.change;

  ctrl.regions = ["Aorta", "Iliakal", "femoral", "popliteal", "below-the-knee", "obere Extremität"];

  // model for custom data on the main form view
  ctrl.formmodel = {};

  // global form options for angular-schema-form
  ctrl.formOptions = {
    validationMessage: {
      '0': 'Fehlerhaftes Feld.',
      '101': 'Der angegebene Wert ist niedriger als {{schema.minimum}}.',
      '103': 'Der angegebene Wert ist größer als {{schema.maximum}}.',
      '105': 'Der angegebene Wert ist keine Zahl.',
      '302': 'Nicht ausgefülltes Pflichtfeld.',
      '400': 'Die Anzahl der gewählten Einträge unterschreitet die Mindestanzahl {{schema.minItems}}.',
      '401': 'Die Anzahl der gewählten Einträge überschreitet die Maximalanzahl {{schema.maxItems}}.',
      'number': 'Der angegebene Wert ist keine Zahl.',
      'default': 'Das Feld ist nicht korrekt ausgefüllt.',
      'entlassungsError': 'Das angegebene Entlassungsdatum liegt vor dem Aufnahmedatum.',
      'diabetesMedicationError': 'Im Risikoprofil wurde unter <b>Diabetes mellitus</b> der Wert <b>Nein</b> hinterlegt.',
      'claudicatioXorRuheschmerzenError': 'Es dürfen nicht gleichzeitig Claudication <b>und</b> Ruheschmerzen ausgewählt werden.'
    },
    validateOnRender: true // initially validate form
  };

  ctrl.$onInit = function () {
    ctrl.formRequest = $q.defer();
    ctrl.formLoaded = false;
    if (!ctrl.treatment || !ctrl.action) {
      // no objects passed - retrieve them from server
      PatientsService.findByPid($stateParams.pid).then(function (data) {
        ctrl.patient = data;
        var treatments = ctrl.patient.treatments;
        // get selected treatment
        for (var i in treatments) {
          if (treatments[i].uuid === treatId) {
            ctrl.treatment = treatments[i];

            // get selected treatment action
            for (var j in treatments[i].actions) {
              if (treatments[i].actions[j].uuid === actionId) {
                ctrl.action = treatments[i].actions[j];
                if (ctrl.action.data) {
                  ctrl.data = JSON.parse(ctrl.action.data);
                  ctrl.initialData = JSON.parse(ctrl.action.data);
                } else {
                  ctrl.data = {};
                }

                break;
              }
            }
            break;
          }
        }
        PatientsService.getTreatmentForm(treatId, actionId).then(function (response) {
          ctrl.schema = response.data;
        });
      });
    }

    if ($stateParams.data) {
      ctrl.data = JSON.parse($stateParams.data);
    } else {
      ctrl.data = {};
    }
  };

  ctrl.$doCheck = function () {
    // add error icons if there are any errors in the fieldset
    jQuery('#formview .has-error').parents('fieldset').map(function () {
      if (jQuery(this).find('.fa-warning').length === 0) {
        jQuery(this).find('legend').append(' <i class="fa fa-warning" style="color: #a94442;"></i>');
      }
    });

    jQuery('#formview .fa-warning').parents('fieldset').map(function () {
      if (jQuery(this).find('.has-error').length === 0) {
        jQuery(this).find(".fa-warning").remove();
      }
    });
  };

  $rootScope.$on('sf-render-finished', function () {
    $timeout(function () {

      // initially validate form
      $rootScope.$broadcast('schemaFormValidate');

      ctrl.formRequest.resolve();

      ctrl.formLoaded = true;
    }, 0);
  });

  ctrl.formChanged = function () {
    if (ctrl.action) {
      if (ctrl.action.lastModifiedAt === ctrl.action.createdAt) {
        return false;
      } else {
        return !angular.equals(ctrl.data, ctrl.initialData);
      }
    }
  };

  ctrl.validateForm = function (form) {
    $rootScope.$broadcast('schemaFormValidate');

    if (form.$valid) {
      Notification.success("Das Formular enthält keine Fehler.");
    } else {
      Notification.warning("Das Formular enthält Fehler. Die betroffenen Felder wurden entsprechend markiert.");
    }
  };

  function saveForm(form, customform) {
    if (customform.$valid) {

      $rootScope.$broadcast('schemaFormValidate');
      ctrl.formmodel.valid = form.$valid;
      ctrl.action.valid = form.$valid;

      PatientsService.saveTreatmentForm(ctrl.treatment, ctrl.action, ctrl.data, ctrl.formmodel).then(function () {
        Notification.success("Datenaufnahme wurde erfolgreich gespeichert.");
        $state.go('main.patients.list.details.treatsteps', {
          treatId: ctrl.treatment.uuid,
          treatment: ctrl.treatment,
          patient: ctrl.patient,
          pid: ctrl.patient.pid
        });
      }, function () {
        Notification.error("Datenaufnahme konnte nicht gespeichert werden.");
        $state.go('main.patients.list.details.treatsteps', {
          treatId: ctrl.treatment.uuid,
          treatment: ctrl.treatment,
          patient: ctrl.patient,
          pid: ctrl.patient.pid
        });
      });
    }
  }

  ctrl.submitForm = function (form, customform) {
    if (angular.equals(ctrl.data, ctrl.initialData)) {
      // form hasn't been touched - save it without password request
      // saving the form althought there are no changes is intended here to trigger some data update, e.g. target lesion detection
      saveForm(form, customform);
    } else if (ctrl.action.lastModifiedAt !== ctrl.action.createdAt) {
      // this is not the first edit of the form, so check the password here

      CRUDService.save({ "password": ctrl.formmodel.confirmPw + "" }, config.urls.users + '/checkPw').then(function () {
        // success response here means that the password was correct

        saveForm(form, customform);
      }, function () {
        // password was incorrect
        Notification.error('Falsches Passwort - Formular wurde nicht gespeichert.');
        ctrl.formmodel.confirmPw = "";
      });
    } else {
      // this is the first edit, so just save the form here
      saveForm(form, customform);
    }
  };

  ctrl.resetForm = function () {
    if (ctrl.action.createdAt === ctrl.action.lastModifiedAt) {
      PatientsService.removeTreatmentAction(ctrl.treatment.uuid, ctrl.action.uuid).then(function () {
        ctrl.treatment.actions = ctrl.treatment.actions.filter(function (e) {
          return e.uuid !== ctrl.action.uuid;
        });
      });
    }
    $state.go('main.patients.list.details.treatsteps', {
      treatId: ctrl.treatment.uuid,
      treatment: ctrl.treatment,
      patient: ctrl.patient,
      pid: ctrl.pid
    });
  };

  // watch specific fields to reset dependent fields
  $scope.$watch(function () {
    if (ctrl.data['zentrum']) {
      return ctrl.data['zentrum']['datum_aufnahme'] + ctrl.data['zentrum']['datum_entlassung'];
    }
  }, function (newVal, oldVal) {
    if (ctrl.data['zentrum'] && ctrl.data['zentrum']['datum_aufnahme'] && ctrl.data['zentrum']['datum_entlassung']) {
      ctrl.data['zentrum']['verweildauer'] = ctrl.calculateDateRange(ctrl.data['zentrum']['datum_aufnahme'], ctrl.data['zentrum']['datum_entlassung']);

      // check that datum_entlassung is after datum_aufnahme
      if (!(0, _moment2.default)(ctrl.data['zentrum']['datum_entlassung'], "DD.MM.YYYY").isSameOrAfter((0, _moment2.default)(ctrl.data['zentrum']['datum_aufnahme'], "DD.MM.YYYY"))) {
        $scope.$broadcast('schemaForm.error.zentrum.datum_entlassung', 'entlassungsError', false);
        ctrl.data['zentrum']['verweildauer'] = null;
      } else {
        $scope.$broadcast('schemaForm.error.zentrum.datum_entlassung', 'entlassungsError', true);
      }
    }
  });

  $scope.$watch(function () {
    if (ctrl.data['symptomatik']) {
      return ctrl.data['symptomatik']['symptome_linkes_bein'] + ctrl.data['symptomatik']['symptome_rechtes_bein'];
    }
  }, function (newVal, oldVal) {
    if (ctrl.data['symptomatik'] && ctrl.data['symptomatik']['symptome_linkes_bein']) {
      console.log(ctrl.data['symptomatik']['symptome_linkes_bein']);
      if (ctrl.data['symptomatik']['symptome_linkes_bein'].indexOf('Claudicatio') > -1 && ctrl.data['symptomatik']['symptome_linkes_bein'].indexOf('Ruheschmerzen') > -1) {
        $scope.$broadcast('schemaForm.error.symptomatik.symptome_linkes_bein', 'claudicatioXorRuheschmerzenError', false);
      } else {
        $scope.$broadcast('schemaForm.error.symptomatik.symptome_linkes_bein', 'claudicatioXorRuheschmerzenError', true);
      }
    }
    if (ctrl.data['symptomatik'] && ctrl.data['symptomatik']['symptome_rechtes_bein']) {
      if (ctrl.data['symptomatik']['symptome_rechtes_bein'].indexOf('Claudicatio') > -1 && ctrl.data['symptomatik']['symptome_rechtes_bein'].indexOf('Ruheschmerzen') > -1) {
        $scope.$broadcast('schemaForm.error.symptomatik.symptome_rechtes_bein', 'claudicatioXorRuheschmerzenError', false);
      } else {
        $scope.$broadcast('schemaForm.error.symptomatik.symptome_rechtes_bein', 'claudicatioXorRuheschmerzenError', true);
      }
    }
  });

  /**
   * print error message if no diabetes mellitus but antidiabetica medication
   * - use crossCheckMedicationDiabetesInfoPupulated to call broatcast only if necessary
   * - always return true, otherwise field is not visible
   * @param {*} diabetes 
   * @param {*} antidiabetica 
   */
  ctrl.crossCheckMedicationDiabetes = function (diabetes, antidiabetica) {
    if (diabetes === undefined && antidiabetica == undefined) {
      return true;
    }
    if (diabetes === 'Nein' && antidiabetica === 'Einnahme') {
      if (crossCheckMedicationDiabetesInfoPupulated != 2) {
        $scope.$broadcast('schemaForm.error.medikation.orales_antidiabetikum', 'diabetesMedicationError', false);
        crossCheckMedicationDiabetesInfoPupulated = 2;
      }
    } else {
      if (crossCheckMedicationDiabetesInfoPupulated != 1) {
        $scope.$broadcast('schemaForm.error.medikation.orales_antidiabetikum', 'diabetesMedicationError', true);
        crossCheckMedicationDiabetesInfoPupulated = 1;
      }
    }
    return true;
  };

  ctrl.calculateRutherford = function (symptome, schwere, laesionen) {
    var rutherford = 0;
    if (symptome && symptome.indexOf('Claudicatio') > -1) {
      if (schwere === 'Gering') {
        rutherford = 1;
      }
      if (schwere === 'Mäßig') {
        rutherford = 2;
      }
      if (schwere === 'Schwer') {
        rutherford = 3;
      }
    }
    if (symptome && symptome.indexOf('Ruheschmerzen') > -1) {
      rutherford = 4;
    }
    if (laesionen === 'Zehen' || laesionen === 'Vorfuß') {
      rutherford = 5;
    }
    if (laesionen === 'Mittelfuß' || laesionen === 'Rückfuß') {
      rutherford = 6;
    }
    return rutherford;
  };

  ctrl.calculateABI = function (rrNiedrigster, rrLinks, rrRechts) {
    var abi = -1;
    rrLinks = rrLinks || 0;
    rrRechts = rrRechts || 0;

    if (Math.abs(rrLinks - rrRechts) > 10) {
      abi = rrNiedrigster / Math.max(rrLinks, rrRechts);
    } else {
      abi = rrNiedrigster / ((rrLinks + rrRechts) / 2);
    }
    abi = roundNumber(abi, 2);

    return abi;
  };

  function roundNumber(num, scale) {
    if (("" + num).indexOf("e") === -1) {
      return +(Math.round(num + "e+" + scale) + "e-" + scale);
    } else {
      var arr = ("" + num).split("e"),
          sig = "";
      if (+arr[1] + scale > 0) {
        sig = "+";
      }
      return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
  }

  ctrl.calculateDateRange = function (date1, date2) {
    date1 = typeof date1.getMonth === 'function' ? date1 : (0, _moment2.default)(date1, "DD.MM.YYYY").toDate();
    date2 = typeof date2.getMonth === 'function' ? date2 : (0, _moment2.default)(date2, "DD.MM.YYYY").toDate();

    var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

    return date1.getTime() === date2.getTime() ? 1 : Math.round(Math.abs((date1.getTime() - date2.getTime()) / oneDay));
  };

  ctrl.syncFields = function (value, form, selector) {
    // check that given type and target type match
    if (value !== undefined && Object.prototype.toString.call(value).match(/^\[object\s(.*)\]$/)[1].toLowerCase() === form.schema.type) {
      ctrl.data[selector[0]][selector[1]] = value;
    }
  };

  $rootScope.$on('treatmentform:updateValue', function (event, params) {
    var key = params["key"].split('.');
    if (ctrl.data[key[0]]) {
      ctrl.data[key[0]][key[1]] = params["value"];
    }
  });
};

TreatmentFormCtrl.$inject = ['$rootScope', '$state', '$stateParams', '$q', 'PatientsService', 'Notification', 'CRUDService', 'config', '$timeout', '$compile', '$scope'];

module.exports = {
  template: __webpack_require__(302),
  controller: TreatmentFormCtrl
};

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = "<i class=\"fa fa-user fa-circle-thinner\" style=font-size:24px;float:left;margin-right:10px></i> <h3 style=margin-bottom:0> Formular {{$root.config.labels[$ctrl.action.schema.action]}} <span ng-if=\"$root.user.hasPermission('11001')\">für {{$ctrl.patient.pid}}</span> </h3> <span ng-if=\"$root.user.hasPermission('00111')\"> <strong>Name:</strong> {{$ctrl.patient.vorname}}, {{$ctrl.patient.nachname}} | <strong>Geburtstag:</strong> {{$ctrl.patient.birthdate|date:\"dd.MM.yyyy\"}} </span> <br/> <div style=clear:both;margin-top:30px> <strong>Behandlungsbeginn:</strong> {{$ctrl.treatment.begin|date:\"dd.MM.yyyy\"}} | <strong>Behandlungsregion:</strong> {{$root.config.labels[$ctrl.action.schema.region]}} </div> <div class=row> <target-lesions-tile ng-if=$ctrl.patient class=col-md-6 patient=$ctrl.patient></target-lesions-tile> <treatment-steps-history class=col-md-6 step=$ctrl.action></treatment-steps-history> </div> <div id=formview cg-busy=\"{promise:$ctrl.formRequest.promise,message:'Formular wird geladen.',wrapperClass:'busy-loading-transparent'}\"> <div ng-show=$ctrl.formLoaded> <form sf-schema=$ctrl.schema sf-form=$ctrl.form sf-model=$ctrl.data name=_form sf-options=$ctrl.formOptions> </form> <span class=clearfix></span> <form name=_customform> <fieldset ng-if=$ctrl.formChanged()> <legend>Bestätigung der Änderungen</legend> <div class=form-group> <label class=control-label>Grund der Änderung *</label> <select class=form-control ng-model=$ctrl.formmodel.changemsg required=required> <option>Fehler bei der Eingabe</option> <option>Fehlende Daten</option> <option>Neue Informationen</option> <option>Unbekannt</option> </select> </div> <div class=form-group> <label class=control-label>Passwort *</label> <input type=password class=form-control ng-model=$ctrl.formmodel.confirmPw required=required /> </div> </fieldset> </form> <strong>* Pflichtfeld</strong><br/><br/> <div class=form-group> <button class=\"btn btn-primary\" ng-click=\"$ctrl.submitForm(_form, _customform)\">{{_form.$valid ? 'Speichern' : 'Zwischenspeichern'}}</button> <button class=\"btn btn-validate\" ng-click=$ctrl.validateForm(_form) title=\"Prüft die gemachten Angaben ohne das Formular zu speichern.\">Validieren</button> <button class=\"btn btn-discard\" ng-click=$ctrl.resetForm()>Verwerfen</button> </div> </div> </div> ";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TreatmentStepFormCtrl = function TreatmentStepFormCtrl($state, PatientsService, config) {
  var ctrl = this;

  // model for new treatment action forms
  ctrl.model = {
    region: 'ARTERIAL'
  };

  ctrl.requestForm = function () {
    // request a new treatment action
    PatientsService.requestTreatmentForm(ctrl.treatment.uuid, ctrl.model).then(function (response) {
      var action = response.data;

      // get form schema
      PatientsService.getTreatmentForm(ctrl.treatment.uuid, response.data.uuid).then(function (response) {
        $state.go('main.patients.formview', {
          schema: response.data,
          data: action.data,
          treatment: ctrl.treatment,
          action: action,
          actionId: action.uuid,
          treatId: ctrl.treatment.uuid,
          pid: ctrl.patient.pid });
      });
    });
  };

  // get possible treatment actions
  ctrl.getTreatactions = function (treatment) {
    var data = {
      'INTERVENTION': config.labels['INTERVENTION'],
      'POSTINTERVATIONELLENACHKONTROLLE': config.labels['POSTINTERVATIONELLENACHKONTROLLE'],
      'FOLLOWUP': config.labels['FOLLOWUP']
    };

    // check if an anamnesis is already given
    for (var action in treatment.actions) {
      if (treatment.actions[action].schema.action === 'ANAMNESIS') {
        if (!ctrl.model.action) {
          ctrl.model.action = 'INTERVENTION';
        }
        return data;
      }
    }

    data.ANAMNESIS = config.labels['ANAMNESIS'];
    if (!ctrl.model.action) {
      ctrl.model.action = 'ANAMNESIS';
    }

    return data;
  };
};

TreatmentStepFormCtrl.$inject = ['$state', 'PatientsService', 'config'];

module.exports = {
  template: __webpack_require__(304),
  bindings: {
    patient: '<',
    treatment: '<'
  },
  controller: TreatmentStepFormCtrl
};

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = "<h4 class=pull-left>Behandlungsschritte</h4> <span class=clearfix></span> <form name=_form> <div class=form-group> <select class=form-control ng-model=$ctrl.model.action ng-options=\"k as v for (k,v) in $ctrl.getTreatactions($ctrl.treatment)\"> </select> </div> <button type=submit class=\"btn btn-primary\" ng-click=$ctrl.requestForm()>Formular anfordern</button> <button class=\"btn btn-discard\" ui-sref=\"main.patients.list.details.treatsteps({pid: $ctrl.patient.pid, treatment: $ctrl.treatment})\">Abbrechen</button> </form> ";

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  bindings: {
    patient: '<'
  },
  template: __webpack_require__(306),
  controller: function controller() {
    var ctrl = this;

    ctrl.gender = {
      "MALE": 'männlich',
      "FEMALE": 'weiblich'
    };
  }
};

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = "<dl class=dl-horizontal> <dt>Name</dt> <dd>{{$ctrl.patient.nachname}} {{$ctrl.patient.vorname}}</dd> <dt>Geburtstag</dt> <dd>{{$ctrl.patient.birthdate|date:\"dd.MM.yyyy\"}}</dd> <dt>Ort</dt> <dd>{{$ctrl.patient.plz}} {{$ctrl.patient.ort}}</dd> <dt>Geschlecht</dt> <dd>{{$ctrl.gender[$ctrl.patient.gender]}}</dd> <dt>Behandlungszentrum</dt> <dd>{{$ctrl.patient.center.name}} ({{$ctrl.patient.center.city}})</dd> <dt>Ersterfassung</dt> <dd>{{$ctrl.patient.entryDate|date:\"dd.MM.yyyy\"}}</dd> <dt>Krankenversicherung</dt> <dd>{{$ctrl.patient.insurance}} {{$ctrl.patient.kvNumber ? '(' + $ctrl.patient.kvNumber + ')' : ''}}</dd> <dt>Diagnose zum Einschluss</dt> <dd>{{$ctrl.patient.diagnosisICD}}</dd> <dt>Studienabbruch</dt> <dd>{{$ctrl.patient.lostToFollowUp ? 'Ja' : 'Nein'}}</dd> <dt>Kommentar</dt> <dd>{{$ctrl.patient.diagnosis}}</dd> </dl> ";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MedicationCtrl = function MedicationCtrl() {
  var ctrl = this;

  ctrl.$onInit = function () {};

  ctrl.isEmpty = function (obj) {
    for (var item in obj) {
      if (obj.hasOwnProperty(item)) {
        return false;
      }
    }
    return true;
  };
};

MedicationCtrl.$inject = [];

module.exports = {
  bindings: {
    'patient': '<'
  },
  template: __webpack_require__(308),
  controller: MedicationCtrl
};

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = "<p class=placeholder ng-if=$ctrl.isEmpty($ctrl.patient.medication)>Keine Medikation vorhanden.</p> <table class=table id=medication ng-if=!$ctrl.isEmpty($ctrl.patient.medication)> <thead> <tr> <th>Aktuell eingenommenes Medikament</th> <th>Status</th> <th>Status vom</th> </tr> </thead> <tbody> <tr ng-repeat=\"(i, item) in $ctrl.patient.medication|orderObjectBy:'lastModifiedAt':true\" ng-if=\"item.currentTaking === 'TAKING'\"> <td>{{$root.config.labels[item.name]}} <span ng-if=item.detail>: {{item.detail}}</span></td> <td>{{$root.config.labels[item.currentTaking]}}</td> <td>{{item.treatmentDate|date:\"dd.MM.yy\"}}</td> </tr> </tbody> </table>";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OpsWizardCtrl = function OpsWizardCtrl($rootScope, config) {
  var ctrl = this;

  ctrl.formDef = config.opsWizardSchema;

  ctrl.data = {};

  ctrl.$onChanges = function (foo) {};

  ctrl.submitOps = function () {
    $rootScope.$broadcast('treatmentform:updateValue', {
      "key": ctrl.codeField,
      "value": collectOpsCodes(ctrl.data) + ""
    });

    $rootScope.$broadcast('treatmentform:updateValue', {
      "key": ctrl.stringField,
      "value": collectOpsStrings(ctrl.data) + ""
    });
  }, ctrl.resetForm = function () {
    ctrl.data = {};
  };

  var collectOpsCodes = function collectOpsCodes(form) {
    var finalCodes = [];

    if (form.length === 0) {
      return "Fehler - leer";
    }
    var opsCodes = [].concat.apply([], Object.keys(form).map(function (key) {
      return form[key];
    }));

    // replace placeholders (**) with given region
    opsCodes.forEach(function (code) {
      if (code.indexOf("**", code.length - 2) !== -1 && ctrl.region && ctrl.region.length > 0) {
        var regionCode = fetchRegion(code, ctrl.region);
        if (regionCode) {
          finalCodes.push(code.replace("**", regionCode));
        }
      } else {
        finalCodes.push(code);
      }
    });

    return finalCodes;
  },
      fetchRegion = function fetchRegion(code, region) {
    var regObj = config.opsRegionen[region];
    for (var property in regObj) {
      if (regObj.hasOwnProperty(property)) {
        if (code === property) {
          return regObj[property];
        }
      }
    }
    if (regObj.hasOwnProperty('default')) {
      return regObj['default'];
    }
    return undefined;
  },
      collectOpsStrings = function collectOpsStrings(form) {
    if (form.length === 0) {
      return "Fehler - leer";
    }
    var opsCodes = [].concat.apply([], Object.keys(form).map(function (key) {
      return form[key];
    }));
    return opsCodes.map(function (code) {
      return config.opsCodes[code];
    }).join(" + ");
  };
};

OpsWizardCtrl.$inject = ['$rootScope', 'config'];

module.exports = {
  template: __webpack_require__(310),
  bindings: {
    'codeField': '<',
    'stringField': '<',
    'region': '<'
  },
  controller: OpsWizardCtrl
};

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title id=myModalLabel><i class=\"fa fa-magic\"></i> OPS-Wizard</h4> </div> <div class=modal-body> <div class=container-fluid style=padding:10px> <div class=\"alert alert-warning row\" ng-if=\"!$ctrl.region || $ctrl.region.length === 0\"> <div class=col-sm-1><i class=\"fa fa-lg fa-exclamation-triangle\"></i></div> <div class=col-sm-11>Es wurde noch keine Gefäßregion für diese Zielläsion definiert. Die OPS-Codes werden daher ggf. mit Platzhaltern (**) versehen.</div> </div> <form sf-schema=$ctrl.formDef sf-form=$ctrl.form sf-model=$ctrl.data name=_form sf-options=$ctrl.formOptions> </form> </div> </div> <div class=modal-footer> <button class=\"btn btn-default\" ng-click=$ctrl.resetForm()>Auswahl zurücksetzen</button> <button class=\"btn btn-primary\" ng-click=$ctrl.submitOps() data-dismiss=modal>OPS-Codes übernehmen</button> </div> </div> ";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OverdueTreatmentsCtrl = function OverdueTreatmentsCtrl(CRUDService, config, PatientsService, $rootScope) {
  var ctrl = this;
  ctrl.$onInit = function () {
    ctrl.request = CRUDService.getAll(config.urls.patients + '/search/findOverdueTreatments').then(function (data) {
      ctrl.warnings = data;
      if ($rootScope.user.hasPermission("00110")) {
        var pids = data.map(function (patient) {
          return patient.patient.pid;
        });
        PatientsService.getPatientData(pids, undefined, undefined, undefined, 1000).then(function (pdata) {
          pdata.data.pageList.forEach(function (record) {
            ctrl.warnings.forEach(function (patient) {
              if (patient.patient.pid === record.ids[0].idString) {
                patient.patient.vorname = record.fields.vorname;
                patient.patient.nachname = record.fields.nachname;
                patient.patient.birthdate = new Date(record.fields.geburtsjahr + "/" + record.fields.geburtsmonat + "/" + record.fields.geburtstag);
              }
            });
          });
        }, function (error) {
          console.log(error);
        });
      }
    });
  };
};

OverdueTreatmentsCtrl.$inject = ['CRUDService', 'config', 'PatientsService', '$rootScope'];

module.exports = {
  template: __webpack_require__(312),
  controller: OverdueTreatmentsCtrl
};

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "<div class=tile cg-busy=$ctrl.request> <h2><i class=\"fa fa-user fa-circle-thinner\"></i> Noch zu erledigen</h2> <p class=placeholder ng-if=\"$ctrl.warnings.length === 0\">Keine Behandlungen vorhanden.</p> <div class=scrollable-table-wrapper> <table ng-if=\"$ctrl.warnings.length > 0\" class=\"table table-striped table-hover\"> <thead> <tr> <th>{{$root.user.hasPermission('11001') ? 'PID' : 'Name, Vorname'}}</th> <th ng-if=\"$root.user.hasPermission('00110')\">Geburtsdatum</th> <th>Behandlungsbeginn</th> <th>Ursache</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.warnings\" ui-sref=\"main.patients.list.details.treatsteps({treatId: item.treatment.uuid, treatment: item.treatment, patient: item.patient, pid: item.patient.pid})\"> <td>{{$root.user.hasPermission('11001') ? item.patient.pid : item.patient.vorname+', '+item.patient.nachname}}</td> <td ng-if=\"$root.user.hasPermission('00110')\">{{item.patient.birthdate|date:\"dd.MM.yyyy\"}}</td> <td>{{item.treatment.begin|date:\"dd.MM.yyyy\"}}</td> <td>{{$root.config.labels[item.type]}} überfällig</td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PatientDetailsCtrl = function PatientDetailsCtrl($rootScope, $state) {
  var ctrl = this;

  if ($state.is('main.patients.list.details.treatsteps')) {
    ctrl.selectedTab = 3;
  }

  $rootScope.$on('emil:patientsListChanged', function () {
    // reset data
    ctrl.patient = undefined;
  });
};

PatientDetailsCtrl.$inject = ['$rootScope', '$state'];

module.exports = {
  template: __webpack_require__(314),
  require: {
    parent: '^patientList'
  },
  bindings: {
    patient: '<'
  },
  controller: PatientDetailsCtrl
};

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=$ctrl.patient id=patientDetails> <h3> <i class=\"fa fa-circle-thinner fa-user\"></i> Patientenakte {{ $root.user.hasPermission('11001') ? $ctrl.patient.pid : ''}}</h3> <uib-tabset active=$ctrl.selectedTab> <uib-tab heading=Stammdaten> <master-data patient=$ctrl.patient></master-data> </uib-tab> <uib-tab heading=Zielläsionen> <target-lesions patient=$ctrl.patient></target-lesions> </uib-tab> <uib-tab heading=Medikation> <medications patient=$ctrl.patient></medications> </uib-tab> <uib-tab heading=Behandlung> <div class=clearfix> <treatments class=col-md-6 patient=$ctrl.patient></treatments> <ui-view class=col-md-6> <h4>Behandlungsschritte</h4> <p class=placeholder>Wählen sie eine Behandlung aus.</p> </ui-view> </div> </uib-tab> </uib-tabset> </div> ";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PatientsListCtrl = function PatientsListCtrl(PatientsService, CRUDService, config, $rootScope, $state, $stateParams, Notification) {
  var ctrl = this,
      currentPage = 0,
      totalPages = void 0,
      sortKey = '';

  ctrl.gender = {
    "MALE": 'männlich',
    "FEMALE": 'weiblich'
  };

  ctrl.model = {
    search: ''
  };

  ctrl.$onInit = function () {
    ctrl.activeSearch = false;
    ctrl.model.search = '';

    ctrl.request = PatientsService.getAll(sortKey, currentPage).then(function (data) {
      ctrl.patients = data.patients;
      totalPages = data.totalPages;

      //check if there is already a patient selection
      if ($stateParams.pid) {
        //Select patient to refresh medication & target lesions
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = ctrl.patients[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var patient = _step.value;

            if (patient.pid === $stateParams.pid) {
              $state.go("main.patients.list.details.treatsteps", {
                treatId: patient.treatments[0].uuid,
                treatment: patient.treatments[0],
                patient: patient,
                pid: patient.pid
              });
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    });
  };

  ctrl.getNextPage = function () {
    if (currentPage + 1 < totalPages) {
      currentPage++;

      PatientsService.getAll(sortKey, currentPage).then(function (data) {
        ctrl.patients = ctrl.patients.concat(data.patients);
      });
    }
  };

  ctrl.hasIncompleteTreatments = function (treatments) {
    for (var treatment in treatments) {
      if (treatments.hasOwnProperty(treatment)) {
        for (var action in treatments[treatment].actions) {
          if (!treatments[treatment].actions[action].valid) {
            return true;
          }
        }
      }
    }

    return false;
  };

  ctrl.search = function (term) {
    ctrl.activeSearch = true;
    PatientsService.getAll(sortKey, currentPage, term).then(function (data) {
      ctrl.patients = data.patients;
      $rootScope.$broadcast('emil:patientsListChanged');
    });
  };

  ctrl.sort = function (key) {
    sortKey = !key ? undefined : key;
    currentPage = 0;

    PatientsService.getAll(sortKey, currentPage, ctrl.model.search).then(function (data) {
      ctrl.patients = data.patients;
    });
  };

  ctrl.requestDeletion = function (item) {
    item.popover = false;
    PatientsService.addPatientDeletionRequest({
      'pid': item.pid,
      'comment': ctrl.deleteMsg
    }).then(function () {
      Notification.success('Ihr Löschantrag wurde erfolgreich eingereicht und wird nun von dem Datentreuhänder bearbeitet.');
      ctrl.deleteMsg = undefined;
    }, function () {
      Notification.error('Beim Einreichen des Löschantrags ist ein Fehler aufgetreten.');
    });
  };
};

PatientsListCtrl.$inject = ['PatientsService', 'CRUDService', 'config', '$rootScope', '$state', '$stateParams', 'Notification'];

module.exports = {
  template: __webpack_require__(316),
  controller: PatientsListCtrl
};

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "<h2>Patientenübersicht</h2> <div class=btn-group role=group ng-if=\"$root.user.hasPermission('00110')\"> <a ui-sref=main.patients.add> <button type=button class=\"btn btn-emil\"> Patient hinzufügen <i class=\"fa fa-plus-circle\"></i> </button> </a> </div> <div class=pull-right> <form class=\"form-inline pull-left\" ng-if=\"$ctrl.patients.length > 0\"> <label>Sortierkriterien:</label> <select class=form-control ng-model=$ctrl.sortKey ng-change=$ctrl.sort($ctrl.sortKey)> <option value=\"\" selected=selected>Letzte Änderung [99-00]</option> <option value=vorname ng-if=\"$root.user.hasPermission('00111')\">Vorname [A-Z]</option> <option value=nachname ng-if=\"$root.user.hasPermission('00111')\">Nachname [A-Z]</option> <option value=geburtsjahr ng-if=\"$root.user.hasPermission('00111')\">Geburtsjahr [00-99]</option> <option value=ort ng-if=\"$root.user.hasPermission('00111')\">Ort [A-Z]</option> </select> </form> <form class=\"form-inline pull-right\" ng-submit=$ctrl.search($ctrl.model.search) style=margin-left:20px> <span id=patientSearch> <input class=form-control type=text placeholder=Suche.. ng-model=$ctrl.model.search required=required minlength=3 /> <i class=\"fa fa-close fa-circle-thinner\" ng-if=$ctrl.activeSearch ng-click=$ctrl.$onInit() title=\"Suche zurücksetzen\"></i> <button type=submit class=\"btn transparent\"> <i class=\"fa fa-search fa-circle-thinner\"></i> </button> </span> </form> </div> <div id=patientlist infinite-scroll=$ctrl.getNextPage() cg-busy=$ctrl.request> <p class=placeholder ng-if=\"$ctrl.patients.length === 0 && !$ctrl.activeSearch\">Keine Patienten vorhanden.</p> <div ng-if=\"$ctrl.patients.length === 0 && $ctrl.activeSearch\" class=placeholder> <p>Keine Patienten gefunden.</p> <button type=button class=\"btn btn-emil\" ng-click=$ctrl.$onInit()>Suche zurücksetzen</button> </div> <table ng-if=\"$ctrl.patients.length > 0\" class=\"table table-striped table-hover\"> <thead> <tr> <th></th> <th ng-if=\"$root.user.hasPermission('11001')\">PID</th> <th ng-if=\"$root.user.hasPermission('00111')\">Vorname</th> <th ng-if=\"$root.user.hasPermission('00111')\">Nachname</th> <th ng-if=\"$root.user.hasPermission('00111')\">Geburtsdatum</th> <th ng-if=\"$root.user.hasPermission('00111')\">Ort</th> <th>Geschlecht</th> <th>Studienabbruch</th> <th ng-if=\"$root.user.hasPermission('10001')\">Zentrum</th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.patients\" ui-sref=\"main.patients.list.details.treatsteps({treatId: item.treatments[0].uuid, treatment: item.treatments[0], patient: item, pid: item.pid})\" ui-sref-active=\"{'active': 'main.patients.list.details({pid: item.pid})'}\"> <td style=width:30px title=\"Patient besitzt unvollständige Behandlungsschritte.\"> <span ng-if=$ctrl.hasIncompleteTreatments(item.treatments) class=\"fa fa-exclamation-triangle\"></span> </td> <td ng-if=\"$root.user.hasPermission('11001')\">{{ item.pid }}</td> <td ng-if=\"$root.user.hasPermission('00111')\">{{item.vorname}}</td> <td ng-if=\"$root.user.hasPermission('00111')\">{{item.nachname}}</td> <td ng-if=\"$root.user.hasPermission('00111')\">{{item.birthdate|date:\"dd.MM.yyyy\"}}</td> <td ng-if=\"$root.user.hasPermission('00111')\">{{item.ort}}</td> <td>{{$ctrl.gender[item.gender]}}</td> <td>{{item.lostToFollowUp ? 'Ja' : 'Nein'}}</td> <td ng-if=\"$root.user.hasPermission('10001')\">{{item.center.name}} ({{item.center.city}})</td> <td> <a ui-sref=\"main.patients.edit({pid: item.pid, patient: item})\" ng-click=$event.stopPropagation() ng-if=\"$root.user.hasPermission('00111')\" style=cursor:pointer> <span title=\"Patient bearbeiten\"> <i class=\"fa fa-pencil fa-circle-thinner\"></i> </span> </a> <script type=text/ng-template id=deletionPopover> <form name=\"deleteUserRequestForm\">\n              <div class=\"form-group\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.deleteMsg\" required placeholder=\"Bemerkung\" />\n              </div>\n              <button class=\"btn btn-danger\" style=\"width: 100%;\" ng-disabled=\"deleteUserRequestForm.$invalid\" ng-click=\"$ctrl.requestDeletion(item)\">Löschantrag stellen</button>\n            </form> </script> <a ng-if=\"$root.user.hasPermission('11110')\" uib-popover-template=\"'deletionPopover'\" popover-title=\"Patient {{item.pid}}\" popover-placement=left popover-trigger=\"'outsideClick click'\" popover-is-open=item.popover style=cursor:pointer> <span title=\"Löschantrag stellen\"> <i class=\"fa fa-trash fa-circle-thinner\"></i> </span> </a> </td> </tr> </tbody> </table> </div> <ui-view> </ui-view>";

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RecentPatientsCtrl = function RecentPatientsCtrl(PatientsService) {
  var ctrl = this;

  ctrl.$onInit = function () {
    ctrl.request = PatientsService.findRecent().then(function (data) {
      ctrl.recentPatients = data;
    });
  };
};

RecentPatientsCtrl.$inject = ['PatientsService'];

module.exports = {
  template: __webpack_require__(318),
  controller: RecentPatientsCtrl
};

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "<div class=tile cg-busy=$ctrl.request> <h2><i class=\"fa fa-user fa-circle-thinner\"></i> Aktuelle Patienten</h2> <p class=placeholder ng-if=\"$ctrl.recentPatients.length === 0\">Keine Patienten vorhanden.</p> <div class=scrollable-table-wrapper> <table ng-if=\"$ctrl.recentPatients.length > 0\" class=\"table table-striped table-hover\"> <thead> <tr> <th>PID</th> <th>Vorname</th> <th>Nachname</th> <th>Zentrum</th> <th>Studienabbruch</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.recentPatients | orderBy:'lastModifiedAt':true\" ui-sref=\"main.patients.list.details.treatsteps({treatId: item.treatments[0].uuid, treatment: item.treatments[0], patient: item, pid: item.pid})\"> <td>{{item.pid}}</td> <td>{{item.vorname}}</td> <td>{{item.nachname}}</td> <td>{{item.center.name}} ({{item.center.city}})</td> <td>{{item.lostToFollowUp ? 'Ja' : 'Nein'}}</td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  bindings: {
    patient: '<'
  },
  template: __webpack_require__(320)
};

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "<div class=tile id=targetlesions> <div class=tile-header> <h4>Zielläsionen</h4> </div> <div class=\"tile-body scrollable-table-wrapper\"> <target-lesions patient=$ctrl.patient></target-lesions> </div> </div> ";

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TargetLesionsCtrl = function TargetLesionsCtrl(PatientsService) {
  var ctrl = this;

  ctrl.$onInit = function () {
    for (var i in ctrl.patient.targetLesions) {
      if (ctrl.patient.targetLesions.hasOwnProperty(i)) {
        // get affected treatment actions for this target lesion
        (function (j) {
          PatientsService.findTreatmentActionsByTargetLesion(ctrl.patient.pid, j).then(function (data) {
            ctrl.patient.targetLesions[j].affectedActions = data.data;
          });
        })(i);
      }
    }
  };

  ctrl.isEmpty = function (obj) {
    for (var item in obj) {
      if (obj.hasOwnProperty(item)) {
        return false;
      }
    }
    return true;
  };
};

TargetLesionsCtrl.$inject = ['PatientsService'];

module.exports = {
  bindings: {
    patient: '<'
  },
  template: __webpack_require__(322),
  controller: TargetLesionsCtrl
};

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "<p class=placeholder ng-if=$ctrl.isEmpty($ctrl.patient.targetLesions)>Keine Zielläsionen vorhanden.</p> <table class=table id=targetlesions ng-if=!$ctrl.isEmpty($ctrl.patient.targetLesions)> <thead> <tr> <th>Nr.</th> <th>Gefäßregion</th> <th>Erfassungsdatum</th> <th>Eingriffe</th> </tr> </thead> <tbody> <tr ng-repeat=\"(i, item) in $ctrl.patient.targetLesions\"> <td>{{i}}</td> <td>{{item.region}}</td> <td>{{item.createdAt|date:\"dd.MM.yy\"}}</td> <td> <ul> <li ng-repeat=\"action in item.affectedActions\"> {{$root.config.labels[action.schema.action]}} - {{action.date|date:\"dd.MM.yy\"}} </li> </ul> </td> </tr> </tbody> </table> ";

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TreatmentCtrl = function TreatmentCtrl(PatientsService, $rootScope, FileSaver, Notification, $state) {
  var ctrl = this;

  /**ctrl.addTreatment = function(){
      PatientsService.addTreatment(ctrl.patient.pid).then(function(data){
        ctrl.patient.treatments = data.data.treatments;
        Notification.success('Neue Behandlung wurde erfolgreich erstellt.');
        $state.go('main.patients.list.details.treatsteps',
          {
            treatId: ctrl.patient.treatments[ctrl.patient.treatments.length - 1].uuid, 
            treatment: ctrl.patient.treatments[ctrl.patient.treatments.length -1], 
            patient: ctrl.patient, 
            pid: ctrl.patient.pid
          });
      });
    };
    **/

  ctrl.finishTreatment = function (treatment) {
    treatment.state = 'FINISHED';
    PatientsService.updateTreatment(treatment).then(function (data) {
      treatment = data.data;
      Notification.success('Behandlung wurde erfolgreich abgeschlossen.');
    });
  };

  ctrl.getReport = function (uuid) {
    PatientsService.getTreatmentReport(uuid).then(function (data) {
      var file = new Blob([data.data], { type: 'application/pdf' });
      FileSaver.saveAs(file, "Behandlungsbericht-" + ctrl.patient.pid + ".pdf");
    }, function () {
      Notification.error("Die angeforderte Datei konnte nicht abgerufen werden.");
    });
  };

  ctrl.isFinishable = function (treatment) {
    if (treatment.state === 'FINISHED') {
      return false;
    }
    if (!$rootScope.user.hasPermission('10110')) {
      return false;
    }
    if (treatment.actions.length === 0) {
      treatment.finishMsg = "Keine Behandlungsschritte vorhanden.";
      return false;
    }
    for (var action in treatment.actions) {
      if (!treatment.actions[action].valid) {
        treatment.finishMsg = "Unvollständige Behandlungsschritte vorhanden.";
        return false;
      }
    }

    return true;
  };

  ctrl.requestDeletion = function (item) {
    item.popover = false;
    PatientsService.addTreatmentDeletionRequest({
      'uuid': item.uuid,
      'comment': ctrl.deleteMsg
    }).then(function () {
      Notification.success('Ihr Löschantrag wurde erfolgreich eingereicht und wird nun von dem Datentreuhänder bearbeitet.');
      ctrl.deleteMsg = undefined;
    }, function (error) {
      if (error.status === 409) {
        Notification.info('Es wurde bereits ein Löscheintrag für diese Behandlung eingereicht.');
      } else {
        Notification.error('Beim Einreichen des Löschantrags ist ein Fehler aufgetreten.');
      }
      ctrl.deleteMsg = undefined;
    });
  };
};

TreatmentCtrl.$inject = ['PatientsService', '$rootScope', 'FileSaver', 'Notification', '$state'];

module.exports = {
  bindings: {
    patient: '='
  },
  template: __webpack_require__(324),
  controller: TreatmentCtrl
};

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "<h4 class=pull-left> Behandlung</h4> <h5 class=pull-right ng-if=\"$root.user.hasPermission('10110')\"> </h5> <span class=clearfix></span> <p class=placeholder ng-if=\"$ctrl.patient.treatments.length === 0\">Keine Behandlung vorhanden.</p> <table class=\"table table-responsive compact\" ng-if=\"$ctrl.patient.treatments.length > 0\"> <thead> <tr> <th>Behandlungsbeginn</th> <th>Erstellung</th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.patient.treatments\" ui-sref-active=\"{'active': 'main.patients.list.details.treatsteps({treatId: item.uuid})'}\"> <td ui-sref=\"main.patients.list.details.treatsteps({treatId: item.uuid, treatment: item, patient: $ctrl.patient, pid: $ctrl.patient.pid})\" title=\"{{ item.state === 'FINISHED' ? 'Abgeschlossen' : item.finishMsg ? 'Behandlung kann nicht abgeschlossen werden: ' + item.finishMsg : 'andauernde Behandlung'}}\"> <i class=fa ng-class=\"{'fa-clock-o': item.state === 'OPEN' && !item.finishMsg, 'fa-exclamation-triangle': item.state === 'OPEN' && item.finishMsg, 'fa-check': item.state === 'FINISHED'}\"></i> {{item.begin|date:\"dd.MM.yyyy\"}} </td> <td ui-sref=\"main.patients.list.details.treatsteps({treatId: item.uuid, treatment: item, patient: $ctrl.patient, pid: $ctrl.patient.pid})\" title=\"{{ item.state === 'FINISHED' ? 'Abgeschlossen' : item.finishMsg ? 'Behandlung kann nicht abgeschlossen werden: ' + item.finishMsg : 'andauernde Behandlung'}}\"> {{item.createdAt|date:\"dd.MM.yyyy\"}} </td> <td> <a ng-click=$ctrl.getReport(item.uuid)> <span title=\"Behandlungsbericht herunterladen\"> <i class=\"fa fa-file fa-circle-thinner\"></i> </span> </a> <script type=text/ng-template id=deletionPopover> <form name=\"deleteTreatmentRequestForm\">\n            <div class=\"form-group\">\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.deleteMsg\" required placeholder=\"Bemerkung\" />\n            </div>\n            <button class=\"btn btn-danger\" style=\"width: 100%;\" ng-disabled=\"deleteTreatmentRequestForm.$invalid\" ng-click=\"$ctrl.requestDeletion(item)\">Löschantrag stellen</button>\n          </form> </script> <a ng-if=\"$root.user.hasPermission('11110')\" uib-popover-template=\"'deletionPopover'\" popover-title=\"Behandlung vom {{item.begin|date:'dd.MM.yyyy'}}\" popover-placement=top popover-trigger=\"'outsideClick click'\" popover-is-open=item.popover style=cursor:pointer> <span title=\"Löschantrag stellen\"> <i class=\"fa fa-trash fa-circle-thinner\"></i> </span> </a> </td> </tr> </tbody> </table>";

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TreatmentStepsCtrl = function TreatmentStepsCtrl($state, PatientsService, FileSaver, Notification) {
  var ctrl = this;

  ctrl.addTreatmentStep = function () {
    if (!ctrl.treatment) {
      PatientsService.addTreatment(ctrl.patient.pid).then(function (data) {
        ctrl.patient.treatments = data.data.treatments;
        ctrl.treatment = ctrl.patient.treatments[ctrl.patient.treatments.length - 1];
        $state.go('main.patients.list.details.treatform', { patient: ctrl.patient, treatment: ctrl.treatment });
      });
    } else {
      $state.go('main.patients.list.details.treatform', { patient: ctrl.patient, treatment: ctrl.treatment });
    }
  };

  ctrl.editForm = function (patient, treatment, action) {
    PatientsService.getTreatmentForm(treatment.uuid, action.uuid).then(function (response) {
      $state.go('main.patients.formview', {
        schema: response.data,
        data: action.data,
        treatment: treatment,
        action: action,
        actionId: action.uuid,
        treatId: treatment.uuid,
        patient: patient,
        pid: patient.pid });
    });
  };

  ctrl.getInterventionProtocol = function (treatUuid, actionUuid) {
    PatientsService.getInterventionProtocol(treatUuid, actionUuid).then(function (data) {
      var file = new Blob([data.data], { type: 'application/pdf' });
      FileSaver.saveAs(file, "Interventionsprotokoll-" + ctrl.patient.pid + ".pdf");
    }, function () {
      Notification.error("Die angeforderte Datei konnte nicht abgerufen werden.");
    });
  };

  ctrl.requestDeletion = function (item) {
    item.popover = false;
    console.info("foo");
    PatientsService.addTreatmentActionDeletionRequest({
      'treatUuid': ctrl.treatment.uuid,
      'actionUuid': item.uuid,
      'comment': ctrl.deleteMsg
    }).then(function () {
      Notification.success('Ihr Löschantrag wurde erfolgreich eingereicht und wird nun von dem Datentreuhänder bearbeitet.');
      ctrl.deleteMsg = undefined;
    }, function (error) {
      if (error.status === 409) {
        Notification.info('Es wurde bereits ein Löscheintrag für diesen Behandlungsschritt eingereicht.');
      } else {
        Notification.error('Beim Einreichen des Löschantrags ist ein Fehler aufgetreten.');
      }
      ctrl.deleteMsg = undefined;
    });
  };
};

TreatmentStepsCtrl.$inject = ['$state', 'PatientsService', 'FileSaver', 'Notification'];

module.exports = {
  template: __webpack_require__(326),
  bindings: {
    patient: '<',
    treatment: '<'
  },
  controller: TreatmentStepsCtrl
};

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = "<h4 class=pull-left>Behandlungsschritte</h4> <h5 class=pull-right> <emil-button-add ng-if=\"(!$ctrl.treatment || ($ctrl.treatment && $ctrl.treatment.state !== 'FINISHED')) && $root.user.hasPermission('10110')\" ng-click=$ctrl.addTreatmentStep() title=\"Behandlungsschritt hinzufügen\"></emil-button-add> </h5> <span class=clearfix></span> <p class=placeholder ng-if=\"$ctrl.treatment.actions.length === 0\">Keine Behandlungsschritte vorhanden.</p> <p class=placeholder ng-if=!$ctrl.treatment>Wählen sie eine Behandlung aus.</p> <table class=\"table table-responsive compact\" ng-if=\"$ctrl.treatment.actions.length > 0\"> <thead> <tr> <th>Datum</th> <th>Schritt</th> <th>Region</th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.treatment.actions\"> <td title=\"{{ item.valid ? 'Vollständig' : 'Unvollständig' }}\"> <i class=fa ng-class=\"{'fa-exclamation-triangle': !item.valid, 'fa-check': item.valid}\"></i> {{item.date|date:\"dd.MM.yyyy\"}} </td> <td>{{$root.config.labels[item.schema.action]}}</td> <td>{{$root.config.labels[item.schema.region]}}</td> <td> <a ng-click=\"$ctrl.editForm($ctrl.patient, $ctrl.treatment, item)\" ng-if=\"$root.user.hasPermission('11110')\"> <i class=\"fa fa-pencil fa-circle-thinner\"></i> </a> <a ng-click=\"$ctrl.getInterventionProtocol($ctrl.treatment.uuid, item.uuid)\"> <span title=\"Interventionsprotokoll herunterladen\"> <i class=\"fa fa-file fa-circle-thinner\"></i> </span> </a> <script type=text/ng-template id=deletionPopover> <form name=\"deleteTreatmentActionRequestForm\">\n              <div class=\"form-group\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.deleteMsg\" required placeholder=\"Bemerkung\" />\n              </div>\n              <button class=\"btn btn-danger\" style=\"width: 100%;\" ng-disabled=\"deleteTreatmentActionRequestForm.$invalid\" ng-click=\"$ctrl.requestDeletion(item)\">Löschantrag stellen</button>\n            </form> </script> <a ng-if=\"$root.user.hasPermission('11110')\" uib-popover-template=\"'deletionPopover'\" popover-title=\"Behandlungsschritt {{item.pid}}\" popover-placement=left popover-trigger=\"'outsideClick click'\" popover-is-open=item.popover style=cursor:pointer> <span title=\"Löschantrag stellen\"> <i class=\"fa fa-trash fa-circle-thinner\"></i> </span> </a> </td> </tr> </tbody> </table> ";

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  bindings: {
    change: '<'
  },
  template: __webpack_require__(328)
};

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = "<strong>Änderung vom {{$ctrl.change.date|date:\"dd.MM.yyyy\"}}</strong> <table class=\"table table-responsive\"> <thead> <tr> <th>Item</th> <th>alter Wert</th> <th>neuer Wert</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.change.changes\"> <td>{{item.fieldName}}</td> <td>{{item.oldValue}}</td> <td>{{item.newValue}}</td> </tr> </tbody> </table> <button class=\"btn btn-discard\" ui-sref=^> Zurück </button> ";

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  bindings: {
    step: '='
  },
  template: __webpack_require__(330)
};

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = "<div class=tile> <div class=tile-header> <h4>Änderungshistorie</h4> </div> <div class=\"tile-body scrollable-table-wrapper\"> <ui-view> <div> <p class=placeholder ng-if=\"$ctrl.step.historyItems.length === 0\">Keine Änderungen vorhanden.</p> <table class=\"table table-responsive compact\" ng-if=\"$ctrl.step.historyItems.length > 0\"> <thead> <tr> <th>Datum</th> <th>Nutzer</th> <th>Grund</th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.step.historyItems.slice().reverse()\"> <td>{{item.date|date:\"dd.MM.yyyy\"}}</td> <td>{{item.editor.username}}</td> <td>{{item.message}}</td> <td> <a ui-sref=\"main.patients.formview.changes({change: item})\"> <i class=\"fa fa-random fa-circle-thinner\" title=\"Änderungen anzeigen\"></i> </a> </td> </tr> </tbody> </table> </div> </ui-view> </div> </div> ";

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    restrict: 'A',
    scope: {
      calculate: "=",
      calculateTrigger: "@"
    },
    require: '^ngModel',
    link: function link(scope, elem, attr, ngModel) {
      scope.$watch(function () {
        return scope.$parent.$parent.$parent.$parent.$parent.model;
      }, function () {
        angular.element(document.getElementById(scope.calculateTrigger)).bind('click', function () {
          // ouch
          var result = scope.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$eval(scope.calculate);
          if (isNaN(result)) {
            result = scope.$parent.$parent.$parent.$parent.$parent.$parent.$eval(scope.calculate);
          }

          // calculate the factor for the decimal precision
          var factor = 100;
          if (attr['step']) {
            factor = 1 / parseFloat(attr['step']);
          }

          result = Math.round(result * factor) / factor;
          elem.val(result);
          ngModel.$setViewValue(result);
        });
      }, true);
    }
  };
};

/***/ }),
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */
/***/ (function(module, exports) {

module.exports = "<div class=row id=home> <div class=col-md-12> <div class=row ng-if=!user> <img src=/images/banner.png id=banner class=col-sm-12 /> <login id=login></login> </div> <div class=row> <overdue-treatments ng-if=user></overdue-treatments> </div> <div class=row> <news class=col-md-12></news> </div> </div> </div> ";

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = "<h3>Downloads</h3> <p> Keine Downloads vorhanden. </p> ";

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = {"name":"gfl-register-mdat","version":"1.8.2","private":true,"dependencies":{"@cgross/angular-busy":"^4.1.4","@uirouter/angularjs":"^1.0.13","angular":"1.6.8","angular-animate":"1.6.8","angular-bootstrap-datetimepicker":"^1.1.4","angular-chart.js":"^1.1.1","angular-date-time-input":"^1.2.1","angular-file-saver":"^1.1.3","angular-http-auth-interceptor":"github:jarnix/angular-http-auth-interceptor","angular-route":"1.6.8","angular-sanitize":"1.6.8","angular-schema-form":"git+https://github.com/Deklin/angular-schema-form.git#0.8.14","angular-schema-form-bootstrap":"^0.2.0","angular-schema-form-datepicker":"^0.4.0","angular-ui-bootstrap":"^2.5.6","angular-ui-notification":"^0.3.6","angular-ui-validate":"^1.2.3","bootstrap":"^3.3.7","d3":"^3.5.17","font-awesome":"^4.7.0","jquery":"^3.2.1","moment":"^2.20.1","phantomjs-prebuilt":"^2.1.16","pickadate":"^3.5.6","textangular":"^1.5.16"},"devDependencies":{"angular-mocks":"1.6.8","babel-core":"^6.26.3","babel-loader":"^7.1.4","babel-preset-es2015":"^6.24.1","copyfiles":"^1.2.0","css-loader":"^0.28.11","eslint":"^4.19.1","eslint-config-google":"^0.9.1","eslint-loader":"^1.9.0","file-loader":"^1.1.11","html-loader":"^0.5.5","html-webpack-plugin":"^2.30.1","jasmine-core":"^2.8.0","karma":"^1.7.1","karma-chrome-launcher":"^2.2.0","karma-firefox-launcher":"^1.1.0","karma-jasmine":"^1.1.2","karma-mocha-reporter":"^2.2.5","karma-phantomjs-launcher":"1.0.4","karma-webpack":"^3.0.0","less":"^2.7.3","less-loader":"^4.1.0","script-loader":"^0.7.2","style-loader":"^0.21.0","url-loader":"^0.6.2","webpack":"^3.10.0","webpack-dev-server":"^2.11.0"},"engines":{"node":">=0.10.0"},"scripts":{"copy":"copyfiles --up 4 src/main/webapp-files/docs/*.* src/main/resources/static/docs && copyfiles --up 3 src/main/webapp-files/favicon.ico src/main/resources/static","test":"./node_modules/.bin/karma start src/test/webapp/karma.conf.js","start":"./node_modules/.bin/webpack-dev-server","prebuild":"npm run test && npm run copy","build":"NODE_ENV=production ./node_modules/.bin/webpack -p"}}

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  template: '<a>' + '  <i class="fa fa-plus fa-circle-thinner"></i>' + '</a>'
};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  template: '<a>' + '  <i class="fa fa-trash fa-circle-thinner"></i>' + '</a>'
};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  template: '<a>' + '  <i class="fa fa-pencil fa-circle-thinner"></i>' + '</a>'
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  bindings: {
    formField: '=',
    required: '<',
    fieldName: '<',
    dateType: '<',
    onChange: '&'
  },
  template: '    <div class="input-group">' + '      <input type="text" class="form-control" name="{{$ctrl.fieldName}}" ng-model="$ctrl.formField" ' + '             ng-required="{{$ctrl.required}}" placeholder="T.M.JJJJ" date-time-input="D.M.YYYY" ' + '             data-model-type="{{$ctrl.dateType}}" ng-change="{{$ctrl.onChangeCb()}}">' + '      <span class="input-group-addon transparent">' + '        <a role="button" data-toggle="modal" data-target="{{\'#dropdown-\' + $ctrl.fieldName}}">' + '          <i class="fa fa-calendar fa-circle-thinner"></i>' + '        </a>' + '      </span>' + '    </div>' + '  <div class="modal fade" ng-attr-id="{{\'dropdown-\' + $ctrl.fieldName}}"" tabindex="-1" role="dialog">' + '    <div class="modal-dialog datepicker" role="document">' + '      <div class="modal-content"><div class="modal-body">' + '        <datetimepicker ng-model="$ctrl.formField" ' + '                        datetimepicker-config="$ctrl.pickerConfig"></datetimepicker>' + '<button type="button" class="btn btn-discard" ng-click="$ctrl.onSubmit()" data-dismiss="modal">Übernehmen</button>' + '<button type="button" class="btn btn-primary" ng-click="$ctrl.selectToday()" data-dismiss="modal">Heute</button>' + '</div></div></div></div>',
  controller: function controller() {
    var ctrl = this;

    ctrl.$onInit = function () {
      ctrl.dateType = ctrl.dateType || 'Date';

      ctrl.pickerConfig = {
        minView: 'day',
        modelType: ctrl.dateType
      };
    };

    ctrl.onChangeCb = function () {
      ctrl.onChange();
    };

    ctrl.selectToday = function () {
      var now = (0, _moment2.default)();
      ctrl.formField = ctrl.dateType === 'Date' ? now.toDate() : now.format('DD.MM.YYYY');
    };
  }
};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  bindings: {
    formField: '=',
    required: '<',
    fieldName: '<',
    maxlength: '<'
  },
  template: '<text-angular ng-model="$ctrl.formField" editor-maxlength="{{$ctrl.maxlength}}" name="{{$ctrl.fieldName}}" ng-required="{{$ctrl.required}}" ta-text-editor-class="form-control editor-height" ta-html-editor-class="form-control editor-height"></text-angular>' + '<small ng-if="$ctrl.formField.length <= $ctrl.maxlength">{{$ctrl.formField.length}}/{{$ctrl.maxlength}} Zeichen (inkl. Formatierungen)</small>'
};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  template: __webpack_require__(354)
};

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports = "<div class=header> <div class=\"navbar navbar-default navbar-inverse navbar-subheader\" role=navigation> <div class=container-fluid> <div class=navbar-header> <button ng-if=$root.user type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#bs-example-navbar-collapse-1 aria-expanded=false> <span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span> </button> <a class=navbar-brand href=#/ ><img src=/images/swisspower-logo.small.png /></a> </div> <div ng-if=$root.user class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-1> <ul class=\"nav navbar-nav center\"> <li ui-sref-active=active> <a ui-sref=main.patients.list>Patientenübersicht</a> </li> <li ui-sref-active=active> <a class=dropdown-toggle data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false>Verwaltung</a> <ul class=dropdown-menu> <li><a ui-sref=main.settings.profile>Profil</a></li> <li ng-if=\"$root.user.hasPermission('10000')\"><a ui-sref=main.settings.news>Neuigkeiten</a></li> <li ng-if=\"$root.user.hasPermission('10000')\"><a ui-sref=main.settings.user>Benutzer</a></li> <li ng-if=\"$root.user.hasPermission('10000')\"><a ui-sref=main.settings.center>Zentren</a></li> <li ng-if=\"$root.user.hasPermission('10000')\"><a ui-sref=main.settings.network>Zentrumsverbunde</a></li> <li ng-if=\"$root.user.hasPermission('10000')\"><a ui-sref=main.settings.protocol>Nutzungsprotokoll</a></li> <li ng-if=\"$root.user.hasPermission('11111')\"><a ui-sref=main.settings.deletionrequests>Löschanträge</a></li> <li ng-if=\"$root.user.hasPermission('10000')\"><a ui-sref=main.settings.options>Einstellungen</a></li> <li ng-if=\"$root.user.hasPermission('01101')\"><a ui-sref=main.settings.export>Export</a></li> </ul> </li> </ul> <ul class=\"nav navbar-nav pull-right\" style=padding-top:15px ng-if=$root.user> <script type=text/ng-template id=userPopover> <div id=\"user-popover\">\n              <dl class=\"dl-horizontal\">\n                <dt>Zentren:</dt><dd>\n                  <ul>\n                    <li ng-repeat=\"c in $root.user.center\">\n                      {{c.name}}\n                    </li>\n                  </ul>\n                </dd>\n                <dt>Nachrichten:</dt><dd> {{$root.user.messages}} <a class=\"pull-right\" ui-sref=\"main.messages\">Zum Posteingang</a></dd>\n              </dl>\n            </div> </script> <li style=margin-right:20px> <span class=badge ng-if=$root.user.messages> {{$root.user.messages}}</span> <span uib-popover-template=\"'userPopover'\" popover-title={{$root.user.username}} popover-placement=bottom popover-trigger=\"'outsideClick'\" style=cursor:pointer> <i class=\"fa fa-user\" style=font-size:1.5em></i> {{$root.user.username}} </span> </li> <li class=logout> <logout></logout> <session-timeout ng-if=!$root.user.remember></session-timeout> </li> </ul> </div> </div> </div> </div> ";

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  template: __webpack_require__(356)
};

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports = "<div class=\"navbar-fixed-bottom footer\"> <span class=navbar-brand> <span class=poweredby>powered by</span><a href=https://www.gesundheitsforen.net><img src=/images/gfl-logo.small.png style=width:250px /></a> </span> <span class=versioninfo> <span>v{{$root.config.version}}</span> </span> <ul class=\"nav navbar-nav\"> <li><a ui-sref=main.downloads>Downloads</a></li> <li><a ui-sref=main.impressum>Impressum</a></li> <li ng-if=$root.user><a ui-sref=main.contact>Kontakt</a></li> </ul> </div> ";

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LoginCtrl = function LoginCtrl(AuthService, Notification) {
  var ctrl = this;

  ctrl.$onInit = function () {
    ctrl.model = {
      username: '',
      password: '',
      remember: false
    };
  };

  ctrl.login = function (form) {
    if (form.$valid) {
      AuthService.login(ctrl.model.username, ctrl.model.password, ctrl.model.remember).then(function () {
        //Notification.success('Sie wurden erfolgreich am System angemeldet.');
      }, function (response) {
        if (response.status === 401) {
          Notification.error('Die Anmeldung konnte nicht durchgeführt werden. Die angegebenen Daten waren nicht korrekt.');
        } else {
          Notification.error('Die Anmeldung konnte nicht durchgeführt werden: <br/>&quot;<samp>' + response.data.details + '</samp>&quot;');
        }
        ctrl.model.password = "";
      });
    }
  };
};
LoginCtrl.$inject = ['AuthService', 'Notification'];

module.exports = {
  template: __webpack_require__(358),
  controller: LoginCtrl
};

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports = "<h2>Login</h2> <form class=form name=loginform> <div class=form-group> <div class=input-group> <div class=\"input-group-addon transparent\"><i class=\"fa fa-lg fa-user fa-circle-thinner\"></i></div> <input type=text ng-model=$ctrl.model.username class=form-control required=required placeholder=Benutzername /> </div> </div> <div class=form-group> <div class=input-group> <div class=\"input-group-addon transparent\"><i class=\"fa fa-lg fa-lock fa-circle-thinner\"></i></div> <input type=password ng-model=$ctrl.model.password class=form-control required=required placeholder=Passwort /> </div> </div> <div class=checkbox> <input type=checkbox id=remember ng-model=$ctrl.model.remember /> <label for=remember> Anmeldedaten speichern</label> </div> <button type=submit ng-click=$ctrl.login(loginform) class=\"form-control btn btn-primary\">Anmelden</button> </form> ";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LogoutCtrl = ['$state', 'AuthService', 'Notification', function ($state, AuthService, Notification) {
  var ctrl = this;

  ctrl.logout = function () {
    AuthService.logout().then(function () {
      Notification.success('Sie wurden erfolgreich abgemeldet.');
      $state.go('main.home');
    }, function () {});
  };
}];

module.exports = {
  template: '<a ng-click="$ctrl.logout()" title="Abmelden"><i class="fa fa-power-off"></i></a>',
  controller: LogoutCtrl
};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ContactCtrl = function ContactCtrl(CRUDService, Notification, config, $state) {
  var ctrl = this;

  ctrl.model = {
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    username: ""
  };

  ctrl.$onInit = function () {
    // get contact settings
    CRUDService.getAll(config.urls.settings).then(function (data) {
      ctrl.subjects = data.mailSubjects;
    });
  };

  ctrl.submit = function (form) {
    console.info(ctrl.model);
    if (form.$valid) {
      CRUDService.save(ctrl.model, config.urls.contact).then(function () {
        Notification.success('Ihre Nachricht wurde erfolgreich versendet.');
        $state.go('main.home');
      }, function () {
        Notification.error('Fehler beim Versenden der Nachricht.');
      });
    }
  };
};

ContactCtrl.$inject = ['CRUDService', 'Notification', 'config', '$state'];

module.exports = {
  template: __webpack_require__(361),
  controller: ContactCtrl
};

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = "<h3>Kontaktanfrage</h3> <form class=form name=form novalidate> <div class=form-group ng-class=\"{ 'has-error' : form.name.$invalid && form.$submitted}\"> <label>Name *</label> <input type=text name=name class=form-control ng-model=$ctrl.model.name required=required maxlength=255> <p ng-show=\"form.name.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.name.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=form-group ng-class=\"{ 'has-error' : form.mail.$invalid && form.$submitted}\"> <label>E-Mail-Adresse *</label> <input type=email name=mail class=form-control ng-model=$ctrl.model.mail required=required maxlength=255> <p ng-show=\"form.mail.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.mail.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=form-group ng-class=\"{ 'has-error' : form.phone.$invalid && form.$submitted}\"> <label>Telefonnr.</label> <input type=text name=phone class=form-control ng-model=$ctrl.model.phone maxlength=255> <p ng-show=\"form.phone.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 255 Zeichen.</p> </div> <div class=form-group ng-class=\"{ 'has-error' : form.subject.$invalid && form.$submitted}\"> <label>Betreff *</label> <select name=subject class=form-control ng-model=$ctrl.model.subject ng-options=\"s for s in $ctrl.subjects\" required=required></select> <p ng-show=\"form.subject.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> </div> <div class=form-group ng-class=\"{ 'has-error' : form.message.$invalid && form.$submitted}\"> <label>Nachricht *</label> <textarea name=message class=form-control rows=10 ng-model=$ctrl.model.message maxlength=2000 required=required></textarea> <p ng-show=\"form.message.$error.required && form.$submitted\" class=help-block>Fehlendes Pflichtfeld.</p> <p ng-show=\"form.message.$error.maxlength && form.$submitted\" class=help-block>Überschrittene Maximallänge von 2000 Zeichen.</p> </div> <button class=\"btn btn-primary\" ng-click=$ctrl.submit(form)>Senden</button> <button class=\"btn btn-discard\" ui-sref=main.home>Verwerfen</button> <p><strong>* Plichtfeld</strong></p> </form> ";

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MessageCtrl = function MessageCtrl($rootScope, CRUDService, config) {
  var ctrl = this;

  var currentPage = 0;
  var totalPages;

  ctrl.$onInit = function () {
    CRUDService.getAll(config.urls.messages, undefined, 'createdAt,desc').then(function (data) {
      ctrl.messages = data._embedded.messages;
      totalPages = data.page.totalPages;
    });
    CRUDService.getAll(config.urls.messages + '/search/count').then(function (data) {
      $rootScope.user.messages = data;
    });
  };

  ctrl.getNextPage = function () {
    if (currentPage + 1 < totalPages) {
      currentPage++;
      CRUDService.getAll(config.urls.messages, currentPage, 'createdAt,desc').then(function (data) {
        ctrl.messages = ctrl.news.concat(data._embedded.messages);
      });
    }
  };

  ctrl.remove = function (item) {
    CRUDService.remove(item._links.self.href).then(function () {
      ctrl.$onInit();
    });
  };

  ctrl.markRead = function (item) {
    item.unread = false;

    var msg = angular.copy(item);
    delete msg.sender;
    CRUDService.save(msg).then(function () {
      ctrl.$onInit();
    });
  };
};

MessageCtrl.$inject = ['$rootScope', 'CRUDService', 'config'];

module.exports = {
  template: __webpack_require__(363),
  controller: MessageCtrl
};

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = "<div class=messages> <h2> <i class=\"fa fa-envelope fa-circle-thinner\"></i> Nachrichten </h2> <p class=placeholder ng-if=\"$ctrl.messages.length === 0\">Keine Nachrichten vorhanden.</p> <table ng-if=\"$ctrl.messages.length > 0\" class=\"table table-striped table-hover\" infinite-scroll=$ctrl.getNextPage()> <thead> <tr> <th></th> <th>Absender</th> <th>Betreff</th> <th>Datum</th> <th class=actions></th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.messages\" ng-class=\"{'read': !item.unread}\" ui-sref=\"main.messages.details({message: item, uuid: item.uuid})\" ui-sref-active=\"{'active': 'main.messages.details({uuid: item.uuid})'}\"> <td> <i class=fa ng-class=\"{'fa-envelope-o': item.unread, 'fa-envelope-open-o': !item.unread}\"></i> </td> <td>{{item.sender.username}}</td> <td>{{item.subject}}</td> <td>{{item.createdAt|date:\"dd.MM.yyyy HH:mm\"}}</td> <td class=actions> <emil-button-delete confirm=\"Wollen sie die Nachricht '{{item.subject}}' wirklich löschen?\" action=$ctrl.remove(item) title=\"Nachricht löschen\"> </emil-button-delete> <a ng-if=item.unread confirm=\"Wollen sie die Nachricht '{{item.subject}}' wirklich als gelesen markieren?\" action=$ctrl.markRead(item) title=\"Nachricht als gelesen markieren.\"> <i class=\"fa fa-check fa-circle-thinner\"></i> </a> </td> </tr> </tbody> </table> <ui-view></ui-view> </div> ";

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MessageDetailsCtrl = ['$stateParams', 'CRUDService', function ($stateParams, CRUDService) {
  this.$onInit = function () {
    this.message = $stateParams.message || this.message;

    if (this.message && this.message.unread) {
      // mark message as read
      this.message.unread = false;

      var msg = angular.copy(this.message);
      delete msg.sender;
      CRUDService.save(msg);
    }
  };
}];

module.exports = {
  template: '\n  <div ng-if="$ctrl.message">\n    <dl class="dl-horizontal compact">\n      <dt>Absender:</dt>\n      <dd>{{$ctrl.message.sender.username}}</dd>\n\n      <dt>Datum:</dt>\n      <dd>{{$ctrl.message.createdAt|date:"dd.MM.yyyy HH:mm"}}</dd>\n\n      <dt>Betreff:</dt>\n      <dd>{{$ctrl.message.subject}}</dd>\n    </dl>\n    <samp style="font-size: 1.3em;" ng-bind-html="$ctrl.message.content">\n    </samp>\n  </div>',
  binding: {
    'message': '='
  },
  controller: MessageDetailsCtrl
};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var NewsController = function NewsController(CRUDService, config) {
  var ctrl = this;

  var currentPage = 0;
  var totalPages;

  ctrl.$onInit = function () {
    CRUDService.getAll(config.urls.news, undefined, 'publishDate,desc').then(function (data) {
      ctrl.news = data._embedded.news;
      totalPages = data.page.totalPages;
    });
  };

  ctrl.getNextPage = function () {
    if (currentPage + 1 < totalPages) {
      currentPage++;
      CRUDService.getAll(config.urls.news, currentPage, 'publishDate,desc').then(function (data) {
        ctrl.news = ctrl.news.concat(data._embedded.news);
      });
    }
  };

  ctrl.shorten = function (term) {
    var match = term.match(/^([\S\n]+[\s]){54}/);
    if (match) {
      return match[0];
    } else {
      return term;
    }
  };
};

NewsController.$inject = ['CRUDService', 'config'];

module.exports = {
  template: __webpack_require__(366),
  controller: NewsController
};

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = "<div class=news> <h2> <i class=\"fa fa-file-text-o fa-circle-thinner\"></i> Neuigkeiten </h2> <div class=row ng-repeat=\"item in $ctrl.news\" infinite-scroll=$ctrl.getNextPage() infinite-scroll-container=\"'document'\"> <div class=\"col-lg-1 date\"> {{item.publishDate|date:\"dd.MM.yyyy\"}} </div> <div class=col-lg-11> <div class=content ng-class=\"{'accent': !$root.user}\"> <h3>{{item.title}}</h3> <p ng-bind-html=\"!hide && item.content.length >= 300 ? $ctrl.shorten(item.content) : item.content\"></p> <a class=more ng-show=\"item.content.length >= 300\" ng-click=\"hide = !hide\">{{ hide ? 'verbergen' : 'anzeigen'}}</a> </div> </div> </div> </div> ";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  template: '<span ng-class="{\'text-danger\': $ctrl.countDown < 300}"' + '      title="Sie werden in {{ $ctrl.countDown/60 | number:0 }} Minuten automatisch vom System abgemeldet.">' + '  ({{ $ctrl.countDown/60 | number:0 }} min)' + '</span>',
  controller: ['$timeout', '$rootScope', function ($timeout, $rootScope) {
    var ctrl = this;

    // TODO get session timeout value from server
    var defaultTimeout = 3600;

    var interval, timeoutFn;

    this.countDown = defaultTimeout;

    this.$onInit = function () {
      timeoutFn = $timeout(ctrl.onTimeout, 1000);
    };

    this.$onDestroy = function () {
      $timeout.cancel(interval);
    };

    this.onTimeout = function () {
      if (ctrl.countDown >= 0) {
        ctrl.countDown--;
        timeoutFn = $timeout(ctrl.onTimeout, 1000);
      }
    };

    $rootScope.$on('http:request', function () {
      ctrl.countDown = defaultTimeout;
    });
  }]
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      element.bind('click', function () {
        var message = attrs.confirm;
        if (message && confirm(message)) {
          scope.$apply(attrs.action);
        }
      });
    }
  };
};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, elem, attrs, ctrl) {
      var max = parseInt(scope.$eval(attrs.editorMaxlength));
      if (isNaN(max)) {
        throw new Error('Max text must be an integer');
      }
      attrs.$observe('editorMaxlength', function (value) {
        max = parseInt(value);
        if (isNaN(max)) {
          throw new Error('Max text must be an integer');
        }
        if (ctrl.$dirty) {
          ctrl.$validate();
        }
      });
      ctrl.$validators.maxlength = function (viewValue) {
        return viewValue ? viewValue.length <= max : true;
      };
    }
  };
};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Use on html element which is scrollable, this will not work if the element has overflow: hidden set
 * use as infinite-scroll="CALLBACK()" to load new items and scroll-threshold="NUMERIC VALUE" as offset to bottom of element (determines the point when to load new items)
 */

module.exports = ['$timeout', function ($timeout) {
  return {
    scope: {
      infiniteScroll: '&',
      infiniteScrollContainer: '='
    },
    link: function link(scope, element, attr) {
      var lengthThreshold = attr.scrollThreshold || 50,
          timeThreshold = attr.timeThreshold || 400,
          promise = null,
          lastRemaining = 9999;
      lengthThreshold = parseInt(lengthThreshold, 10);
      timeThreshold = parseInt(timeThreshold, 10);

      var scroll = function scroll() {

        var scrollHeight = element[0].scrollHeight; // || element[0].scrollingElement.scrollHeight;
        var clientHeight = element[0].clientHeight; // || element[0].scrollingElement.clientHeight;
        var scrollTop = element[0].scrollTop; // || element[0].scrollingElement.scrollTop;
        var remaining = scrollHeight - (clientHeight + scrollTop);
        //if we have reached the threshold and we scroll down
        var condition = remaining < lengthThreshold && remaining - lastRemaining < 0;

        if (scope.infiniteScrollContainer !== undefined) {
          if (scope.infiniteScrollContainer === "document") {
            scrollTop = jQuery(document).scrollTop();
            var windowHeight = jQuery(window).height();
            var bodyHeight = jQuery(document).height() - windowHeight;
            var scrollPercentage = scrollTop / bodyHeight;

            condition = scrollPercentage > 0.8;
          } else {
            scrollHeight = element[0].scrollHeight; // || element[0].scrollingElement.scrollHeight;
            clientHeight = element[0].clientHeight; // || element[0].scrollingElement.clientHeight;
            scrollTop = element[0].scrollTop; // || element[0].scrollingElement.scrollTop;
            remaining = scrollHeight - (clientHeight + scrollTop);
            //if we have reached the threshold and we scroll down
            condition = remaining < lengthThreshold && remaining - lastRemaining < 0;
          }
        }

        if (condition) {

          //if there is already a timer running which has no expired yet we have to cancel it and restart the timer
          if (promise !== null) {
            $timeout.cancel(promise);
          }
          promise = $timeout(function () {
            scope.infiniteScroll();
            promise = null;
          }, timeThreshold);
        }
        lastRemaining = remaining;
      };

      if (scope.infiniteScrollContainer !== undefined) {
        if (scope.infiniteScrollContainer === "document") {
          element = angular.element(document);
        } else {
          element = angular.element(document).find(scope.infiniteScrollContainer);
        }
      }

      // set event listener
      element.on('scroll', scroll);

      // clean up event listener
      scope.$on('$destroy', function () {
        element.off('scroll', scroll);
      });
    }
  };
}];

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function link(scope, element, attrs, ctrl) {
      ctrl.$parsers.unshift(function (viewValue) {
        ctrl.$setValidity("passwordVerify", true);

        // check length
        if (viewValue.length < 8) {
          ctrl.$setValidity("passwordVerify", false);
        }

        // check that password contains letters and numbers
        if (!viewValue.match(".*\\d.*") || !viewValue.match(".*[a-zA-Z].*")) {
          ctrl.$setValidity("passwordVerify", false);
        }

        return viewValue;
      });
    }
  };
};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ['$interpolate', '$state', '$transitions', '$rootScope', function ($interpolate, $state, $transitions, $rootScope) {
  return {
    restrict: 'E',
    template: __webpack_require__(373),
    scope: {
      displaynameProperty: '@',
      abstractProxyProperty: '@?'
    },
    link: function link(scope) {

      scope.breadcrumbs = [];
      if ($state.$current.name !== '') {
        updateBreadcrumbsArray();
      }

      $transitions.onSuccess({}, function () {
        updateBreadcrumbsArray();
      });

      /**
       * Start with the current state and traverse up the path to build the
       * array of breadcrumbs that can be used in an ng-repeat in the template.
       */
      function updateBreadcrumbsArray() {
        var workingState,
            displayName,
            breadcrumbs = [],
            currentState = $state.$current;

        while (currentState && currentState.name !== '') {
          workingState = getWorkingState(currentState);
          if (workingState) {
            displayName = getDisplayName(workingState);

            if (displayName !== false && displayName !== '' && !stateAlreadyInBreadcrumbs(workingState, breadcrumbs)) {
              breadcrumbs.push({
                displayName: displayName,
                route: workingState.name
              });
            }
          }
          currentState = currentState.parent;
        }
        breadcrumbs.reverse();
        scope.breadcrumbs = breadcrumbs;
      }

      /**
      * Get the state to put in the breadcrumbs array, taking into account that if the current state is abstract,
      * we need to either substitute it with the state named in the `scope.abstractProxyProperty` property, or
      * set it to `false` which means this breadcrumb level will be skipped entirely.
      * @param currentState
      * @returns {*}
      */
      function getWorkingState(currentState) {
        var proxyStateName,
            workingState = currentState;
        if (currentState.abstract === true) {
          if (typeof scope.abstractProxyProperty !== 'undefined') {
            proxyStateName = getObjectValue(scope.abstractProxyProperty, currentState);
            if (proxyStateName) {
              workingState = $state.get(proxyStateName);
            } else {
              workingState = false;
            }
          } else {
            workingState = false;
          }
        }
        return workingState;
      }

      /**
       * Resolve the displayName of the specified state. Take the property specified by the `displayname-property`
       * attribute and look up the corresponding property on the state's config object. The specified string can be interpolated against any resolved
       * properties on the state config object, by using the usual {{ }} syntax.
       * @param currentState
       * @returns {*}
       */
      function getDisplayName(currentState) {
        var interpolationContext, propertyReference, displayName;

        if (!scope.displaynameProperty) {
          // if the displayname-property attribute was not specified, default to the state's name
          return currentState.name;
        }
        propertyReference = getObjectValue(scope.displaynameProperty, currentState);

        if (propertyReference === false) {
          return false;
        } else if (typeof propertyReference === 'undefined') {
          return currentState.name;
        } else {
          // use the $interpolate service to handle any bindings in the propertyReference string.
          interpolationContext = typeof currentState.locals !== 'undefined' ? currentState.locals.globals : currentState;
          displayName = $interpolate(propertyReference)(interpolationContext);
          return displayName;
        }
      }

      /**
       * Given a string of the type 'object.property.property', traverse the given context (eg the current $state object) and return the
       * value found at that path.
       *
       * @param objectPath
       * @param context
       * @returns {*}
       */
      function getObjectValue(objectPath, context) {
        var i,
            propertyArray = objectPath.split('.'),
            propertyReference = context;

        for (i = 0; i < propertyArray.length; i++) {
          if (angular.isDefined(propertyReference[propertyArray[i]])) {
            propertyReference = propertyReference[propertyArray[i]];
          } else {
            // if the specified property was not found, default to the state's name
            return undefined;
          }
        }
        return propertyReference;
      }

      /**
       * Check whether the current `state` has already appeared in the current breadcrumbs array. This check is necessary
       * when using abstract states that might specify a proxy that is already there in the breadcrumbs.
       * @param state
       * @param breadcrumbs
       * @returns {boolean}
       */
      function stateAlreadyInBreadcrumbs(state, breadcrumbs) {
        var i,
            alreadyUsed = false;
        for (i = 0; i < breadcrumbs.length; i++) {
          if (breadcrumbs[i].route === state.name) {
            alreadyUsed = true;
          }
        }
        return alreadyUsed;
      }
    }
  };
}];

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports = "<ol ng-if=$root.user class=breadcrumb> <li ng-repeat=\"crumb in breadcrumbs\" ng-class=\"{ active: $last }\"> <a ui-sref={{crumb.route}} ng-if=!$last>{{ crumb.displayName }}&nbsp;</a> <span ng-show=$last>{{ crumb.displayName }}</span> </li> </ol>";

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ['$rootScope', function ($rootScope) {

  return {
    'request': function request(_request) {

      if (_request.cache === undefined) {
        if (_request.url.indexOf('http') === -1) {
          // adjust api path
          if (window.location.host === "www2.gesundheitsforen.net") {
            _request.url = "https://www2.gesundheitsforen.net/emil-mdat" + _request.url;
          } else if (window.location.host.match(/localhost/)) {
            _request.url = "http://localhost:8080" + _request.url;
          }

          // redirect live preview to normal backend path
          //if (window.location.host === "localhost:9000"){
          //}
        }

        $rootScope.$broadcast('http:request');
      }

      return _request;
    }
  };
}];

/***/ })
]),[186]);


// WEBPACK FOOTER //
// app.cecb8dab18797020506f.js